/* eslint-disable */
// 由 scripts/gen_web_contract.py 从 PetJourneyBackend/app/schemas/web 生成，请勿手改。
// 修改契约：改 Python DTO → 运行 `npm run contract:gen` → 更新 WEB-CONTRACT 文档。

export const WEB_CONTRACT_VERSION = "0.4.5";
export const WEB_API_PREFIX = "/api/v1/web";

/** UTC ISO 8601，例如 2026-09-22T07:35:00Z */
export type IsoDateTime = string;
/** YYYY-MM-DD */
export type IsoDate = string;
/** 把有服务端默认值的字段变为可选：用于请求体。 */
export type WithOptional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

export type DataOrigin = "fixture" | "live";
export const DataOriginValues = ["fixture", "live"] as const;

export type WebErrorCode = "AUTH_REQUIRED" | "SESSION_EXPIRED" | "CSRF_FAILED" | "FORBIDDEN" | "NOT_FOUND" | "VALIDATION_FAILED" | "CONFLICT" | "VERSION_CONFLICT" | "IDEMPOTENCY_KEY_REQUIRED" | "IDEMPOTENCY_KEY_REUSED" | "IDEMPOTENCY_IN_PROGRESS" | "CAPABILITY_UNAVAILABLE" | "NOT_CONFIGURED" | "RATE_LIMITED" | "UPSTREAM_UNAVAILABLE" | "INTERNAL_ERROR" | "USERNAME_TAKEN" | "INVALID_CREDENTIALS" | "ADOPTION_TAKEN" | "PET_NOT_ACTIVATED" | "DRIVING_BLOCKS_VIDEO" | "CONTROL_LEASE_HELD" | "ITINERARY_CHANGED" | "DRAFT_EXPIRED" | "INSUFFICIENT_FUNDS" | "ALREADY_TRAVELING" | "FARM_GUARDED" | "ALREADY_HAS_COMPANION" | "MEDIA_REJECTED" | "CODE_INVALID" | "CODE_EXPIRED" | "VERIFY_REQUIRED" | "REAUTH_REQUIRED" | "CONTACT_TAKEN" | "REGISTRATION_CLOSED";
export const WebErrorCodeValues = ["AUTH_REQUIRED", "SESSION_EXPIRED", "CSRF_FAILED", "FORBIDDEN", "NOT_FOUND", "VALIDATION_FAILED", "CONFLICT", "VERSION_CONFLICT", "IDEMPOTENCY_KEY_REQUIRED", "IDEMPOTENCY_KEY_REUSED", "IDEMPOTENCY_IN_PROGRESS", "CAPABILITY_UNAVAILABLE", "NOT_CONFIGURED", "RATE_LIMITED", "UPSTREAM_UNAVAILABLE", "INTERNAL_ERROR", "USERNAME_TAKEN", "INVALID_CREDENTIALS", "ADOPTION_TAKEN", "PET_NOT_ACTIVATED", "DRIVING_BLOCKS_VIDEO", "CONTROL_LEASE_HELD", "ITINERARY_CHANGED", "DRAFT_EXPIRED", "INSUFFICIENT_FUNDS", "ALREADY_TRAVELING", "FARM_GUARDED", "ALREADY_HAS_COMPANION", "MEDIA_REJECTED", "CODE_INVALID", "CODE_EXPIRED", "VERIFY_REQUIRED", "REAUTH_REQUIRED", "CONTACT_TAKEN", "REGISTRATION_CLOSED"] as const;

export type CapabilityStatus = "available" | "not_implemented" | "not_configured" | "disabled";
export const CapabilityStatusValues = ["available", "not_implemented", "not_configured", "disabled"] as const;

export type AuthMethod = "web_password" | "apple_bearer";
export const AuthMethodValues = ["web_password", "apple_bearer"] as const;

export type CoordSystem = "wgs84" | "gcj02";
export const CoordSystemValues = ["wgs84", "gcj02"] as const;

export type ContactChannel = "email" | "sms";
export const ContactChannelValues = ["email", "sms"] as const;

export type AuthCredentialKind = "password" | "email_password" | "phone_code" | "apple";
export const AuthCredentialKindValues = ["password", "email_password", "phone_code", "apple"] as const;

export type OnboardingStep = "needs_companion" | "reception_optional" | "ready_to_move_in" | "active";
export const OnboardingStepValues = ["needs_companion", "reception_optional", "ready_to_move_in", "active"] as const;

export type AudienceScope = "everyone" | "signed_in" | "followers" | "family";
export const AudienceScopeValues = ["everyone", "signed_in", "followers", "family"] as const;

export type AudienceWarning = "posts_wider_than_profile" | "followers_open_to_anyone" | "photo_family_only";
export const AudienceWarningValues = ["posts_wider_than_profile", "followers_open_to_anyone", "photo_family_only"] as const;

export type HouseholdRole = "admin" | "caregiver";
export const HouseholdRoleValues = ["admin", "caregiver"] as const;

export type InviteStatus = "pending" | "accepted" | "revoked" | "expired";
export const InviteStatusValues = ["pending", "accepted", "revoked", "expired"] as const;

export type PetJoinStep = "reception_optional" | "ready_to_move_in" | "moved_in";
export const PetJoinStepValues = ["reception_optional", "ready_to_move_in", "moved_in"] as const;

export type HomeRoom = "inside" | "courtyard";
export const HomeRoomValues = ["inside", "courtyard"] as const;

export type HomeActivityKind = "sleeping" | "awake" | "arriving" | "unknown" | "away";
export const HomeActivityKindValues = ["sleeping", "awake", "arriving", "unknown", "away"] as const;

export type HomeActivityDetailKind = "rest" | "eat" | "watch_window" | "watch_tv" | "phone" | "stroll_courtyard" | "drink" | "run" | "motion";
export const HomeActivityDetailKindValues = ["rest", "eat", "watch_window", "watch_tv", "phone", "stroll_courtyard", "drink", "run", "motion"] as const;

export type HomeDisplayKind = "rest" | "eat" | "watch_window" | "stroll_courtyard" | "drink" | "run" | "motion";
export const HomeDisplayKindValues = ["rest", "eat", "watch_window", "stroll_courtyard", "drink", "run", "motion"] as const;

export type EntryKind = "browse" | "own_pet" | "adopt" | "invite";
export const EntryKindValues = ["browse", "own_pet", "adopt", "invite"] as const;

export type PetSpecies = "dog" | "cat" | "parrot" | "rabbit" | "hamster" | "bird" | "guinea_pig" | "chinchilla" | "hedgehog" | "ferret" | "other";
export const PetSpeciesValues = ["dog", "cat", "parrot", "rabbit", "hamster", "bird", "guinea_pig", "chinchilla", "hedgehog", "ferret", "other"] as const;

export type PetOrigin = "own_pet" | "adopted_original" | "adopted_real_archive";
export const PetOriginValues = ["own_pet", "adopted_original", "adopted_real_archive"] as const;

export type PetPresence = "not_activated" | "at_home" | "in_transit" | "at_destination" | "visiting" | "returning" | "unknown";
export const PetPresenceValues = ["not_activated", "at_home", "in_transit", "at_destination", "visiting", "returning", "unknown"] as const;

export type ProfileVisibility = "public" | "followers" | "private";
export const ProfileVisibilityValues = ["public", "followers", "private"] as const;

export type IdentitySourceKind = "owner_original" | "real_archive" | "original_companion" | "platform_official";
export const IdentitySourceKindValues = ["owner_original", "real_archive", "original_companion", "platform_official"] as const;

export type IdentityAssetState = "usable" | "revoked" | "missing";
export const IdentityAssetStateValues = ["usable", "revoked", "missing"] as const;

export type IdentityPlaceholder = "species_illustration" | "paw";
export const IdentityPlaceholderValues = ["species_illustration", "paw"] as const;

export type AdoptionAvailability = "available" | "reserved" | "adopted";
export const AdoptionAvailabilityValues = ["available", "reserved", "adopted"] as const;

export type BehaviorPolarity = "positive" | "negative" | "averse" | "uncertain";
export const BehaviorPolarityValues = ["positive", "negative", "averse", "uncertain"] as const;

export type BehaviorTraitStatus = "applied" | "negated" | "outweighed" | "uncertain";
export const BehaviorTraitStatusValues = ["applied", "negated", "outweighed", "uncertain"] as const;

export type PetRhythm = "regular" | "night_owl" | "early_bird" | "sleepy";
export const PetRhythmValues = ["regular", "night_owl", "early_bird", "sleepy"] as const;

export type PetSociability = "social" | "steady" | "homebody";
export const PetSociabilityValues = ["social", "steady", "homebody"] as const;

export type PhotoScene = "home" | "train" | "flight_adventure";
export const PhotoSceneValues = ["home", "train", "flight_adventure"] as const;

export type PhotoNarrative = "daily_life" | "fictional_adventure";
export const PhotoNarrativeValues = ["daily_life", "fictional_adventure"] as const;

export type PhotoCheckOutcome = "pass_cat" | "pass_dog" | "species_mismatch" | "not_pet" | "unsupported_species" | "unclear" | "unknown";
export const PhotoCheckOutcomeValues = ["pass_cat", "pass_dog", "species_mismatch", "not_pet", "unsupported_species", "unclear", "unknown"] as const;

export type PhotoCheckReason = "photo_not_pet" | "species_not_supported" | "species_mismatch" | "photo_unclear" | "recognition_unavailable" | "recognition_rate_limited";
export const PhotoCheckReasonValues = ["photo_not_pet", "species_not_supported", "species_mismatch", "photo_unclear", "recognition_unavailable", "recognition_rate_limited"] as const;

export type CharacterStatus = "absent" | "queued" | "running" | "ready" | "failed" | "unknown";
export const CharacterStatusValues = ["absent", "queued", "running", "ready", "failed", "unknown"] as const;

export type CharacterReason = "no_reference_photo" | "species_unsupported" | "provider_unavailable" | "provider_no_png" | "not_configured" | "pet_has_no_household" | "reference_source_pending" | "capability_off" | "capability_unknown" | "generated_reference_only" | "reference_changed" | "body_changed" | "body_info_needed" | "budget_denied" | "charge_basis_pending" | "unknown_result" | "transparency_not_requested" | "attempts_exhausted" | "daily_cap" | "rejected" | "timeout" | "unconfirmed" | "already_queued" | "not_png" | "undecodable" | "interlaced_unsupported" | "palette_unsupported" | "bit_depth_unsupported" | "no_alpha_channel" | "opaque_background" | "checkerboard_drawn" | "empty_subject" | "multiple_subjects" | "subject_cut_off" | "subject_too_large" | "background_not_removed" | "key_background_not_uniform" | "background_halo" | "subject_too_small" | "too_large_to_check" | "fringe_output_invalid" | "photo_not_to_bottom" | "photo_headroom_off" | "photo_head_cut_off" | "photo_too_small" | "photo_wrong_shape" | "photo_blank";
export const CharacterReasonValues = ["no_reference_photo", "species_unsupported", "provider_unavailable", "provider_no_png", "not_configured", "pet_has_no_household", "reference_source_pending", "capability_off", "capability_unknown", "generated_reference_only", "reference_changed", "body_changed", "body_info_needed", "budget_denied", "charge_basis_pending", "unknown_result", "transparency_not_requested", "attempts_exhausted", "daily_cap", "rejected", "timeout", "unconfirmed", "already_queued", "not_png", "undecodable", "interlaced_unsupported", "palette_unsupported", "bit_depth_unsupported", "no_alpha_channel", "opaque_background", "checkerboard_drawn", "empty_subject", "multiple_subjects", "subject_cut_off", "subject_too_large", "background_not_removed", "key_background_not_uniform", "background_halo", "subject_too_small", "too_large_to_check", "fringe_output_invalid", "photo_not_to_bottom", "photo_headroom_off", "photo_head_cut_off", "photo_too_small", "photo_wrong_shape", "photo_blank"] as const;

export type CharacterPose = "neutral_full" | "sleeping" | "sunbathing" | "eating" | "walking" | "petted" | "stand_front" | "stand_left" | "stand_right" | "stand_back" | "sit" | "lie" | "sleep_curl" | "sleep_side" | "eat" | "drink" | "petted_stand" | "petted_sit" | "petted_lie" | "walk_left" | "walk_right" | "walk_front" | "walk_back" | "run_left" | "run_right" | "groom" | "stretch" | "yawn" | "look_up" | "shake" | "scratch" | "sniff";
export const CharacterPoseValues = ["neutral_full", "sleeping", "sunbathing", "eating", "walking", "petted", "stand_front", "stand_left", "stand_right", "stand_back", "sit", "lie", "sleep_curl", "sleep_side", "eat", "drink", "petted_stand", "petted_sit", "petted_lie", "walk_left", "walk_right", "walk_front", "walk_back", "run_left", "run_right", "groom", "stretch", "yawn", "look_up", "shake", "scratch", "sniff"] as const;

export type CharacterPoseBackfill = "waiting_quota" | "exhausted";
export const CharacterPoseBackfillValues = ["waiting_quota", "exhausted"] as const;

export type IdPhotoSource = "generated" | "companion_portrait";
export const IdPhotoSourceValues = ["generated", "companion_portrait"] as const;

export type IdPhotoAutoRedraw = "on" | "off" | "unknown";
export const IdPhotoAutoRedrawValues = ["on", "off", "unknown"] as const;

export type CharacterPoseRetryOutcome = "queued" | "already_queued" | "waiting" | "ready" | "retry_limit" | "not_available";
export const CharacterPoseRetryOutcomeValues = ["queued", "already_queued", "waiting", "ready", "retry_limit", "not_available"] as const;

export type InteractionPart = "head" | "back" | "chin" | "cheek" | "belly" | "tail" | "unknown";
export const InteractionPartValues = ["head", "back", "chin", "cheek", "belly", "tail", "unknown"] as const;

export type InteractionLevel = "low" | "medium" | "high" | "unknown";
export const InteractionLevelValues = ["low", "medium", "high", "unknown"] as const;

export type TouchPreferenceValue = "prefer" | "avoid";
export const TouchPreferenceValueValues = ["prefer", "avoid"] as const;

export type InteractionSourceKind = "confirmed_note" | "dna" | "species_default";
export const InteractionSourceKindValues = ["confirmed_note", "dna", "species_default"] as const;

export type InteractionHoldKind = "verified" | "unconfirmed_risk";
export const InteractionHoldKindValues = ["verified", "unconfirmed_risk"] as const;

export type InteractionScope = "part" | "whole_body";
export const InteractionScopeValues = ["part", "whole_body"] as const;

export type InteractionLimitCategory = "injury" | "post_surgery" | "other";
export const InteractionLimitCategoryValues = ["injury", "post_surgery", "other"] as const;

export type InteractionHoldSource = "limit_record" | "dna" | "own_note";
export const InteractionHoldSourceValues = ["limit_record", "dna", "own_note"] as const;

export type InteractionMemberScope = "self";
export const InteractionMemberScopeValues = ["self"] as const;

export type InteractionLimitStatus = "pending" | "confirmed" | "rejected" | "withdrawn";
export const InteractionLimitStatusValues = ["pending", "confirmed", "rejected", "withdrawn"] as const;

export type InteractionLimitSource = "family" | "ops";
export const InteractionLimitSourceValues = ["family", "ops"] as const;

export type HabitatKind = "seaside" | "grassland" | "desert" | "forest" | "lakeside" | "mountain" | "city" | "countryside";
export const HabitatKindValues = ["seaside", "grassland", "desert", "forest", "lakeside", "mountain", "city", "countryside"] as const;

export type GuardBasis = "pet_at_home" | "owner_patrol" | "none";
export const GuardBasisValues = ["pet_at_home", "owner_patrol", "none"] as const;

export type PlotStage = "empty" | "growing" | "ripe" | "harvested";
export const PlotStageValues = ["empty", "growing", "ripe", "harvested"] as const;

export type FarmActionKind = "plant" | "harvest" | "steal";
export const FarmActionKindValues = ["plant", "harvest", "steal"] as const;

export type WelcomeDetailKind = "owner_title" | "favorite_object" | "interaction_boundary";
export const WelcomeDetailKindValues = ["owner_title", "favorite_object", "interaction_boundary"] as const;

export type FarmWatch = "owner_patrol" | "pet_awake" | "pet_resting" | "nobody";
export const FarmWatchValues = ["owner_patrol", "pet_awake", "pet_resting", "nobody"] as const;

export type SuggestionStatus = "pending" | "accepted" | "passed" | "replaced";
export const SuggestionStatusValues = ["pending", "accepted", "passed", "replaced"] as const;

export type GuideStatus = "planned" | "in_progress" | "completed";
export const GuideStatusValues = ["planned", "in_progress", "completed"] as const;

export type PlaceProvider = "amap" | "google" | "fixture" | "world";
export const PlaceProviderValues = ["amap", "google", "fixture", "world"] as const;

export type VisitState = "planned" | "travelling" | "arrived" | "active" | "completed" | "cancelled";
export const VisitStateValues = ["planned", "travelling", "arrived", "active", "completed", "cancelled"] as const;

export type VenueTemplate = "cafe" | "restaurant" | "park" | "generic";
export const VenueTemplateValues = ["cafe", "restaurant", "park", "generic"] as const;

export type VisitActivityKind = "choose_seat" | "order_drink" | "take_photo" | "greet_resident";
export const VisitActivityKindValues = ["choose_seat", "order_drink", "take_photo", "greet_resident"] as const;

export type VisitActivityState = "available" | "in_progress" | "done" | "disabled";
export const VisitActivityStateValues = ["available", "in_progress", "done", "disabled"] as const;

export type JourneyLifecycle = "active" | "completed" | "cancelled";
export const JourneyLifecycleValues = ["active", "completed", "cancelled"] as const;

export type TransportMode = "flight" | "train" | "ferry" | "drive" | "transit" | "taxi" | "walk";
export const TransportModeValues = ["flight", "train", "ferry", "drive", "transit", "taxi", "walk"] as const;

export type TimeBasis = "verified_timetable" | "live_status" | "routed_estimate" | "demo_fixture";
export const TimeBasisValues = ["verified_timetable", "live_status", "routed_estimate", "demo_fixture"] as const;

export type LegTimeSource = "verified_timetable" | "operator_rule" | "routed_estimate" | "world_rule" | "demo_fixture";
export const LegTimeSourceValues = ["verified_timetable", "operator_rule", "routed_estimate", "world_rule", "demo_fixture"] as const;

export type DataFreshness = "verified" | "stale" | "unavailable";
export const DataFreshnessValues = ["verified", "stale", "unavailable"] as const;

export type PositionBasis = "simulated_route" | "schematic" | "live_vehicle";
export const PositionBasisValues = ["simulated_route", "schematic", "live_vehicle"] as const;

export type TravellerRole = "driver" | "passenger" | "walker";
export const TravellerRoleValues = ["driver", "passenger", "walker"] as const;

export type LegKind = "main" | "connection" | "wait" | "transfer";
export const LegKindValues = ["main", "connection", "wait", "transfer"] as const;

export type LegPhase = "scheduled" | "connecting" | "waiting" | "boarding" | "in_transit" | "arriving" | "arrived" | "cancelled";
export const LegPhaseValues = ["scheduled", "connecting", "waiting", "boarding", "in_transit", "arriving", "arrived", "cancelled"] as const;

export type NodeKind = "airport" | "station" | "port" | "road_point" | "place";
export const NodeKindValues = ["airport", "station", "port", "road_point", "place"] as const;

export type TravelActivityKind = "listening" | "watching" | "resting" | "window_gazing" | "dining" | "writing_postcard";
export const TravelActivityKindValues = ["listening", "watching", "resting", "window_gazing", "dining", "writing_postcard"] as const;

export type TravelActivityState = "active" | "paused" | "interrupted" | "ended";
export const TravelActivityStateValues = ["active", "paused", "interrupted", "ended"] as const;

export type ActivityBadgeKind = "music" | "tv";
export const ActivityBadgeKindValues = ["music", "tv"] as const;

export type MapEntryAction = "join" | "solo" | "open_leg_card";
export const MapEntryActionValues = ["join", "solo", "open_leg_card"] as const;

export type BasemapProvider = "amap";
export const BasemapProviderValues = ["amap"] as const;

export type BasemapUnavailableReason = "not_configured" | "outside_region" | "daily_cap" | "user_limit" | "upstream_error";
export const BasemapUnavailableReasonValues = ["not_configured", "outside_region", "daily_cap", "user_limit", "upstream_error"] as const;

export type MediaKind = "audio" | "video";
export const MediaKindValues = ["audio", "video"] as const;

export type MediaAvailability = "in_app_sync" | "external_link" | "unavailable";
export const MediaAvailabilityValues = ["in_app_sync", "external_link", "unavailable"] as const;

export type LicenseStatus = "self_generated_test" | "licensed" | "pending" | "unknown";
export const LicenseStatusValues = ["self_generated_test", "licensed", "pending", "unknown"] as const;

export type MediaSessionState = "playing" | "paused" | "ended" | "interrupted";
export const MediaSessionStateValues = ["playing", "paused", "ended", "interrupted"] as const;

export type ResumePolicy = "pet_continues" | "save_shared_progress" | "stop";
export const ResumePolicyValues = ["pet_continues", "save_shared_progress", "stop"] as const;

export type InterruptReason = "arrival" | "driving" | "content_unavailable" | "joint_pause";
export const InterruptReasonValues = ["arrival", "driving", "content_unavailable", "joint_pause"] as const;

export type ParticipationMode = "not_joined" | "joining" | "synced" | "solo" | "buffering" | "blocked" | "failed" | "left";
export const ParticipationModeValues = ["not_joined", "joining", "synced", "solo", "buffering", "blocked", "failed", "left"] as const;

export type CompanionCommandKind = "pause" | "resume" | "seek" | "restart";
export const CompanionCommandKindValues = ["pause", "resume", "seek", "restart"] as const;

export type FoodMode = "pet_virtual_explore" | "owner_real_dining";
export const FoodModeValues = ["pet_virtual_explore", "owner_real_dining"] as const;

export type PreferenceSubject = "pet" | "owner";
export const PreferenceSubjectValues = ["pet", "owner"] as const;

export type PreferenceSource = "explicit" | "reception_confirmed" | "feedback_derived" | "fixture";
export const PreferenceSourceValues = ["explicit", "reception_confirmed", "feedback_derived", "fixture"] as const;

export type DietaryRestrictionKind = "allergy" | "avoid" | "religious" | "other";
export const DietaryRestrictionKindValues = ["allergy", "avoid", "religious", "other"] as const;

export type EvidenceSourceKind = "map_poi" | "merchant_menu" | "licensed_review" | "owner_feedback" | "partner_note" | "fixture";
export const EvidenceSourceKindValues = ["map_poi", "merchant_menu", "licensed_review", "owner_feedback", "partner_note", "fixture"] as const;

export type EligibilityStatus = "eligible" | "needs_verification" | "excluded";
export const EligibilityStatusValues = ["eligible", "needs_verification", "excluded"] as const;

export type RecommendationGroup = "primary" | "alternative" | "explore" | "needs_verification";
export const RecommendationGroupValues = ["primary", "alternative", "explore", "needs_verification"] as const;

export type RecommendationFreshness = "fresh" | "needs_recheck" | "expired";
export const RecommendationFreshnessValues = ["fresh", "needs_recheck", "expired"] as const;

export type FoodDataStatus = "fixture" | "live_verified" | "live_partial";
export const FoodDataStatusValues = ["fixture", "live_verified", "live_partial"] as const;

export type FeedbackVerdict = "liked" | "neutral" | "disliked";
export const FeedbackVerdictValues = ["liked", "neutral", "disliked"] as const;

export type FeedbackVerification = "self_reported" | "verified";
export const FeedbackVerificationValues = ["self_reported", "verified"] as const;

export type ReceptionBranch = "own_pet" | "adopted";
export const ReceptionBranchValues = ["own_pet", "adopted"] as const;

export type ReceptionMode = "guided_notes" | "model_conversation";
export const ReceptionModeValues = ["guided_notes", "model_conversation"] as const;

export type ReceptionStatus = "active" | "awaiting_confirmation" | "skipped" | "completed" | "expired";
export const ReceptionStatusValues = ["active", "awaiting_confirmation", "skipped", "completed", "expired"] as const;

export type TurnSpeaker = "host" | "owner";
export const TurnSpeakerValues = ["host", "owner"] as const;

export type CandidateKind = "habit" | "shared_story" | "wish" | "letter" | "owner_private" | "inference";
export const CandidateKindValues = ["habit", "shared_story", "wish", "letter", "owner_private", "inference"] as const;

export type CandidateSubject = "pet" | "owner" | "relationship";
export const CandidateSubjectValues = ["pet", "owner", "relationship"] as const;

export type CandidateState = "unconfirmed" | "edited" | "confirmed" | "discarded";
export const CandidateStateValues = ["unconfirmed", "edited", "confirmed", "discarded"] as const;

export type CareNoteSlot = "owner_title" | "favorite_object" | "interaction_boundary" | "travel_mood" | "wish_place" | "other" | "touch_preference";
export const CareNoteSlotValues = ["owner_title", "favorite_object", "interaction_boundary", "travel_mood", "wish_place", "other", "touch_preference"] as const;

export type SaveTarget = "give_to_pet" | "keep_here" | "do_not_save";
export const SaveTargetValues = ["give_to_pet", "keep_here", "do_not_save"] as const;

export type MemoryPurpose = "private_chat" | "home_interaction" | "travel_preference" | "food_preference_pet" | "public_story" | "media_generation";
export const MemoryPurposeValues = ["private_chat", "home_interaction", "travel_preference", "food_preference_pet", "public_story", "media_generation"] as const;

export type PersistState = "persisted" | "failed";
export const PersistStateValues = ["persisted", "failed"] as const;

export type MemoryCorrectionAction = "correct" | "revoke" | "erase";
export const MemoryCorrectionActionValues = ["correct", "revoke", "erase"] as const;

export type CleanupState = "usage_stopped" | "cleanup_pending" | "cleanup_done";
export const CleanupStateValues = ["usage_stopped", "cleanup_pending", "cleanup_done"] as const;

export type ActorKind = "pet" | "npc" | "owner";
export const ActorKindValues = ["pet", "npc", "owner"] as const;

export type PostVisibility = "public" | "followers" | "removed";
export const PostVisibilityValues = ["public", "followers", "removed"] as const;

export type MessageSender = "owner" | "pet";
export const MessageSenderValues = ["owner", "pet"] as const;

export type MessageDeliveryState = "sending" | "delivered" | "awaiting_reply" | "processing" | "failed";
export const MessageDeliveryStateValues = ["sending", "delivered", "awaiting_reply", "processing", "failed"] as const;

export type MessageComposer = "event" | "template" | "model";
export const MessageComposerValues = ["event", "template", "model"] as const;

export type MessageTopic = "morning" | "share" | "goodnight" | "thinking_of_you" | "news";
export const MessageTopicValues = ["morning", "share", "goodnight", "thinking_of_you", "news"] as const;

export type MessageChannel = "private" | "family";
export const MessageChannelValues = ["private", "family"] as const;

export type MessageSuggestedAction = "come_home";
export const MessageSuggestedActionValues = ["come_home"] as const;

export type PhotoStatus = "processing" | "ready" | "failed" | "unknown";
export const PhotoStatusValues = ["processing", "ready", "failed", "unknown"] as const;

export type FriendKind = "pet" | "resident";
export const FriendKindValues = ["pet", "resident"] as const;

export type IntentChannel = "reception" | "communicator";
export const IntentChannelValues = ["reception", "communicator"] as const;

export type IntentLayerMode = "off" | "shadow" | "assist";
export const IntentLayerModeValues = ["off", "shadow", "assist"] as const;

export type IntentProvider = "rule" | "configured_llm" | "jev";
export const IntentProviderValues = ["rule", "configured_llm", "jev"] as const;

export type SignalKind = "share" | "ask" | "request" | "correct" | "refuse" | "revoke" | "missing" | "constraint" | "wish" | "privacy_limit" | "unclear";
export const SignalKindValues = ["share", "ask", "request", "correct", "refuse", "revoke", "missing", "constraint", "wish", "privacy_limit", "unclear"] as const;

export type SignalSubject = "owner" | "pet" | "place" | "journey" | "memory" | "photo" | "unknown";
export const SignalSubjectValues = ["owner", "pet", "place", "journey", "memory", "photo", "unknown"] as const;

export type TemporalScope = "past" | "ongoing" | "future_wish" | "hypothetical" | "current_command" | "unknown";
export const TemporalScopeValues = ["past", "ongoing", "future_wish", "hypothetical", "current_command", "unknown"] as const;

export type UsageLimit = "do_not_record" | "do_not_relay" | "do_not_publish";
export const UsageLimitValues = ["do_not_record", "do_not_relay", "do_not_publish"] as const;

export type ActionProposalKind = "none" | "clarify" | "offer_control" | "record_candidate" | "adjust_reply";
export const ActionProposalKindValues = ["none", "clarify", "offer_control", "record_candidate", "adjust_reply"] as const;

export type ActionOutcomeState = "proposed" | "needs_confirmation" | "blocked" | "executed" | "failed";
export const ActionOutcomeStateValues = ["proposed", "needs_confirmation", "blocked", "executed", "failed"] as const;

export type CredentialKind = "identity_card" | "bank_card" | "care_profile" | "passport" | "driver_license" | "boarding_pass" | "transport_ticket" | "hotel_key";
export const CredentialKindValues = ["identity_card", "bank_card", "care_profile", "passport", "driver_license", "boarding_pass", "transport_ticket", "hotel_key"] as const;

export type CredentialStatus = "not_obtained" | "in_progress" | "active" | "used" | "expired";
export const CredentialStatusValues = ["not_obtained", "in_progress", "active", "used", "expired"] as const;

export type SchoolSubject = "s1" | "s2" | "s3" | "s4";
export const SchoolSubjectValues = ["s1", "s2", "s3", "s4"] as const;

export type SchoolStage = "none" | "wish" | "enrolled" | "license_pending" | "licensed";
export const SchoolStageValues = ["none", "wish", "enrolled", "license_pending", "licensed"] as const;

export type SubjectState = "locked" | "available" | "in_exam" | "cooldown" | "passed";
export const SubjectStateValues = ["locked", "available", "in_exam", "cooldown", "passed"] as const;

export type SessionMode = "practice" | "formal";
export const SessionModeValues = ["practice", "formal"] as const;

export type AttemptKind = "first" | "retake";
export const AttemptKindValues = ["first", "retake"] as const;

export type SchoolSessionState = "preparing" | "running" | "settled" | "void";
export const SchoolSessionStateValues = ["preparing", "running", "settled", "void"] as const;

export type QuizKind = "choice" | "match" | "order";
export const QuizKindValues = ["choice", "match", "order"] as const;

export type EntryRoute = "browse" | "own_pet" | "adopt" | "invite";
export const EntryRouteValues = ["browse", "own_pet", "adopt", "invite"] as const;

export type MapPresence = "on_map" | "off_map";
export const MapPresenceValues = ["on_map", "off_map"] as const;

export type OffMapReason = "no_official_image" | "position_unknown";
export const OffMapReasonValues = ["no_official_image", "position_unknown"] as const;

export type ResidentKind = "adoptable" | "public_npc";
export const ResidentKindValues = ["adoptable", "public_npc"] as const;

export type PublicMapBasis = "residential_site" | "residence_area" | "place_area" | "route_area" | "last_known_area";
export const PublicMapBasisValues = ["residential_site", "residence_area", "place_area", "route_area", "last_known_area"] as const;

export type PublicFeedKind = "outing_started" | "event_joined" | "arrived" | "came_home" | "photo_posted" | "met";
export const PublicFeedKindValues = ["outing_started", "event_joined", "arrived", "came_home", "photo_posted", "met"] as const;

export type PublicTimelineState = "known" | "unknown";
export const PublicTimelineStateValues = ["known", "unknown"] as const;

export type PublicSky = "night" | "dawn" | "day" | "dusk";
export const PublicSkyValues = ["night", "dawn", "day", "dusk"] as const;

export type ProviderState = "disabled" | "not_configured" | "configured" | "verified" | "failing";
export const ProviderStateValues = ["disabled", "not_configured", "configured", "verified", "failing"] as const;

export type WorldRunnerHealth = "healthy" | "stalled" | "lost" | "configured_off" | "unavailable";
export const WorldRunnerHealthValues = ["healthy", "stalled", "lost", "configured_off", "unavailable"] as const;

export type WorldStallReason = "journey_events_overdue" | "next_check_overdue" | "outbox_overdue" | "report_missing" | "report_failed" | "report_stale";
export const WorldStallReasonValues = ["journey_events_overdue", "next_check_overdue", "outbox_overdue", "report_missing", "report_failed", "report_stale"] as const;

export type MapProvider = "amap";
export const MapProviderValues = ["amap"] as const;

export type MapUnavailableReason = "not_configured";
export const MapUnavailableReasonValues = ["not_configured"] as const;

export type WorldRelation = "mine" | "household";
export const WorldRelationValues = ["mine", "household"] as const;

export type WorldActivityKind = "home" | "stroll" | "cafe" | "city_trip" | "drive_trip" | "job" | "trip";
export const WorldActivityKindValues = ["home", "stroll", "cafe", "city_trip", "drive_trip", "job", "trip"] as const;

export type WorldPhase = "home" | "going" | "there" | "returning" | "unknown";
export const WorldPhaseValues = ["home", "going", "there", "returning", "unknown"] as const;

export type WorldPositionBasis = "home_area" | "place" | "route" | "unknown";
export const WorldPositionBasisValues = ["home_area", "place", "route", "unknown"] as const;

export type WorldPose = "idle" | "sleeping" | "eating" | "drinking" | "running" | "sunbathing" | "walking" | "riding" | "cafe" | "working" | "exploring" | "unknown";
export const WorldPoseValues = ["idle", "sleeping", "eating", "drinking", "running", "sunbathing", "walking", "riding", "cafe", "working", "exploring", "unknown"] as const;

export type RhythmSeason = "spring" | "summer" | "autumn" | "winter";
export const RhythmSeasonValues = ["spring", "summer", "autumn", "winter"] as const;

export type RhythmSky = "night" | "dawn" | "day" | "dusk";
export const RhythmSkyValues = ["night", "dawn", "day", "dusk"] as const;

export type RhythmBasis = "home" | "residence" | "unknown";
export const RhythmBasisValues = ["home", "residence", "unknown"] as const;

export type AnnouncementSeverity = "info" | "notice" | "maintenance";
export const AnnouncementSeverityValues = ["info", "notice", "maintenance"] as const;

export type AnnouncementSource = "live" | "not_installed";
export const AnnouncementSourceValues = ["live", "not_installed"] as const;

export type ReportStatus = "received" | "resolved";
export const ReportStatusValues = ["received", "resolved"] as const;

export type ReportOutcome = "received" | "content_removed" | "no_violation_found" | "content_restored";
export const ReportOutcomeValues = ["received", "content_removed", "no_violation_found", "content_restored"] as const;

export type TravelWaitingReason = "missing_funds" | "quota_denied" | "research_pending" | "research_unknown" | "research_failed" | "fact_stale" | "plan_stale" | "fact_unverified" | "fact_conflicting" | "weather_unsuitable" | "commitment_active" | "maintenance";
export const TravelWaitingReasonValues = ["missing_funds", "quota_denied", "research_pending", "research_unknown", "research_failed", "fact_stale", "plan_stale", "fact_unverified", "fact_conflicting", "weather_unsuitable", "commitment_active", "maintenance"] as const;

export type TravelWishStatus = "active" | "ready" | "linked" | "completed" | "cancelled";
export const TravelWishStatusValues = ["active", "ready", "linked", "completed", "cancelled"] as const;

export type TravelResearchStatus = "queued" | "running" | "ready" | "failed" | "unknown";
export const TravelResearchStatusValues = ["queued", "running", "ready", "failed", "unknown"] as const;

export type TravelStopRole = "main" | "suggested";
export const TravelStopRoleValues = ["main", "suggested"] as const;

export type TravelFactVerdict = "verified" | "unverified" | "stale" | "conflicting" | "rejected";
export const TravelFactVerdictValues = ["verified", "unverified", "stale", "conflicting", "rejected"] as const;

export type TravelJournalPhase = "plan" | "memory";
export const TravelJournalPhaseValues = ["plan", "memory"] as const;

export type TravelIdentityMode = "photo" | "none";
export const TravelIdentityModeValues = ["photo", "none"] as const;

export type TravelSafetySticker = "shark_flag";
export const TravelSafetyStickerValues = ["shark_flag"] as const;

export type PlanetEventJourneyPhase = "scheduled" | "traveling" | "returned";
export const PlanetEventJourneyPhaseValues = ["scheduled", "traveling", "returned"] as const;

export type PlanetEventTellSource = "owner" | "heard";
export const PlanetEventTellSourceValues = ["owner", "heard"] as const;

export type PlanetEventTellStatus = "active" | "withdrawn" | "used" | "void";
export const PlanetEventTellStatusValues = ["active", "withdrawn", "used", "void"] as const;

export type PhotoSourceKind = "visit" | "photo_ask" | "legacy_request" | "arrival" | "home_activity" | "creative";
export const PhotoSourceKindValues = ["visit", "photo_ask", "legacy_request", "arrival", "home_activity", "creative"] as const;

export type PhotoTrigger = "autonomous" | "owner_ask" | "owner_click" | "legacy_request" | "system";
export const PhotoTriggerValues = ["autonomous", "owner_ask", "owner_click", "legacy_request", "system"] as const;

export type PhotoCategory = "life" | "work" | "travel" | "friends" | "fantasy" | "unknown";
export const PhotoCategoryValues = ["life", "work", "travel", "friends", "fantasy", "unknown"] as const;

export type PhotoIdentityMode = "reference" | "portrait_free" | "unrecorded";
export const PhotoIdentityModeValues = ["reference", "portrait_free", "unrecorded"] as const;

export type PhotoAudienceScope = "household" | "requester";
export const PhotoAudienceScopeValues = ["household", "requester"] as const;

export type PhotoAssetKind = "image" | "video";
export const PhotoAssetKindValues = ["image", "video"] as const;

export type VisitPhotoState = "ready" | "processing" | "unknown" | "failed" | "none";
export const VisitPhotoStateValues = ["ready", "processing", "unknown", "failed", "none"] as const;

export type PhotoAskOrigin = "button" | "text_confirmed" | "visit";
export const PhotoAskOriginValues = ["button", "text_confirmed", "visit"] as const;

export type PhotoAskChannel = "button" | "text_confirmed";
export const PhotoAskChannelValues = ["button", "text_confirmed"] as const;

export type PhotoAskOutcome = "accepted" | "shared_existing";
export const PhotoAskOutcomeValues = ["accepted", "shared_existing"] as const;

export type PhotoAskQuotaState = "held" | "consumed" | "released";
export const PhotoAskQuotaStateValues = ["held", "consumed", "released"] as const;

export type PhotoAskStatus = "processing" | "ready" | "failed" | "checking";
export const PhotoAskStatusValues = ["processing", "ready", "failed", "checking"] as const;

export type PhotoAskScope = "member_pet" | "pet" | "household";
export const PhotoAskScopeValues = ["member_pet", "pet", "household"] as const;

export type CareReason = "care_disabled" | "pet_has_no_household" | "resident_not_supported" | "generated_reference_only" | "no_reference_photo" | "species_unsupported" | "body_profile_missing" | "provider_unavailable" | "already_open" | "request_not_open" | "not_eligible" | "part_not_confirmed" | "no_change" | "change_not_supported" | "preview_not_passed" | "generation_mismatch" | "expired" | "preview_limit_reached" | "revert_nothing" | "revert_target_not_allowed" | "revert_assets_unavailable" | "base_world_changed" | "reality_changed" | "household_changed" | "proposer_revoked" | "reference_changed" | "quality_failed" | "quality_unknown";
export const CareReasonValues = ["care_disabled", "pet_has_no_household", "resident_not_supported", "generated_reference_only", "no_reference_photo", "species_unsupported", "body_profile_missing", "provider_unavailable", "already_open", "request_not_open", "not_eligible", "part_not_confirmed", "no_change", "change_not_supported", "preview_not_passed", "generation_mismatch", "expired", "preview_limit_reached", "revert_nothing", "revert_target_not_allowed", "revert_assets_unavailable", "base_world_changed", "reality_changed", "household_changed", "proposer_revoked", "reference_changed", "quality_failed", "quality_unknown"] as const;

export type CarePreferenceChoice = "unset" | "keep_original" | "later";
export const CarePreferenceChoiceValues = ["unset", "keep_original", "later"] as const;

export type CarePreferenceOption = "keep_original" | "later";
export const CarePreferenceOptionValues = ["keep_original", "later"] as const;

export type CareRequestKind = "world_change" | "revert";
export const CareRequestKindValues = ["world_change", "revert"] as const;

export type CareShownState = "proposed" | "generating" | "preview_ready" | "preview_failed" | "applied" | "cancelled" | "superseded" | "expired" | "unknown";
export const CareShownStateValues = ["proposed", "generating", "preview_ready", "preview_failed", "applied", "cancelled", "superseded", "expired", "unknown"] as const;

export type WorldBodyRevisionSource = "baseline" | "care_apply" | "care_revert" | "reality_rebase";
export const WorldBodyRevisionSourceValues = ["baseline", "care_apply", "care_revert", "reality_rebase"] as const;

export type BodyPartState = "present" | "absent" | "partial" | "unknown";
export const BodyPartStateValues = ["present", "absent", "partial", "unknown"] as const;

export type ThreeDLayer = "not_enabled" | "ready" | "pending_adaptation" | "unsupported_body_plan";
export const ThreeDLayerValues = ["not_enabled", "ready", "pending_adaptation", "unsupported_body_plan"] as const;

export type ThreeDBodyPlan = "supported" | "unsupported_body_plan" | "unknown";
export const ThreeDBodyPlanValues = ["supported", "unsupported_body_plan", "unknown"] as const;

export type BirthPrecision = "full" | "year_month" | "month_day" | "year" | "unknown";
export const BirthPrecisionValues = ["full", "year_month", "month_day", "year", "unknown"] as const;

export type FactReason = "facts_date_invalid" | "facts_date_in_future" | "facts_precision_invalid" | "facts_estimate_needs_year" | "facts_year_out_of_range" | "facts_chosen_birthday_invalid" | "facts_sex_cannot_clear" | "facts_version_conflict";
export const FactReasonValues = ["facts_date_invalid", "facts_date_in_future", "facts_precision_invalid", "facts_estimate_needs_year", "facts_year_out_of_range", "facts_chosen_birthday_invalid", "facts_sex_cannot_clear", "facts_version_conflict"] as const;

export type FactSource = "owner_confirmed" | "prototype_verified" | "platform_original";
export const FactSourceValues = ["owner_confirmed", "prototype_verified", "platform_original"] as const;

export type PetSex = "male" | "female" | "unknown";
export const PetSexValues = ["male", "female", "unknown"] as const;

export type PetSexChoice = "male" | "female";
export const PetSexChoiceValues = ["male", "female"] as const;

export type BodyReason = "body_statement_forbidden" | "body_resident_managed" | "body_revision_conflict" | "body_value_invalid" | "body_statement_not_pending" | "body_conflict_not_open";
export const BodyReasonValues = ["body_statement_forbidden", "body_resident_managed", "body_revision_conflict", "body_value_invalid", "body_statement_not_pending", "body_conflict_not_open"] as const;

export type BodyPlan = "quadruped_tailed" | "quadruped_tailless" | "bird";
export const BodyPlanValues = ["quadruped_tailed", "quadruped_tailless", "bird"] as const;

export type BodyPartId = "head" | "ear_l" | "ear_r" | "limb_fl" | "limb_fr" | "limb_hl" | "limb_hr" | "tail" | "torso" | "wing_l" | "wing_r" | "leg_l" | "leg_r";
export const BodyPartIdValues = ["head", "ear_l", "ear_r", "limb_fl", "limb_fr", "limb_hl", "limb_hr", "tail", "torso", "wing_l", "wing_r", "leg_l", "leg_r"] as const;

export type BodyGroup = "limbs" | "tails" | "ears" | "wings";
export const BodyGroupValues = ["limbs", "tails", "ears", "wings"] as const;

export type BodyStatementKind = "group_count" | "part_state" | "dog_size";
export const BodyStatementKindValues = ["group_count", "part_state", "dog_size"] as const;

export type BodyStatementState = "present" | "absent" | "partial";
export const BodyStatementStateValues = ["present", "absent", "partial"] as const;

export type BodyConfirmation = "confirmed" | "unconfirmed";
export const BodyConfirmationValues = ["confirmed", "unconfirmed"] as const;

export type BodyDogSize = "small" | "large";
export const BodyDogSizeValues = ["small", "large"] as const;

export type BodySizeClass = "small" | "medium" | "large";
export const BodySizeClassValues = ["small", "medium", "large"] as const;

export type BodySizeClassBasis = "species" | "owner_confirmed" | "resident_design" | "species_default_unconfirmed";
export const BodySizeClassBasisValues = ["species", "owner_confirmed", "resident_design", "species_default_unconfirmed"] as const;

export type BodyStatementStatus = "applied" | "pending";
export const BodyStatementStatusValues = ["applied", "pending"] as const;

export type BodyConflictSource = "reference_photo" | "human_review";
export const BodyConflictSourceValues = ["reference_photo", "human_review"] as const;

export type PetChatStatus = "invited" | "active" | "ended";
export const PetChatStatusValues = ["invited", "active", "ended"] as const;

export type PetChatEnding = "chatted" | "no_reply" | "stopped" | "expired";
export const PetChatEndingValues = ["chatted", "no_reply", "stopped", "expired"] as const;

export type PetChatSpeaker = "mine" | "theirs";
export const PetChatSpeakerValues = ["mine", "theirs"] as const;

export type PetChatKind = "live" | "post";
export const PetChatKindValues = ["live", "post"] as const;

export type PetChatExchange = "both" | "one_way" | "none";
export const PetChatExchangeValues = ["both", "one_way", "none"] as const;

export type PetFriendKind = "pet" | "resident";
export const PetFriendKindValues = ["pet", "resident"] as const;

export type PetFriendExchange = "both" | "one_way" | "none" | "met_only";
export const PetFriendExchangeValues = ["both", "one_way", "none", "met_only"] as const;

export type PetFriendRelation = "friends" | "ended" | "none";
export const PetFriendRelationValues = ["friends", "ended", "none"] as const;

export type PlanRequestOrigin = "button" | "text_confirmed";
export const PlanRequestOriginValues = ["button", "text_confirmed"] as const;

export type PlanRequestState = "accepted" | "cannot_now" | "cancelled" | "replaced" | "done" | "expired";
export const PlanRequestStateValues = ["accepted", "cannot_now", "cancelled", "replaced", "done", "expired"] as const;

export type PlanRequestDisplay = "waiting_safe_node" | "returning" | "home" | "cannot_now" | "cancelled" | "replaced" | "expired";
export const PlanRequestDisplayValues = ["waiting_safe_node", "returning", "home", "cannot_now", "cancelled", "replaced", "expired"] as const;

export type SafeNodeKind = "min_stay" | "visit_end" | "shift_end" | "fixed_service" | "unsupported";
export const SafeNodeKindValues = ["min_stay", "visit_end", "shift_end", "fixed_service", "unsupported"] as const;

export type PlanRequestReason = "stay_fixed_service" | "no_visit" | "household_changed" | "journey_ended" | "plan_changed";
export const PlanRequestReasonValues = ["stay_fixed_service", "no_visit", "household_changed", "journey_ended", "plan_changed"] as const;

export type PlanRequestOutcome = "accepted" | "cannot_now" | "already_arranged" | "not_out" | "already_returning";
export const PlanRequestOutcomeValues = ["accepted", "cannot_now", "already_arranged", "not_out", "already_returning"] as const;

export type ArrangementState = "waiting_safe_node" | "returning";
export const ArrangementStateValues = ["waiting_safe_node", "returning"] as const;

export type BlockTargetKind = "account" | "pet" | "legacy_residents";
export const BlockTargetKindValues = ["account", "pet", "legacy_residents"] as const;

export type PetMotionPurpose = "home" | "game_snake" | "game_basket";
export const PetMotionPurposeValues = ["home", "game_snake", "game_basket"] as const;

export type PetMotionGenerationMethod = "keyframe_inbetween" | "video_extract" | "fixture";
export const PetMotionGenerationMethodValues = ["keyframe_inbetween", "video_extract", "fixture"] as const;

export type ActionLimitActivity = "rest" | "watch_window" | "watch_tv" | "phone" | "eat" | "stroll_courtyard";
export const ActionLimitActivityValues = ["rest", "watch_window", "watch_tv", "phone", "eat", "stroll_courtyard"] as const;

export type ActionLimitSource = "household_admin" | "member_suggestion" | "operator";
export const ActionLimitSourceValues = ["household_admin", "member_suggestion", "operator"] as const;

export type ActionLimitStatus = "pending" | "active" | "revoked";
export const ActionLimitStatusValues = ["pending", "active", "revoked"] as const;

export type CodePurpose = "phone_signin" | "email_register" | "password_recover" | "bind_contact" | "change_contact" | "account_proof";
export const CodePurposeValues = ["phone_signin", "email_register", "password_recover", "bind_contact", "change_contact", "account_proof"] as const;

export type DeliveryState = "accepted" | "unknown" | "failed" | "not_disclosed";
export const DeliveryStateValues = ["accepted", "unknown", "failed", "not_disclosed"] as const;

export type ChannelStatus = "available" | "disabled" | "not_configured";
export const ChannelStatusValues = ["available", "disabled", "not_configured"] as const;

export type SigninOutcome = "signed_in" | "created" | "proof_required";
export const SigninOutcomeValues = ["signed_in", "created", "proof_required"] as const;

export type PhoneProofMethod = "email_code" | "password" | "recovery_code";
export const PhoneProofMethodValues = ["email_code", "password", "recovery_code"] as const;

export type EmailVerifyOutcome = "verified_new" | "verified_existing";
export const EmailVerifyOutcomeValues = ["verified_new", "verified_existing"] as const;

export type RecoveryOutcome = "reset_allowed" | "phone_only";
export const RecoveryOutcomeValues = ["reset_allowed", "phone_only"] as const;

export type DataUsePurpose = "conversation" | "images" | "photo_check" | "maps" | "travel_research" | "verification_sms" | "verification_email";
export const DataUsePurposeValues = ["conversation", "images", "photo_check", "maps", "travel_research", "verification_sms", "verification_email"] as const;

export type BasicMotionStatus = "usable" | "preparing" | "unavailable";
export const BasicMotionStatusValues = ["usable", "preparing", "unavailable"] as const;

export interface WebError {
  code: WebErrorCode;
  /** 可读说明；不含堆栈、SQL 或密钥 */
  message: string;
  request_id: string;
  retryable: boolean;
  details: Record<string, unknown> | null;
}
export type WebErrorInput = WithOptional<WebError, "retryable" | "details">;

export interface WebErrorEnvelope {
  error: WebError;
}
export type WebErrorEnvelopeInput = WebErrorEnvelope;

export interface Capability {
  /** 稳定能力键，例如 food.recommendations */
  key: string;
  status: CapabilityStatus;
  module: string;
  note: string | null;
}
export type CapabilityInput = WithOptional<Capability, "note">;

export interface WebMeta {
  api_prefix: string;
  contract_version: string;
  server_time: IsoDateTime;
  backend_version: string;
  data_origin: DataOrigin;
  auth_methods_available: AuthMethod[];
  capabilities: Capability[];
  applied_migrations: string[];
}
export type WebMetaInput = WithOptional<WebMeta, "api_prefix" | "contract_version" | "data_origin" | "auth_methods_available" | "capabilities" | "applied_migrations">;

/** 整数金额；currency 区分游戏币 travel_coin 与现实币种（HKD/CNY 等），两者不混算。 */
export interface MoneyAmount {
  amount_minor: number;
  currency: string;
}
export type MoneyAmountInput = MoneyAmount;

export interface LatLng {
  lat: number;
  lng: number;
}
export type LatLngInput = LatLng;

export interface ContactView {
  channel: ContactChannel;
  masked: string;
  verified_at: IsoDateTime;
}
export type ContactViewInput = ContactView;

/** GET /me/contacts，以及 POST /me/contacts/{channel} 的回包；只给脱敏值。 */
export interface ContactsView {
  contacts: ContactView[];
  /** 没有密码的账号（只有手机号、Apple）不展示改密码 */
  has_password: boolean;
  /** 老账号名（只对老用户）；新账号没有 */
  legacy_username: string | null;
}
export type ContactsViewInput = WithOptional<ContactsView, "contacts" | "legacy_username">;

export interface OnboardingState {
  step: OnboardingStep;
  pet_id: string | null;
  home_id: string | null;
  reception_session_id: string | null;
  reception_skipped: boolean;
  home_activated_at: IsoDateTime | null;
  /** 伙伴来源；接待据此选择“自己的宠物/领养”分支 */
  pet_origin: PetOrigin | null;
  /** 你所在的家庭与各家的宠物（0.4.0：一个账号可以在多个家庭里照顾多只宠物） */
  households?: HouseholdBrief[];
  /** 注册时带来的入口（选中的伙伴 / 家庭邀请），等你确认；不会自动领养或加入 */
  entry?: EntryIntentView | null;
}
export type OnboardingStateInput = WithOptional<OnboardingState, "pet_id" | "home_id" | "reception_session_id" | "reception_skipped" | "home_activated_at" | "pet_origin" | "households" | "entry">;

export interface SessionUser {
  user_id: string;
  display_name: string | null;
  username: string | null;
  auth_method: AuthMethod;
  /** 这次会话凭什么登进来（AUTH-CONTACT C2）；cookie 会话的 auth_method 仍是 web_password */
  credential_kind?: AuthCredentialKind | null;
}
export type SessionUserInput = WithOptional<SessionUser, "display_name" | "username" | "credential_kind">;

export interface SessionState {
  authenticated: boolean;
  user: SessionUser | null;
  csrf_required: boolean;
  expires_at: IsoDateTime | null;
  onboarding: OnboardingState | null;
}
export type SessionStateInput = WithOptional<SessionState, "user" | "csrf_required" | "expires_at" | "onboarding">;

export interface RegisterRequest {
  username: string;
  password: string;
  display_name: string | null;
  /** 从哪个入口来注册（0.4.0） */
  entry?: EntryIntentRequest | null;
}
export type RegisterRequestInput = WithOptional<RegisterRequest, "display_name" | "entry">;

export interface LoginRequest {
  username: string;
  password: string;
}
export type LoginRequestInput = LoginRequest;

/** 入住激活。public_posts：是否允许 TA 的旅行到访生成公开动态（默认不公开，由主人明确选择）。 */
export interface MoveInRequest {
  public_posts: boolean;
  /** 希望这个家在哪一类地方（只在家第一次入住时生效）；只能选当前开放的类型（见 /home/place） */
  habitat?: string | null;
  /** 住进来的是哪一只宠物（0.4.0；只照顾一只时可以省略） */
  pet_id?: string | null;
  /** 希望这个家在哪座城市（城市起点）：只在家第一次入住、而且选了 habitat 时生效，否则忽略；只能选这一类开放的城市（见 /home/place 每一类的 cities），城市没开放时 422 habitat_not_supported；不带时落在这一类的 default_city（香港），这一类没有开放的香港片区时不带也 422 */
  city?: string | null;
  /** CITY-01：希望这个家在哪座城市（城市目录里的 amap:<市级 adcode>，见 /cities/search、/cities/recommend、/cities/random）。只在家第一次入住时生效；带了它就忽略 city，habitat 不给时按「城市」生活。城没开也能当场入住：城市先定、地址晚一点落定（地址落定前宠物不出门）；暂不开放的地区 422 region_unsupported，这座城没有这一类环境 422 habitat_not_supported */
  city_id?: string | null;
}
export type MoveInRequestInput = WithOptional<MoveInRequest, "public_posts" | "habitat" | "pet_id" | "city" | "city_id">;

export interface SettingsView {
  username: string | null;
  display_name: string | null;
  public_posts: boolean;
  profile_visibility: string;
  bio: string | null;
  intent_layer_mode: string;
  /** 开启时，由对话模型按已确认的叮嘱撰写：TA 给你的私信回复与主动来信、明信片上的话、攻略的措辞；家里第一位管理员的这项选择，还决定家庭频道的措辞、到站明信片上的话、TA 自己琢磨想去哪儿旅行时用不用模型，以及运营开启自主决策时 TA 的思考用不用模型；运营开启自主决策时，你的叮嘱也会按用途交给模型参考。恒为开启：用户 09-30 决定、c84a 10-03 D0020-1 批准，这一项由运营后台控制（本宠能力开关），玩家设置不再能关；旧客户端传来的值照旧回 200，但不写库、不撤回授权，读回恒为 true */
  model_replies?: boolean;
  model_replies_available?: boolean;
  /** 对话模型服务商（披露用），未配置为空 */
  model_provider?: string | null;
  /** 主人开启后，冒险事件会请生图服务画一张插画；默认关闭 */
  generated_photos?: boolean;
  generated_photos_available?: boolean;
  image_provider?: string | null;
  /** 是否接收 TA 主动发来的消息（早安、分享、晚安等；每天最多 4 条，夜间不打扰） */
  pet_messages?: boolean;
  /** 主人所在时区（IANA 名称），安静时段按它计算 */
  timezone?: string;
  /** 已绑定的手机号和邮箱（脱敏） */
  contacts?: ContactsView | null;
  /** PRIV-AUDIENCE-01b：这只宠物此刻每一项对家人以外开到哪一档（由主页范围与动态公开两个开关换算，逐项与真实读取端一致）；隐私说明只从这里来。没有宠物时为空 */
  effective_audience?: EffectiveAudience | null;
}
export type SettingsViewInput = WithOptional<SettingsView, "username" | "display_name" | "bio" | "model_replies" | "model_replies_available" | "model_provider" | "generated_photos" | "generated_photos_available" | "image_provider" | "pet_messages" | "timezone" | "contacts" | "effective_audience">;

export interface SettingsUpdate {
  model_replies: boolean | null;
  /** 大家怎么称呼你（AUTH-CONTACT E0-d：建号以后改称呼） */
  display_name?: string | null;
  generated_photos: boolean | null;
  pet_messages: boolean | null;
  /** IANA 时区名，例如 Asia/Hong_Kong；前端可取浏览器时区 */
  timezone: string | null;
  public_posts: boolean | null;
  profile_visibility: string | null;
  bio: string | null;
}
export type SettingsUpdateInput = WithOptional<SettingsUpdate, "model_replies" | "display_name" | "generated_photos" | "pet_messages" | "timezone" | "public_posts" | "profile_visibility" | "bio">;

/** 此刻每一项对家人以外开到哪一档；逐项与真实读取端同一套判定（app/web_social/audience.py）。 */
export interface EffectiveAudience {
  /** 完整主页（简介、头像）：/public/pets/{id} 与 /pets/{id}/profile */
  profile_page: AudienceScope;
  /** 名片（名字、物种、计数）：主页不对你开时，/pets/{id}/profile 只给这些 */
  profile_card: AudienceScope;
  /** 照片原图：/media/pets/{id}/photo 与 /public/media/pets/{id}/photo；没有照片为空 */
  photo: AudienceScope | null;
  /** 到访动态与配图：/public/pets/{id}/posts、/public/world */
  posts: AudienceScope;
  warnings: AudienceWarning[];
}
export type EffectiveAudienceInput = WithOptional<EffectiveAudience, "photo" | "warnings">;

export interface HomeTransition {
  from_room: HomeRoom;
  from_anchor: string;
  to_room: HomeRoom;
  to_anchor: string;
  starts_at: IsoDateTime;
  ends_at: IsoDateTime;
}
export type HomeTransitionInput = HomeTransition;

/** TA 在家里的哪儿：世界规则的结果（`basis=world_rule`），不是真实观测。**前端只读，切房间不改它。** */
export interface HomePosition {
  room: HomeRoom;
  anchor: string;
  slot: number;
  since: IsoDateTime | null;
  transition: HomeTransition | null;
  layout_version: number;
  rule_version: string;
  basis: string;
}
export type HomePositionInput = WithOptional<HomePosition, "slot" | "since" | "transition" | "basis">;

export interface HomeActivityDetail {
  kind: HomeActivityDetailKind;
  activity_id: string;
  /** 世界线激活这一段的时刻（不是计划开始；没做成的段不会出现在这里） */
  since: IsoDateTime;
  /** 这一段计划结束的时刻 */
  until: IsoDateTime;
  /** 生活选择（LIFE-CHOICE）排的那一段才有：这段具体是什么，例如 phone:album＝翻这趟旅行的照片；照作息排的为 null */
  detail_kind?: string | null;
  /** 生活选择的理由短句（服务端按已提交的事实套模板，例如「刚旅行回来，翻翻这趟的照片」）；照作息排的、照习惯歇着的为 null */
  reason?: string | null;
  /** 此刻显示成什么（唯一口径：小窝画面和私聊里「在做什么」都照它说）。有画面的活动原样；没有画面的（看电视、玩手机、这只宠物缺吃饭姿态时的吃饭）一律为 rest＝在屋里歇着；姿态补齐后自动变回。kind 的意思不变 */
  display_kind?: HomeDisplayKind;
}
export type HomeActivityDetailInput = WithOptional<HomeActivityDetail, "detail_kind" | "reason" | "display_kind">;

export interface HomeActivity {
  kind: HomeActivityKind;
  since: IsoDateTime | null;
  until: IsoDateTime | null;
  /** L2 居家日程：TA 此刻正在做的那一段。只在醒着（kind=awake）时下发；睡觉仍由 kind=sleeping 表达；开关关着、空档里、到家那 60 秒都为 null。外层 kind／since／until 的意思不变 */
  detail?: HomeActivityDetail | null;
}
export type HomeActivityInput = WithOptional<HomeActivity, "since" | "until" | "detail">;

/** L2-0：TA 此刻在家里在哪、在做什么、作息如何（`/home` 与 `/world/state` 读同一个投影 `home_life`）。 */
export interface HomeLife {
  activity: HomeActivity;
  position: HomePosition | null;
  rhythm: HomeRhythm | null;
}
export type HomeLifeInput = WithOptional<HomeLife, "position" | "rhythm">;

export interface HouseholdPetBrief {
  pet_id: string;
  name: string;
  species: PetSpecies;
  photo_url: string | null;
  origin: PetOrigin;
  presence: PetPresence;
  join_step: PetJoinStep;
  joined_at: IsoDateTime;
  added_by_you: boolean;
  /** 照片是没照片时生成的形象照（换照片的确认文案据此区分；玩家页不显示 AI 字样，用户 09-29） */
  photo_generated?: boolean;
  /** 此刻这张照片的版本（没有照片为 null）。换照片时作为 replace_version 带上：先请主人确认、只上传一次（2026-09-25） */
  photo_version?: string | null;
  /** 在外面时这一趟计划到家的时间（领养了在外面的居民、入住后这一趟回来直接回新家时，就是到新家的时间）；在家、或已过点还没结算完时为 null。入住回包里据此区分「TA 还在路上」与「到家了」（2026-09-25） */
  back_at?: IsoDateTime | null;
  /** TA 此刻在家里在哪、在做什么、作息（L2-0）；还没入住为 null。前端只读：画在哪个房间只看 life.position.room，姿态只看 life.activity.kind */
  life?: HomeLife | null;
  /** 身份头像（D4，家人视角）：官方形象 → 真照 → 基准照 → 占位。换照片流程仍按 photo_url／photo_version，不读它 */
  identity?: PetIdentityImage | null;
}
export type HouseholdPetBriefInput = WithOptional<HouseholdPetBrief, "photo_url" | "added_by_you" | "photo_generated" | "photo_version" | "back_at" | "life" | "identity">;

export interface HouseholdBrief {
  household_id: string;
  name: string | null;
  home_id: string;
  /** 你在这个家庭里的角色 */
  role: HouseholdRole;
  home_activated: boolean;
  member_count: number;
  pets: HouseholdPetBrief[];
}
export type HouseholdBriefInput = WithOptional<HouseholdBrief, "name" | "pets">;

export interface HouseholdMember {
  user_id: string;
  display_name: string;
  role: HouseholdRole;
  joined_at: IsoDateTime;
  is_you: boolean;
}
export type HouseholdMemberInput = WithOptional<HouseholdMember, "is_you">;

export interface HouseholdSettings {
  name: string | null;
  /** 共同照顾者能否使用宠物的星球账户（出发旅费等） */
  caregivers_can_spend: boolean;
  /** 宠物自己的旅途照片是否生成写实照片（付费生图，由家庭管理员决定） */
  generated_photos: boolean;
  /** 宠物是否主动把生活里发生的事发到家庭频道 */
  pet_messages: boolean;
  /** 宠物的旅行到访是否生成公开动态 */
  public_posts: boolean;
}
export type HouseholdSettingsInput = WithOptional<HouseholdSettings, "name">;

export interface HouseholdDetail {
  household: HouseholdBrief;
  members: HouseholdMember[];
  settings: HouseholdSettings;
  /** view / care / spend / manage */
  your_permissions: string[];
  version: number;
}
export type HouseholdDetailInput = HouseholdDetail;

export interface HouseholdSettingsRequest {
  name: string | null;
  caregivers_can_spend: boolean | null;
  generated_photos: boolean | null;
  pet_messages: boolean | null;
  public_posts: boolean | null;
}
export type HouseholdSettingsRequestInput = WithOptional<HouseholdSettingsRequest, "name" | "caregivers_can_spend" | "generated_photos" | "pet_messages" | "public_posts">;

export interface MemberRoleRequest {
  role: HouseholdRole;
}
export type MemberRoleRequestInput = MemberRoleRequest;

export interface HouseholdInvite {
  invite_id: string;
  household_id: string;
  role: HouseholdRole;
  /** 邀请人写的称呼提示，例如“妈妈”；只是称呼，不带权限 */
  relation_hint: string | null;
  status: InviteStatus;
  created_at: IsoDateTime;
  expires_at: IsoDateTime;
  accepted_at: IsoDateTime | null;
}
export type HouseholdInviteInput = WithOptional<HouseholdInvite, "relation_hint" | "accepted_at">;

export interface InviteCreateRequest {
  role: HouseholdRole;
  relation_hint: string | null;
  ttl_hours: number;
}
export type InviteCreateRequestInput = WithOptional<InviteCreateRequest, "role" | "relation_hint" | "ttl_hours">;

export interface InviteCreated {
  invite: HouseholdInvite;
  /** 邀请令牌：只在创建时返回一次，服务端只保存摘要 */
  token: string;
  /** 前端的邀请直达路径，例如 /join?invite=<令牌> */
  join_path: string;
}
export type InviteCreatedInput = InviteCreated;

export interface InviteTokenRequest {
  token: string;
}
export type InviteTokenRequestInput = InviteTokenRequest;

/** 接受邀请前能看到的最少信息：家庭名、邀请人称呼、角色、宠物名字。不含私人资料。 */
export interface InvitePreview {
  invite_id: string;
  status: InviteStatus;
  role: HouseholdRole;
  relation_hint: string | null;
  expires_at: IsoDateTime;
  household_name: string | null;
  inviter_name: string;
  pet_names: string[];
  already_member: boolean;
}
export type InvitePreviewInput = WithOptional<InvitePreview, "relation_hint" | "household_name" | "pet_names" | "already_member">;

export interface PetRelationship {
  pet_id: string;
  /** TA 怎么称呼你（只属于你和 TA 之间） */
  owner_title: string | null;
  /** 你和 TA 的关系称呼；不影响权限 */
  relation_label: string | null;
  updated_at: IsoDateTime | null;
}
export type PetRelationshipInput = WithOptional<PetRelationship, "owner_title" | "relation_label" | "updated_at">;

export interface PetRelationshipRequest {
  owner_title: string | null;
  relation_label: string | null;
}
export type PetRelationshipRequestInput = WithOptional<PetRelationshipRequest, "owner_title" | "relation_label">;

/** 注册时带上的入口：先逛逛 / 接我的宠物入住 / 认识新伙伴（注册前选中的伙伴）/ 家庭邀请直达。只记下来，登录后由用户确认。 */
export interface EntryIntentRequest {
  kind: EntryKind;
  /** kind=adopt：注册前在访客页选中的待领养伙伴 */
  pet_id: string | null;
  /** kind=invite：邀请令牌（只用来找到邀请，不保存原文） */
  invite_token: string | null;
}
export type EntryIntentRequestInput = WithOptional<EntryIntentRequest, "pet_id" | "invite_token">;

export interface PendingAdoption {
  pet_id: string;
  name: string;
  species: PetSpecies;
  /** 重新校验后的可领养状态；已被别的家庭领养时为 false */
  available: boolean;
}
export type PendingAdoptionInput = PendingAdoption;

export interface EntryIntentView {
  kind: EntryKind;
  pending_adoption: PendingAdoption | null;
  pending_invite: InvitePreview | null;
  created_at: IsoDateTime;
}
export type EntryIntentViewInput = WithOptional<EntryIntentView, "pending_adoption" | "pending_invite">;

/** 给已有家庭添一只宠物（家庭管理员）。上传用 multipart 的 /pets（带 household_id 查询参数），领养用 /adoption/adopt。 */
export interface AddPetRequest {
  household_id: string;
}
export type AddPetRequestInput = AddPetRequest;

/** 这位查看者此刻该看到的身份图（首选、退路、占位）。都是事实字段，不含运营原因、员工号或素材库备注。 */
export interface PetIdentityImage {
  /** 首选身份图的地址；这位查看者看不到（主页非公开、非家人）或链上什么都没有时为 null。官方形象一律是带版本的公开地址 `/api/v1/web/public/identity/{pet_id}/official/{revision}`（普通下架照常能读、撤回使用权 404） */
  url: string | null;
  /** 首选图的来源；url 为 null 时为 null */
  source_kind: IdentitySourceKind | null;
  /** 首选图是不是 AI 生成：只按素材真实来源——官方形象看素材库登记的来源（ai_generated 才为真），真照为假，基准照／随仓原创形象为真。玩家页不显示 AI 字样（用户 09-29），数据保留给运营后台与以后恢复 */
  ai_generated: boolean;
  /** 不透明版本串，只用于比相等（官方形象 "o<版本号>"，照片是 photo_version）；换了图就变 */
  version: string | null;
  /** 这只宠物有官方形象引用时它此刻的状态（usable／revoked／missing）；没有官方形象为 null。revoked 时首选已经退到下一级，页面可如实说明「官方形象暂时不可用」 */
  official_state: IdentityAssetState | null;
  /** 链上的下一级（首选打不开时用，比如缓存期内被撤回、网络错误）；没有为 null */
  fallback_url: string | null;
  fallback_source_kind: IdentitySourceKind | null;
  fallback_ai_generated: boolean;
  /** 都打不开时画什么：原创居民出身的画物种插画（读屏说明不是本人照片），其余画爪印 */
  placeholder: IdentityPlaceholder;
  /** 出身是平台居民（待领养居民或平台原创角色；领养前后都为真）。pet_id 本身领养前后不变，不另设 resident_id */
  platform_resident: boolean;
}
export type PetIdentityImageInput = WithOptional<PetIdentityImage, "url" | "source_kind" | "ai_generated" | "version" | "official_state" | "fallback_url" | "fallback_source_kind" | "fallback_ai_generated" | "placeholder" | "platform_resident">;

/** 只发给归属主人。owner_title 只在主人确认后出现，缺省不代表主人说过。 */
export interface PetPrivateSummary {
  pet_id: string;
  home_id: string | null;
  name: string;
  species: PetSpecies;
  photo_url: string | null;
  origin: PetOrigin;
  owner_title: string | null;
  presence: PetPresence;
  /** 照片是生成的写实证件照（没有主人上传的照片时）。玩家页不显示 AI 字样（用户 09-29），数据保留给运营后台与以后恢复 */
  photo_generated?: boolean;
  /** 此刻这张照片的版本（没有照片为 null）。换照片时作为 `replace_version` 原样带回；photo_url 的 ?v= 也是它（2026-09-25） */
  photo_version?: string | null;
  /** 身份图（D4）：服务端按首选链与查看者给的首选图、来源、是否 AI 生成、版本、退路与占位。新前端读它，不再按来历推断 AI */
  identity?: PetIdentityImage | null;
}
export type PetPrivateSummaryInput = WithOptional<PetPrivateSummary, "home_id" | "photo_url" | "owner_title" | "photo_generated" | "photo_version" | "identity">;

/** 公开主页投影：不含主人私密资料、接待原文或饮食限制。计数来自已执行动作。 */
export interface PetPublicProfile {
  pet_id: string;
  display_name: string;
  species: PetSpecies;
  /** 头像地址，与 identity.url 同值（D4）；新前端读 identity */
  avatar_url: string | null;
  bio: string | null;
  origin_label: string | null;
  visibility: ProfileVisibility;
  follower_count: number;
  post_count: number;
  /** 当前查看者的宠物是否已关注 TA */
  viewer_follows: boolean;
  /** 看的人自家哪几只宠物关注了 TA（家里的顺序；FOLLOW-AS-PET-01-B）；取消关注时以其中那只的身份发 as_pet_id。只列自家的，匿名或没有宠物时为空 */
  viewer_following_pet_ids?: string[];
  /** 是否是查看者自己的宠物 */
  is_own: boolean;
  data_origin: DataOrigin;
  /** 身份图（D4）：服务端按首选链与查看者给的首选图、来源、是否 AI 生成、版本、退路与占位。新前端读它，不再按来历推断 AI */
  identity?: PetIdentityImage | null;
  /** 来历（自己的宠物／原创伙伴／真实原型档案），与 origin_label 同一个事实（D4） */
  origin?: PetOrigin | null;
}
export type PetPublicProfileInput = WithOptional<PetPublicProfile, "avatar_url" | "bio" | "origin_label" | "follower_count" | "post_count" | "viewer_follows" | "viewer_following_pet_ids" | "is_own" | "identity" | "origin">;

/** 「仅关注者」主页给已登录、没被拉黑、还没关注的人看的最小名片（PRIV-D8，用户 10-09 选 c84a 方案 A；I 定单独建模型）。 */
export interface PetMinimalCard {
  /** 与完整主页区分：GET /pets/{id}/profile 回这张卡时恒为 minimal_card */
  kind: "minimal_card";
  pet_id: string;
  display_name: string;
  species: PetSpecies;
  /** 当前查看者的宠物是否已关注 TA（关注按钮用） */
  viewer_follows: boolean;
  /** 看的人自家哪几只宠物关注了 TA（家里的顺序）；取消关注时以其中那只的身份发 as_pet_id。只列自家的，没有宠物时为空 */
  viewer_following_pet_ids?: string[];
}
export type PetMinimalCardInput = WithOptional<PetMinimalCard, "kind" | "viewer_follows" | "viewer_following_pet_ids">;

/** 领养卡：先讲名字/性格/梦想；真实背景可展开；来源未知保持未知。 */
export interface AdoptionCandidate {
  candidate_id: string;
  name: string;
  species: PetSpecies;
  personality: string;
  dream: string;
  origin: PetOrigin;
  /** 来源说明；未知则为 null，不编造 */
  source_note: string | null;
  background_available: boolean;
  availability: AdoptionAvailability;
  data_origin: DataOrigin;
  /** 已经在星球上生活的待领养居民的稳定 pet_id（领养后不变）；可用它看 TA 的公开生活 */
  pet_id?: string | null;
  /** 领养前住在哪（星球居民驿站·片区；世界规则提供食宿，不编造人类主人） */
  residence?: string | null;
  /** 从什么时候开始在星球上公开生活 */
  living_since?: IsoDateTime | null;
  /** TA 的形象（访客也打得开的地址）；只在仍可领养时给，没有为 null。与 identity.url 同值（D4）：设了官方形象时是它（看 official_avatar），否则是原来那张照片；平台原创居民的照片是生成的原创设计，不是真实照片 */
  photo_url?: string | null;
  /** 还在星球上生活的居民此刻在哪（与公开居民同一个口径）；不在外面就能领养后马上入住。没有 pet_id 的候选为 null（2026-09-25） */
  presence?: PetPresence | null;
  /** 在外面时这一趟计划回到驿站的时间（领养后要等 TA 回到驿站才能入住）；在驿站、或已过点还没结算完时为 null（2026-09-25） */
  back_at?: IsoDateTime | null;
  /** photo_url 是不是平台的官方形象（D4，与 PublicResident.official_avatar 同一条规则）。为 true 时读屏说「{名字}的官方形象」，AI 来源看 identity.ai_generated，不按来历推断；玩家页不显示 AI 字样（用户 09-29） */
  official_avatar?: boolean;
  /** photo_url 是官方形象时，TA 原来那张照片（打不开官方形象时退回用它；再打不开画物种插画）。不是官方形象、或原来没有照片时为 null */
  fallback_avatar_url?: string | null;
  /** 身份图（D4，只在仍可领养时给）：服务端按首选链与查看者给的首选图、来源、是否 AI 生成、版本、退路与占位。新前端读它，不再按来历推断 AI */
  identity?: PetIdentityImage | null;
}
export type AdoptionCandidateInput = WithOptional<AdoptionCandidate, "source_note" | "background_available" | "pet_id" | "residence" | "living_since" | "photo_url" | "presence" | "back_at" | "official_avatar" | "fallback_avatar_url" | "identity">;

/** 需 Idempotency-Key；服务端原子占用，两个家庭抢同一候选最多一个成功（409 ADOPTION_TAKEN）。 */
export interface AdoptRequest {
  candidate_id: string;
  /** 领养进已有的家庭（需要是这个家庭的管理员）；不给则新建家庭 */
  household_id?: string | null;
}
export type AdoptRequestInput = WithOptional<AdoptRequest, "household_id">;

export interface AdoptResult {
  pet_id: string;
  candidate_id: string;
  adopted_at: IsoDateTime;
  /** PRIV-FOLLOW-02（c84a REQ17 CR3）：领养完成后这只宠物主页的范围。新领养一律先只给家人看，要公开请主人自己去设置里改；动态公开另在入住时选 */
  profile_visibility?: ProfileVisibility;
}
export type AdoptResultInput = WithOptional<AdoptResult, "profile_visibility">;

/** 宠物 DNA：主人描述、确认的性格与习惯。模型扮演宠物时读取；私密字段只用于私信，不进公开动态。 */
export interface PetDNA {
  /** TA 怎么称呼主人 */
  owner_title: string | null;
  /** 主人叫 TA 的小名 */
  nicknames: string[];
  /** 性格 */
  personality: string | null;
  /** 说话的样子，例如“慢吞吞、爱撒娇” */
  voice_style: string | null;
  /** 口头禅或常发出的声音 */
  catchphrase: string | null;
  favorite_foods: string[];
  favorite_places: string[];
  hobbies: string[];
  /** 小习惯 */
  habits: string[];
  /** 害怕的东西 */
  fears: string[];
  /** 和主人之间的小暗号、趣事；只在私信里使用 */
  shared_memories: string[];
}
export type PetDNAInput = WithOptional<PetDNA, "owner_title" | "nicknames" | "personality" | "voice_style" | "catchphrase" | "favorite_foods" | "favorite_places" | "hobbies" | "habits" | "fears" | "shared_memories">;

/** 一条原话出处：DNA 哪一栏、原话中的哪一小句（原样，不改写）、被怎样理解。 */
export interface BehaviorEvidence {
  /** personality / voice_style / catchphrase / habits / hobbies / favorite_places / favorite_foods / fears / dream / note（接待叮嘱） */
  field: string;
  /** 栏目中文名，例如“性格”“小习惯”“接待时的叮嘱” */
  field_label: string;
  /** 原话中的那一小句 */
  phrase: string;
  /** positive 肯定 / negative 被否定 / averse 讨厌或害怕 / uncertain 说不准 */
  polarity: BehaviorPolarity;
  /** 为什么这样理解，例如“‘不’否定了这个说法”“‘偶尔’：说法不确定，暂不归类” */
  note: string | null;
  /** 由别的说法反推（例如“不爱热闹”→ 偏安静），单独不足以归类 */
  implied: boolean;
}
export type BehaviorEvidenceInput = WithOptional<BehaviorEvidence, "note" | "implied">;

export interface BehaviorTrait {
  /** night_owl / early_bird / sleepy / social / homebody / curious / diligent / playful */
  key: string;
  label: string;
  /** applied 用上了 / negated 明确说不是 / outweighed 被更明确的相反说法盖过 / uncertain 说不准，暂不归类 */
  status: BehaviorTraitStatus;
  evidence: BehaviorEvidence[];
}
export type BehaviorTraitInput = WithOptional<BehaviorTrait, "evidence">;

export interface BehaviorPreference {
  /** job:<岗位> / route:local:stroll / route:local:cafe / route:local:city_trip / route:long */
  key: string;
  label: string;
  /** 选择时的倍数：>1 更愿意，<1 不太愿意，1 照常 */
  weight: number;
  evidence: BehaviorEvidence[];
  /** 来自性格的调整，例如“恋家：更爱在附近走走” */
  notes: string[];
}
export type BehaviorPreferenceInput = WithOptional<BehaviorPreference, "evidence" | "notes">;

/** 由 DNA 原话整理出的行为倾向（服务端确定性规则，不调用模型）；只给主人看。 */
export interface PetBehavior {
  rules_version: string;
  rhythm: PetRhythm;
  /** 入睡时间（TA 所在地当地时间，HH:MM） */
  sleep_start: string;
  /** 起床时间（HH:MM） */
  wake: string;
  sociability: PetSociability;
  curious: boolean;
  /** 一天最多自己出门几次 */
  outings_per_day: number;
  /** 一天主动找主人说话的次数 */
  chattiness: number;
  /** 学东西的快慢（驾考陪练与自学的倍数） */
  learn_rate: number;
  /** 一句话结论，例如“不爱熬夜：按平常作息（23:30 睡，07:30 起）” */
  summary: string[];
  /** 提到过的性格与作息特征（含被否定、被盖过和说不准的） */
  traits: BehaviorTrait[];
  /** 工作与路线倾向 */
  preferences: BehaviorPreference[];
  /** 提到了但说不准或前后矛盾、没有归类的原话 */
  unclassified: string[];
  /** 这次用到了哪些栏目 */
  sources: string[];
}
export type PetBehaviorInput = WithOptional<PetBehavior, "summary" | "traits" | "preferences" | "unclassified" | "sources">;

export interface PetDNAView {
  pet_id: string;
  dna: PetDNA;
  /** 主人是否已保存确认；未确认时为系统整理的草稿 */
  confirmed: boolean;
  /** 草稿来源：adoption_profile / owner_bio / reception_notes */
  draft_sources: string[];
  updated_at: IsoDateTime | null;
  /** 只用于私信、不进公开内容的字段 */
  private_fields: string[];
  /** 由这份 DNA 整理出的行为倾向与原话出处（0.2.5 追加） */
  behavior?: PetBehavior | null;
  /** 全家共用那部分 DNA 的版本号；保存时带 ?expected_version= 可防止无声覆盖家人的修改（冲突 409） */
  version?: number | null;
  /** 每位家人各自的一份（TA 怎么称呼你、你们之间的小暗号），别的家人看不到也不会被覆盖 */
  personal_fields?: string[];
  /** 共用部分最后一次是不是你改的 */
  updated_by_you?: boolean | null;
}
export type PetDNAViewInput = WithOptional<PetDNAView, "draft_sources" | "updated_at" | "private_fields" | "behavior" | "version" | "personal_fields" | "updated_by_you">;

/** 主人说「给我拍一张」。 */
export interface PhotoRequestCommand {
  scene: PhotoScene;
  /** flight_adventure 必须显式传 fictional_adventure；其余场景只接受 daily_life */
  narrative: PhotoNarrative;
}
export type PhotoRequestCommandInput = WithOptional<PhotoRequestCommand, "narrative">;

/** 受理结果。**不代表照片已经画好**，也不代表一定画得出来。 */
export interface PhotoRequestResult {
  /** 这次摄影请求的稳定标识，用它去只读查询里找结果、或发起重画 */
  request_id: string;
  /** 排上队的生图任务。为空的情况只有一种：这个环境没配生图供应商、或主人没开「生成照片」，于是命令受理了但没有排队。重复请求**不会**让它为空——那会原样返回第一次的任务号。 */
  task_id: string | null;
  scene: PhotoScene;
  narrative: PhotoNarrative;
  /** 真值表示这是主人选的虚构主题：不会写成真实出行、不扣旅费、不发勋章 */
  fictional: boolean;
  /** 按 TA **此刻所在城市**换算的拍摄时刻；途中用当前所在地，不是出发地 */
  captured_at: IsoDateTime;
  /** 这一刻 TA 在哪（家 / 车上 / 虚构主题的场景），只作展示 */
  place: string;
  city: string;
}
export type PhotoRequestResultInput = WithOptional<PhotoRequestResult, "task_id">;

/** 主人主动拍的那些照片，现在各是什么样。**纯读**：读它不会驱动任何任务，也不会发起任何调用。 */
export interface PhotoRequestView {
  request_id: string;
  task_id: string | null;
  scene: PhotoScene;
  narrative: PhotoNarrative;
  fictional: boolean;
  captured_at: IsoDateTime;
  place: string;
  city: string;
  /** processing＝还在画；ready＝画好了；failed＝确定没画成；**unknown＝结果还没确认**（可能已经发出、甚至已经计费），页面要显示成「还没确认」并给重画入口，不能写成「没画成」 */
  photo_status: PhotoStatus;
  /** 画好了才有；其余状态一律为空 */
  image_url: string | null;
  /** 能不能点「重画」：failed 与 unknown 可以，processing / ready 不行 */
  can_retry: boolean;
}
export type PhotoRequestViewInput = WithOptional<PhotoRequestView, "task_id" | "image_url">;

/** `body_info_needed` 的细节：补哪一组的哪几个部位就能画全身（BODY-0 §11.4、§11.6 的组名与部位编号）。 */
export interface CharacterReasonDetails {
  /** limbs／tails／ears／wings */
  group: string;
  /** 这一组里还不知道的部位编号，如 limb_fl */
  part_ids: string[];
}
export type CharacterReasonDetailsInput = CharacterReasonDetails;

/** 非透明内容在画布里的实际边界（像素，左上原点）。 */
export interface ContentBox {
  left: number;
  top: number;
  right: number;
  bottom: number;
}
export type ContentBoxInput = ContentBox;

/** 落地点：角色"脚踩在哪里"，相对画布的归一化坐标。 */
export interface GroundAnchor {
  x: number;
  y: number;
  /** True＝从图像实测；False＝导演给的估计值 */
  measured: boolean;
}
export type GroundAnchorInput = WithOptional<GroundAnchor, "measured">;

/** 家用整套共用的画布（像素）：home-set/1 是 768×512。 */
export interface CharacterHomeCanvas {
  width: number;
  height: number;
}
export type CharacterHomeCanvasInput = CharacterHomeCanvas;

/** 整套画布基准点（按画布比例）：站姿母版的接地测点。整块画布对准地面上这一点，不逐张平移。 */
export interface CharacterHomeDatum {
  x: number;
  y: number;
}
export type CharacterHomeDatumInput = CharacterHomeDatum;

/** 家用整套母版的落位（MULTI-POSE-AVATAR-117，m2685）：一套一块画布、一个比例（站姿主体高 320）、一个 datum。 */
export interface CharacterHomeLayout {
  /** 落位规则的版本，本版 home-set/1；不认识的版本当静态图用，不拼进动作 */
  version: string;
  canvas: CharacterHomeCanvas;
  datum: CharacterHomeDatum;
  /** 接地怎么量：paws 量最低接地带（斜前视角是前爪），body 量身体（蜷睡这类脚被挡住的） */
  basis: string;
}
export type CharacterHomeLayoutInput = CharacterHomeLayout;

/** 接地测点：按画布宽高换成比例后乘一百万取整（规范式里不许有小数）。 */
export interface CharacterContactPoint {
  x: number;
  y: number;
}
export type CharacterContactPointInput = CharacterContactPoint;

/** 一张母版的接地记录（contact-band/1，字段与 web_character/contact.record 一一对应）。只做校验，不用来平移落位。 */
export interface CharacterGroundContact {
  method: string;
  /** ok；量不出时 no_contact、fragmented 等，不给测点 */
  status: string;
  basis: string;
  seed: string;
  canvas: CharacterHomeCanvas;
  point: CharacterContactPoint | null;
  floor_row: number | null;
  segments: number[][];
}
export type CharacterGroundContactInput = CharacterGroundContact;

/** 一张姿态图。URL **受权限保护**，不是公开静态资源。 */
export interface CharacterAsset {
  asset_id: string;
  pose: CharacterPose;
  /** 受权限保护的读取地址；越权读会被挡下，不是 CDN 直链 */
  url: string;
  /** 图片字节的 SHA-256；用于证明前端拿到的就是这一版 */
  content_sha256: string;
  /** 实际的图片 MIME，例如 image/png */
  content_type: string;
  width: number;
  height: number;
  content_box: ContentBox;
  anchor: GroundAnchor;
  /** 不透明像素占整张画布的比例。`has_alpha` 只说通道在不在，这个说主体有多大——接近 1 基本就是一张不透明的方图（背景没抠掉），接近 0 则可能主体被裁没了。 */
  opaque_ratio: number;
  /** 实际验证过的 alpha 通道可用性。**不得因为返回的是 PNG 就填 True**——PNG 可以完全不透明，当前 GPT 适配器也没有请求或验收透明背景。 */
  has_alpha: boolean;
  /** 家用整套的母版才有：整套共用一块画布、同一比例、datum 落位，换姿态不跳不缩放；中性形象与旧姿态为 null */
  layout?: CharacterHomeLayout | null;
  /** 家用整套的母版才有：这一张的接地记录（只做校验，不用来平移落位）；中性形象与旧姿态为 null */
  contact?: CharacterGroundContact | null;
}
export type CharacterAssetInput = WithOptional<CharacterAsset, "layout" | "contact">;

/** 家用整套一张姿态表的进度（MULTI-POSE-AVATAR-117）：一张表一次出图出 5 个母版，一张表为一套，过一张用一张。 */
export interface CharacterSheetProgress {
  /** S1–S4（S1 是家里最常用的趴、睡、吃、喝、被摸） */
  sheet_key: string;
  status: CharacterStatus;
  /** 不生效的原因码（出图链路的码或姿态表自己的校验码）；不给主人看 */
  reason: string | null;
  /** 这一张出的 5 个母版 */
  poses: CharacterPose[];
  /** 平台自动重画过几次（校验不过时重画一次） */
  redraws: number;
}
export type CharacterSheetProgressInput = WithOptional<CharacterSheetProgress, "reason">;

/** 一套已发布的角色资产。同一 `character_set_id` 内各姿态外貌必须一致。 */
export interface CharacterSet {
  character_set_id: string;
  pet_id: string;
  /** 同一只宠物的第几套；过期任务不得覆盖更高的 revision */
  revision: number;
  /** 生成时所用身份参考（原照）的版本。**换参考后旧结果不得发布**，靠这个比。 */
  reference_version: number;
  /** 画风版本；换风格要能解释形象为何变了 */
  style_version: string;
  assets: CharacterAsset[];
  published_at: IsoDateTime;
  /** 照着换掉之前那张照片画的；可以自己点重画（`POST …/character/regenerate`，走现有额度）。原样保留、不自动重画（读时现算：这一套依据的原照 ≠ 此刻的照片）。新的一版在建时仍为 true，直到它生效 */
  outdated?: boolean;
}
export type CharacterSetInput = WithOptional<CharacterSet, "outdated">;

/** 本次在建的那一套。它失败不影响 `active` 继续显示。 */
export interface CharacterCandidate {
  status: CharacterStatus;
  pose: CharacterPose;
  reference_version: number;
  style_version: string;
  queued_at: IsoDateTime;
  /** 未获授权、额度不足、供应商失败等**如实写原因**；不要把 unknown 的原因写成「没生成」。 */
  reason: string | null;
  /** 对应的后台任务；没有任务时为 null */
  task_id: string | null;
}
export type CharacterCandidateInput = WithOptional<CharacterCandidate, "reason" | "task_id">;

/** active 那一套里**一个额外姿态**的进度（批次二）。中性站姿不在这里——它的状态就是 `CharacterState.status`。 */
export interface CharacterPoseProgress {
  pose: CharacterPose;
  status: CharacterStatus;
  /** 没画成或作废的原因，码表同 `CharacterReason` */
  reason: string | null;
  /** 对应的后台任务 */
  task_id: string | null;
  /** waiting_quota＝额度回来后会只补这一张；exhausted＝暂时补不上；None＝不会自动补 */
  backfill: CharacterPoseBackfill | null;
}
export type CharacterPoseProgressInput = WithOptional<CharacterPoseProgress, "reason" | "task_id" | "backfill">;

/** 每只宠物一张证件照（CR-6C2B-IDPHOTO）：护照、居民证、驾照等全部证件都用它。**不透明**，所以不是一种姿态。 */
export interface CharacterIdPhoto {
  /** 与角色同一口径；`unknown` 是可能已经发出、结果没确认，不得说成没画成 */
  status: CharacterStatus;
  /** `absent` 时为 null */
  source: IdPhotoSource | null;
  /** 证件用图（竖幅 3:4、浅蓝纯底）的受保护地址；没有生效的证件照时为 null */
  url: string | null;
  /** 地图头像：从证件照上方正方形缩成的 **256×256** 小图。**没有就是 null，不拿别的图冒充**（没照片的宠物那张基准照不是裁好的头像，也是 null） */
  avatar_url: string | null;
  width: number | null;
  height: number | null;
  /** 证件用图字节的 SHA-256 */
  content_sha256: string | null;
  /** 依据的是这只宠物的第几张参考照；换了照片才重画 */
  reference_version: number | null;
  revision: number | null;
  /** 没画成或作废的原因，码表同 `CharacterReason` */
  reason: string | null;
  task_id: string | null;
  /** 照着换掉之前那张照片画的。照片一变会**自动**排一轮重画（受自动开关管，用户 2026-09-26 定），进度看 `pending_status`；新的一版生效之前旧的照常显示、仍为 true（这时点重画回 `already_queued`）。只有已生效的那张（`source=generated`）会为 true。自动开关关着时可以自己点重画（`POST …/id-photo/regenerate`，走现有额度）；点不成时 `reason` 说明为什么（服务没配是 `provider_unavailable`） */
  outdated?: boolean;
  /** 已有生效的证件照时，**比它新、还没生效**的那一轮的状态（queued／running／failed／unknown）；没有这样一轮时为 null。`unknown` 同样是可能已经发出、结果没确认，不得说成没画成 */
  pending_status?: CharacterStatus | null;
  /** 那一轮没画成或作废的原因，码表同 `CharacterReason`（例如 `reference_changed`：排上之后照片又换了，这一轮作废、不发送）；没有这样一轮时为 null。服务没配置时根本不排新一轮，这两个字段都是 null */
  pending_reason?: string | null;
}
export type CharacterIdPhotoInput = WithOptional<CharacterIdPhoto, "source" | "url" | "avatar_url" | "width" | "height" | "content_sha256" | "reference_version" | "revision" | "reason" | "task_id" | "outdated" | "pending_status" | "pending_reason">;

/** `GET /pets/{pet_id}/character` 的响应。**纯读，绝不触发生成。** */
export interface CharacterState {
  pet_id: string;
  /** 综合状态：有 candidate 时取它的，否则由 active 是否存在决定 */
  status: CharacterStatus;
  /** 当前生效的一套；从未成功过时为 null */
  active: CharacterSet | null;
  /** 本次在建的；空闲时为 null */
  candidate: CharacterCandidate | null;
  /** 是否允许发起「调整形象」。授权缺失、额度用尽、已有在建任务时为 False，**原因在 candidate.reason 或 blocked_reason 里给**。 */
  can_regenerate: boolean;
  /** can_regenerate 为 False 且没有 candidate 时，这里说明为什么 */
  blocked_reason: string | null;
  /** active 那一套里其余姿态的进度（批次二）。自动生成的开关默认关，关着时为空数组；已就绪的那几张同时出现在 `active.assets` 里 */
  poses?: CharacterPoseProgress[];
  /** 证件照（与形象不同，不透明、有底色）。没有时前端退回 `photo_url` */
  id_photo?: CharacterIdPhoto | null;
  /** candidate.reason 是 body_info_needed 时补哪一组的哪几个部位；读时按此刻的身体档案现算，其余情况为 null */
  reason_details?: CharacterReasonDetails | null;
  /** 到家等待页要等齐的姿态（c84a D0812-1、D0912-1，读时现算）：表达这只宠物的形象到家需要哪几种姿态，不表达系统此刻会不会去画——临时关开关、没配好生图、运营停画都不清空，暂时画不了看 poses 与 blocked_reason。给出集合＝这几种都 ready 才算齐；空数组＝产品上确定不适用（领养的原创居民用官方形象）；null＝说不准（物种或来源读不到、物种没有角色配方、差异体型的适用动作未定），前端不能当空数组放行 */
  required_poses?: CharacterPose[] | null;
  /** active 那一套家用整套每张姿态表的进度（S1→S4）；没开家用整套或还没有生效形象时为空数组。母版陆续到、先进家，缺的姿态不显示 */
  home_set?: CharacterSheetProgress[];
  /** 基础动作就绪（BASIC-PACK-117）：每段一行照实给主人看（UI-2「TA 的小动作」）；没有生效形象、家用整套没接手时为 null，前端不显示这一块 */
  basic_motions?: BasicMotionReadiness | null;
  /** 换了照片以后会不会自动重画证件照：on 会排一轮／off 确定不会／unknown 说不准。任何宠物都有值；证件照从没有过时 id_photo 为 null，这一项照给 */
  id_photo_auto_redraw?: IdPhotoAutoRedraw;
}
export type CharacterStateInput = WithOptional<CharacterState, "active" | "candidate" | "blocked_reason" | "poses" | "id_photo" | "reason_details" | "required_poses" | "home_set" | "basic_motions" | "id_photo_auto_redraw">;

/** 「调整形象」——**可选**操作。正常路径由上传成功自动触发，用户不必点这个。 */
export interface CharacterRegenerateCommand {
  /** **目前一律按整套重做**：先重画中性站姿，其余姿态（开关开着时）随新的一套重新生成——只重画某一个姿态会让它和同套的站姿不再是同一张参考（P 规范 §6-4）。本字段暂不区分取值 */
  pose: CharacterPose;
  /** 主人想调整的地方，可空 */
  note: string | null;
}
export type CharacterRegenerateCommandInput = WithOptional<CharacterRegenerateCommand, "pose" | "note">;

/** 发起结果。`accepted=False` 时 `reason` 必须能解释为什么没排上。 */
export interface CharacterRegenerateResult {
  accepted: boolean;
  status: CharacterStatus;
  task_id: string | null;
  reason: string | null;
}
export type CharacterRegenerateResultInput = WithOptional<CharacterRegenerateResult, "task_id" | "reason">;

/** 主人「再画这个动作」（A-POSE-RETRY-01）。`pose` 不传＝active 那一套里能再画的都排；传了只排那一张。中性站姿不在这条路上（它走「调整形象」整套重做）。 */
export interface CharacterPoseRetryCommand {
  pose: CharacterPose | null;
}
export type CharacterPoseRetryCommandInput = WithOptional<CharacterPoseRetryCommand, "pose">;

export interface CharacterPoseRetryItem {
  pose: CharacterPose;
  result: CharacterPoseRetryOutcome;
}
export type CharacterPoseRetryItemInput = CharacterPoseRetryItem;

/** 按 active 那一套的姿态顺序，每张一条。没有 active 的一套时为空。 */
export interface CharacterPoseRetryResult {
  poses: CharacterPoseRetryItem[];
}
export type CharacterPoseRetryResultInput = CharacterPoseRetryResult;

/** 只引用、不含原话。ref：confirmed_note → 本人自己的 note_id；dna → "dna"；species_default → "species:<物种>"。 */
export interface InteractionSourceRef {
  kind: InteractionSourceKind;
  ref: string;
  /** note 的版本／共用 DNA 的版本号／规则版本；DNA 从没保存过为 unknown */
  version: string;
}
export type InteractionSourceRefInput = InteractionSourceRef;

export interface InteractionDimension {
  value: InteractionLevel;
  sources: InteractionSourceRef[];
}
export type InteractionDimensionInput = WithOptional<InteractionDimension, "value" | "sources">;

/** 五个维度各自独立（NC-00 P5）：「粘人」「爱热闹」不推出 contact=high，「独立」「胆小」不推出 caution=high。 */
export interface InteractionDimensions {
  approach: InteractionDimension;
  contact: InteractionDimension;
  caution: InteractionDimension;
  play: InteractionDimension;
  quiet: InteractionDimension;
}
export type InteractionDimensionsInput = WithOptional<InteractionDimensions, "approach" | "contact" | "caution" | "play" | "quiet">;

/** 某个部位的偏好：avoid 胜 prefer（P1），两边都有说法时 conflict=true。没说就不在列表里。 */
export interface InteractionPreference {
  part: InteractionPart;
  value: TouchPreferenceValue;
  conflict: boolean;
  sources: InteractionSourceRef[];
}
export type InteractionPreferenceInput = WithOptional<InteractionPreference, "conflict" | "sources">;

/** 一条保留（NC-LIMITS §4）：只带这六个字段——不带原话、叮嘱编号、限制记录编号、提交人、确认人。 */
export interface InteractionHold {
  kind: InteractionHoldKind;
  scope: InteractionScope;
  /** scope=part 时是部位键（不会是 unknown）；whole_body 时为 null */
  part: InteractionPart | null;
  /** 限制记录的类别；来自 DNA 或叮嘱的风险为 null */
  category: InteractionLimitCategory | null;
  source_kind: InteractionHoldSource;
  /** 到期时刻；null＝没写截止（未知），一直有效、不自动解除 */
  valid_until: IsoDateTime | null;
}
export type InteractionHoldInput = WithOptional<InteractionHold, "part" | "category" | "valid_until">;

/** 受权摸摸档案：只给当前宠物、当前登录成员；从没写过偏好也是一份合法档案（全 unknown，D8）。 */
export interface InteractionProfile {
  schema_version: number;
  pet_id: string;
  member_scope: InteractionMemberScope;
  /** 本人条目 note_id@version、共用 DNA 版本、身体版本、限制版本与保留、规则版本的摘要；变了前端取消进行中的接触链 */
  profile_revision: string;
  /** {POLICY_VERSION}:p{privacy_epoch}:m{membership_epoch}；撤回、更正、成员变动后会变 */
  policy_revision: string;
  /** 互动维度规则版本（C 的 touch_profile） */
  rules_version: string;
  /** 身体档案（世界 W）的编号；为 null＝身体未知 */
  body_version: string | null;
  /** 身体档案里在的部位（partial 也算在）；已核缺失的、还不知道的都不列。为 null＝没有身体档案，不等于「什么部位都有」 */
  body_parts: InteractionPart[] | null;
  issued_at: IsoDateTime;
  /** issued_at＋120 秒（D4），有限制在这之前开始或到期时提前到那一刻（到期不写库，靠它让缓存过期）；过期即转中性，客户端不得自行续期（用 serverNow 比） */
  valid_until: IsoDateTime;
  dimensions: InteractionDimensions;
  preferences: InteractionPreference[];
  /** 必须遵守的保留（NC-LIMITS §3、§4）：verified 永不触碰，unconfirmed_risk 这一次对所指部位停止触碰、部位未知按整身；手势与自动动作一视同仁。只进本人档案的：本人待确认的限制、本人叮嘱里的风险 */
  holds?: InteractionHold[];
  /** 宠物级互动限制版本：任何一条限制变了就 +1（到期不变）；与 valid_until 一起判旧 */
  limits_version?: number;
}
export type InteractionProfileInput = WithOptional<InteractionProfile, "schema_version" | "member_scope" | "body_version" | "body_parts" | "dimensions" | "preferences" | "holds" | "limits_version">;

/** 保存一个部位的摸摸偏好（NC-00 §3.2）。需 Idempotency-Key 与 CSRF；只写自己的；一个部位一条，改主意会换新版本。 */
export interface TouchPreferenceRequest {
  part: InteractionPart;
  value: TouchPreferenceValue;
  /** 主人看得懂的一句话（页面按选择生成、主人可改） */
  text: string;
  expected_note_version: number | null;
}
export type TouchPreferenceRequestInput = WithOptional<TouchPreferenceRequest, "expected_note_version">;

/** 一条限制。不带提交人、确认人与撤回原因。 */
export interface InteractionLimitView {
  limit_id: string;
  scope: InteractionScope;
  /** scope=part 时是部位键；whole_body 时为 null */
  part: InteractionPart | null;
  category: InteractionLimitCategory;
  status: InteractionLimitStatus;
  source_kind: InteractionLimitSource;
  starts_at: IsoDateTime;
  /** null＝截止未知：一直有效、不自动解除；到了截止只结束这一条 */
  ends_at: IsoDateTime | null;
  /** 这一条的版本：确认、驳回、修订、撤回时带上它（expected_version） */
  version: number;
  /** 是不是查看者自己提交的 */
  mine: boolean;
}
export type InteractionLimitViewInput = WithOptional<InteractionLimitView, "part" | "ends_at">;

/** 这只宠物的限制：全部已确认的、自己提交的待确认的；家庭管理员另能看到别人提交的待确认的（要由管理员确认或驳回）。 */
export interface InteractionLimitList {
  pet_id: string;
  /** 宠物级版本：提交时带上它（expected_version） */
  limits_version: number;
  limits: InteractionLimitView[];
}
export type InteractionLimitListInput = WithOptional<InteractionLimitList, "limits">;

/** 提交一条（家庭成员）。管理员提交直接是已确认，普通成员提交是待确认、在管理员确认之前只影响提交人本人。 */
export interface InteractionLimitSubmitRequest {
  scope: InteractionScope;
  /** scope=part 时必填（不能是 unknown）；whole_body 时不填 */
  part: InteractionPart | null;
  category: InteractionLimitCategory;
  /** 不填＝从现在开始 */
  starts_at: IsoDateTime | null;
  /** 不填＝截止未知 */
  ends_at: IsoDateTime | null;
  /** 宠物级版本（列表里的 limits_version）；对不上 409 */
  expected_version: number;
}
export type InteractionLimitSubmitRequestInput = WithOptional<InteractionLimitSubmitRequest, "part" | "starts_at" | "ends_at">;

/** 修订部位、类别、起止（管理员改已确认的，改完仍是已确认；提交人本人改自己待确认的）。 */
export interface InteractionLimitReviseRequest {
  scope: InteractionScope;
  part: InteractionPart | null;
  category: InteractionLimitCategory;
  starts_at: IsoDateTime;
  ends_at: IsoDateTime | null;
  /** 这一条的 version；对不上 409 */
  expected_version: number;
}
export type InteractionLimitReviseRequestInput = WithOptional<InteractionLimitReviseRequest, "part" | "ends_at">;

/** 确认、驳回、撤回共用：只带这一条的版本。 */
export interface InteractionLimitDecisionRequest {
  /** 这一条的 version；对不上 409 */
  expected_version: number;
}
export type InteractionLimitDecisionRequestInput = InteractionLimitDecisionRequest;

/** 命令的结果：这一条的新样子与宠物级新版本。 */
export interface InteractionLimitResult {
  limit: InteractionLimitView;
  limits_version: number;
}
export type InteractionLimitResultInput = InteractionLimitResult;

export interface HomePlaceSummary {
  habitat: HabitatKind;
  /** 海边/草原/…… */
  habitat_label: string;
  /** 城市；从没选过城的家为空串（HOME-PLACE-PENDING-117：不给暂住的香港） */
  city: string;
  /** 片区的说法，例如“环岛路附近的海边”；不是具体地址 */
  area_label: string;
  /** 展示用：城市·片区；地址待落定时只到城市；从没选过城的家是「还没选好 TA 住在哪」 */
  display: string;
  /** 家的时区；从没选过城的家为空串 */
  timezone: string;
  /** 主人是否选过城；false＝还没选好住在哪（city、area_label、timezone 为空串，世界不为 TA 推进，出门 409 home_place_unchosen） */
  chosen: boolean;
  /** CITY-01：新入住的家所在城市（amap:<市级 adcode>）；老片区的家为 null */
  city_id?: string | null;
  /** CITY-01 v4：城市定了、地址还在落定（开城中）；这时宠物不出门，落定后自动接上。页面写「新家地址还在落定」 */
  address_pending?: boolean;
  /** 只给本家人看：落在真实小区上时带小区名（城市·区县·小区）；对外、分享一律用 display（只到区县） */
  private_display?: string | null;
}
export type HomePlaceSummaryInput = WithOptional<HomePlaceSummary, "city_id" | "address_pending" | "private_display">;

export interface HabitatOption {
  habitat: HabitatKind;
  label: string;
  /** 可能随机到的城市，例如“厦门、青岛” */
  examples: string[];
  /** 新家现在能不能选这一类（只开放真实交通与地点都已接通的片区；已有的家不受影响） */
  open?: boolean;
  /** 这一类新家现在能选的城市（入住、搬家时 city 只能取这里的值），顺序稳定；不带 city 时分到哪看 default_city，不要拿第一项当缺省；这一类还没开放时为空 */
  cities?: string[];
  /** 不带 city 时分到的城市（旧客户端的缺省，＝香港）；这一类没有开放的香港片区、或者还没开放时为空，这时不带 city 的入住、搬家会被拒（422 habitat_not_supported），要明确选城市 */
  default_city?: string | null;
}
export type HabitatOptionInput = WithOptional<HabitatOption, "examples" | "open" | "cities" | "default_city">;

export interface HomePlaceView {
  place: HomePlaceSummary;
  options: HabitatOption[];
  /** TA 在外面时不能搬家 */
  can_change: boolean;
}
export type HomePlaceViewInput = WithOptional<HomePlaceView, "options">;

/** 选一类地方，可以再指定城市；服务端在对应的开放片区里随机一个，坐标已模糊处理。同一类重复提交保持原地（指定了城市时还要是同一座城市）。 */
export interface HomePlaceRequest {
  habitat: HabitatKind;
  /** 希望搬到哪座城市（城市起点）：只能选这一类开放的城市（见 cities），城市没开放时 422 habitat_not_supported；不带时落在 default_city（香港），这一类没有开放的香港片区时不带 city 也 422；同一类不带城市的重复提交保持原来有效的所在地 */
  city?: string | null;
}
export type HomePlaceRequestInput = WithOptional<HomePlaceRequest, "city">;

export interface WalletSummary {
  /** 唯一游戏币口径 */
  currency: string;
  balance: number;
  updated_at: IsoDateTime | null;
}
export type WalletSummaryInput = WithOptional<WalletSummary, "currency" | "balance" | "updated_at">;

export interface GuardState {
  guarding: boolean;
  basis: GuardBasis;
  /** 主人巡院的守护截止时间（basis=owner_patrol 时） */
  until: IsoDateTime | null;
  /** 下一次可以巡院的时间；为空表示现在就可以 */
  next_patrol_at: IsoDateTime | null;
  /** 此刻在家、醒着、在守菜的宠物（多只一起守效果更好，但不是绝对防偷） */
  guarding_pets?: string[];
}
export type GuardStateInput = WithOptional<GuardState, "until" | "next_patrol_at" | "guarding_pets">;

/** 仓库里的可出售物资（收成、串门摘来的菜）。个人纪念与照片不在这里、不可交易。 */
export interface InventoryItem {
  item_key: string;
  label: string;
  qty: number;
  /** 杂货铺收购价（travel_coin/单位） */
  unit_price: number;
  tradable: boolean;
}
export type InventoryItemInput = WithOptional<InventoryItem, "tradable">;

export interface PlotSummary {
  plot_id: string;
  cycle_id: string | null;
  crop_key: string | null;
  crop_label: string | null;
  stage: PlotStage;
  ripe_at: IsoDateTime | null;
  /** 本批可偷总额（全体访客共享） */
  steal_total: number | null;
  steal_remaining: number | null;
}
export type PlotSummaryInput = WithOptional<PlotSummary, "cycle_id" | "crop_key" | "crop_label" | "ripe_at" | "steal_total" | "steal_remaining">;

/** 需 Idempotency-Key 请求头；同键同请求返回原结果。 */
export interface FarmActionRequest {
  home_id: string;
  plot_id: string;
  cycle_id: string | null;
  action: FarmActionKind;
  crop_key: string | null;
}
export type FarmActionRequestInput = WithOptional<FarmActionRequest, "cycle_id" | "crop_key">;

export interface FarmActionResult {
  plot: PlotSummary;
  wallet: WalletSummary;
  gained_items: string[];
}
export type FarmActionResultInput = WithOptional<FarmActionResult, "gained_items">;

/** 菜园扩建（L4）：下一块能开的地、开垦价、现在能不能开、下一次开垦扣哪只宠物的钱。纯读，读页面不开地。 */
export interface FarmExpansion {
  /** 下一未开地格号（0–7）；已达容量为空 */
  next_slot: number | null;
  /** 开垦价（星币）；还没定价为空，这时开不了 */
  cost: number | null;
  /** 现在能不能开：定了价、还有能开的格、付钱的宠物还在这个家。余额够不够开的时候才核 */
  available: boolean;
  /** 开不了的原因（人话），例如「开垦价还没定」「已经开到最多了」；能开时为空 */
  reason: string | null;
  /** 下一次开垦扣哪只宠物的钱：这个家登记的第一只，不随切换宠物或家里宠物的排列变；没有能开的格、或它已经不在这个家时为空 */
  payer_pet_id?: string | null;
  capacity?: 8;
  slots?: FarmPlanningSlot[];
  currency?: "travel_coin" | null;
  config_version?: string | null;
}
export type FarmExpansionInput = WithOptional<FarmExpansion, "reason" | "payer_pet_id" | "capacity" | "slots" | "currency" | "config_version">;

export interface FarmPlanningSlot {
  slot: number;
  plot_id: string;
  opened: boolean;
  next_in_order: boolean;
  available: boolean;
  cost: number | null;
  paid_cost: number | null;
  currency: "travel_coin" | null;
  eligibility_condition: "current_household_care" | null;
  eligibility_status: "eligible" | "requires_current_care" | "unknown" | "ineligible";
  reason_code: string | null;
  config_version: string;
}
export type FarmPlanningSlotInput = WithOptional<FarmPlanningSlot, "cost" | "paid_cost" | "currency" | "eligibility_condition" | "reason_code">;

/** 开垦下一块地（L4）：需 CSRF 与 Idempotency-Key（scope farm.unlock）；同键同请求回原结果，已经开过的再点回同一个结果、不再扣。 */
export interface FarmUnlockRequest {
  home_id: string;
  /** 只能申请服务端下一未开格；不能跳格 */
  slot: number;
  /** 当前确认页的服务端配置版本，价/币种/条件变化须刷新 */
  config_version: string;
}
export type FarmUnlockRequestInput = FarmUnlockRequest;

export interface FarmUnlockResult {
  plot: PlotSummary;
  /** 付钱那只宠物的钱包（扣完之后） */
  wallet: WalletSummary;
  expansion: FarmExpansion;
  /** 这块地扣的是哪只宠物的钱；重放、家人再点都回同一只 */
  paid_by_pet_id?: string;
  paid_cost?: number | null;
  currency?: "travel_coin";
  domain_operation_id?: string | null;
  receipt_source?: "original_http" | "domain_legacy";
}
export type FarmUnlockResultInput = WithOptional<FarmUnlockResult, "paid_cost" | "currency" | "domain_operation_id" | "receipt_source">;

export interface FarmUnlockOperation {
  status: "UNKNOWN" | "IN_PROGRESS" | "COMMITTED";
  operation_id: string;
  home_id: string;
  original_result: FarmUnlockResult | null;
}
export type FarmUnlockOperationInput = WithOptional<FarmUnlockOperation, "original_result">;

export interface WelcomeDetail {
  kind: WelcomeDetailKind;
  text: string;
  note_id: string;
  note_version: number;
}
export type WelcomeDetailInput = WelcomeDetail;

/** 只由 MemoryProjection(home_interaction) 生成；未确认/owner_private 候选不会出现。 */
export interface HomeWelcome {
  pet_id: string;
  confirmation_id: string | null;
  projection_version: number;
  greeting: string;
  details: WelcomeDetail[];
}
export type HomeWelcomeInput = WithOptional<HomeWelcome, "confirmation_id" | "details">;

export interface UnreadSignals {
  messages: number;
  circle: number;
  /** 通讯器「我和 TA」分区的未读（messages 是两个分区之和） */
  messages_private?: number;
  /** 通讯器「家庭来信」分区的未读 */
  messages_family?: number;
}
export type UnreadSignalsInput = WithOptional<UnreadSignals, "messages" | "circle" | "messages_private" | "messages_family">;

export interface JourneyBrief {
  journey_id: string;
  itinerary_version: number;
  headline: string;
  current_visit_id: string | null;
  current_leg_id: string | null;
}
export type JourneyBriefInput = WithOptional<JourneyBrief, "current_visit_id" | "current_leg_id">;

export interface HomeSnapshot {
  home_id: string;
  server_time: IsoDateTime;
  /** 快照版本，写操作后递增；客户端据此失效缓存 */
  version: number;
  pet: PetPrivateSummary;
  presence: PetPresence;
  guard: GuardState;
  wallet: WalletSummary;
  /** 仓库物资；卖给杂货铺或交居民订单才变成旅费 */
  pantry: InventoryItem[];
  plots: PlotSummary[];
  /** 菜园扩建：下一块能开的地、开垦价、能不能开、谁付钱（L4）；还没入住为空 */
  expansion?: FarmExpansion | null;
  journey: JourneyBrief | null;
  welcome: HomeWelcome | null;
  unread: UnreadSignals;
  /** TA 的家在哪（城市·片区，不是具体地址） */
  place?: HomePlaceSummary | null;
  /** 尚未接入的能力键；前端据此显示未接入而非伪造数据 */
  missing_capabilities: string[];
  data_origin: DataOrigin;
  /** 这个家属于哪个家庭、你的角色、家里有几位成员 */
  household?: HouseholdBrief | null;
  /** 家里的全部宠物与各自此刻的状态；pet 字段是当前查看的那一只 */
  pets?: HouseholdPetBrief[];
  /** 当前查看的这只宠物有已经到期、后台还没结算到的事实：世界正在更新，工资与来信稍后出现（0.4.1） */
  catching_up?: boolean;
  /** 这位家人看到的这只宠物的摸摸档案（NC-00 §3.4、NC-LIMITS §4）：只给当前宠物、当前登录成员。开关 web_nc_touch 关着时回包里没有这个字段（D14） */
  interaction?: InteractionProfile | null;
}
export type HomeSnapshotInput = WithOptional<HomeSnapshot, "pantry" | "plots" | "expansion" | "journey" | "welcome" | "unread" | "place" | "missing_capabilities" | "household" | "pets" | "catching_up" | "interaction">;

export interface CropInfo {
  crop_key: string;
  label: string;
  grow_seconds: number;
  yield_units: number;
  /** 每单位折算的 travel_coin */
  unit_value: number;
  /** 每一批作物全体访客合计最多可偷的单位数 */
  steal_total: number;
  /** 稀有作物：需要旅行带回的种子，种下时消耗一颗 */
  requires_seed: boolean;
}
export type CropInfoInput = WithOptional<CropInfo, "requires_seed">;

export interface NeighborPetBrief {
  pet_id: string;
  name: string;
  species: PetSpecies;
  /** 主页公开才给；与 identity.url 同值（D4） */
  avatar_url: string | null;
  /** 身份图（D4）：主页非公开时只给占位 */
  identity?: PetIdentityImage | null;
  /** 来历（D4） */
  origin?: PetOrigin | null;
}
export type NeighborPetBriefInput = WithOptional<NeighborPetBrief, "avatar_url" | "identity" | "origin">;

export interface NeighborHomeSummary {
  home_id: string;
  pet: NeighborPetBrief;
  presence: PetPresence;
  /** 有人看着菜园（主人巡院或宠物在家）；宠物在家时仍可能偷到，只是几率低 */
  guarded: boolean;
  stealable_plots: number;
  /** 谁在看着菜园 */
  watch?: FarmWatch | null;
  data_origin: DataOrigin;
}
export type NeighborHomeSummaryInput = WithOptional<NeighborHomeSummary, "watch">;

export interface VisitorPlot {
  plot: PlotSummary;
  taken_by_me: boolean;
}
export type VisitorPlotInput = WithOptional<VisitorPlot, "taken_by_me">;

export interface NeighborHomeView {
  home_id: string;
  pet: NeighborPetBrief;
  presence: PetPresence;
  guarded: boolean;
  plots: VisitorPlot[];
  /** 谁在看着菜园 */
  watch?: FarmWatch | null;
  server_time: IsoDateTime;
  data_origin: DataOrigin;
}
export type NeighborHomeViewInput = WithOptional<NeighborHomeView, "plots" | "watch">;

/** 需 Idempotency-Key；同一批作物每位访客最多偷一次，全体合计不超过 steal_total。 */
export interface StealRequest {
  home_id: string;
  plot_id: string;
  cycle_id: string;
}
export type StealRequestInput = StealRequest;

/** 偷到的是物资（进自己的仓库），不是直接的游戏币。 */
export interface StealResult {
  home_id: string;
  plot: PlotSummary;
  gained_item_key: string;
  gained_units: number;
  message: string;
}
export type StealResultInput = StealResult;

export interface PatrolResult {
  guard: GuardState;
  message: string;
}
export type PatrolResultInput = PatrolResult;

export interface FarmEventActor {
  kind: "household";
  reference: string;
  display: "隔壁家";
}
export type FarmEventActorInput = WithOptional<FarmEventActor, "kind" | "display">;

export interface FarmEventItem {
  event_id: string;
  kind: "caught_awake" | "caught_resting" | "stolen";
  occurred_at: IsoDateTime;
  discovered_at: IsoDateTime;
  discovery_basis: string;
  crop_key: string | null;
  units: number;
  is_seen: boolean;
  actor: FarmEventActor;
}
export type FarmEventItemInput = FarmEventItem;

export interface FarmEventsPage {
  items: FarmEventItem[];
  next_cursor: string | null;
  total: number;
  unread: number;
  server_time: IsoDateTime;
  data_origin: DataOrigin;
}
export type FarmEventsPageInput = FarmEventsPage;

export interface FarmEventsSeenRequest {
  event_ids: string[];
}
export type FarmEventsSeenRequestInput = FarmEventsSeenRequest;

export interface FarmEventSeen {
  event_id: string;
  seen_at: IsoDateTime;
}
export type FarmEventSeenInput = FarmEventSeen;

export interface FarmEventsSeenResult {
  entries: FarmEventSeen[];
  unread: number;
}
export type FarmEventsSeenResultInput = FarmEventsSeenResult;

/** 星球居民（公共 NPC，不是真实玩家）当天的收购订单；比杂货铺出价高，每单只能交一次。 */
export interface ResidentOrder {
  order_id: string;
  resident: string;
  item_key: string;
  item_label: string;
  qty: number;
  reward: number;
  /** 同样数量卖给杂货铺能得到的旅费，方便对比 */
  shop_value: number;
  fulfilled: boolean;
  can_fulfill: boolean;
  expires_at: IsoDateTime;
  status: "available" | "fulfilled" | "cancelled" | "expired";
  issued_at: IsoDateTime | null;
  origin: string | null;
  rule_version: string | null;
  issued_unit_price: number | null;
  generation_ref: string | null;
  cancelled_at: IsoDateTime | null;
  settled_pet_id: string | null;
  settled_at: IsoDateTime | null;
  receipt: MarketReceipt | null;
  settlement_status: "not_settled" | "verified" | "legacy_unverified";
}
export type ResidentOrderInput = WithOptional<ResidentOrder, "status" | "issued_at" | "origin" | "rule_version" | "issued_unit_price" | "generation_ref" | "cancelled_at" | "settled_pet_id" | "settled_at" | "receipt" | "settlement_status">;

export interface MarketView {
  pantry: InventoryItem[];
  wallet: WalletSummary;
  orders: ResidentOrder[];
  player_listing_enabled: boolean;
  player_listing_note: string;
  data_origin: DataOrigin;
  /** 杂货铺每个家每天最多收多少星币的货（E1-FARM-CAP-01；居民订单不算在内） */
  shop_daily_cap?: number | null;
  /** 这个家今天已经卖给杂货铺多少星币（香港日） */
  shop_sold_today?: number | null;
  /** 今天还能卖给杂货铺多少星币；为 0 时杂货铺今天收满了，菜留在仓库，明天再卖或交居民订单 */
  shop_remaining_today?: number | null;
  /** 杂货铺的「今天」何时结束（香港时间次日 0 点） */
  shop_resets_at?: IsoDateTime | null;
}
export type MarketViewInput = WithOptional<MarketView, "pantry" | "orders" | "player_listing_enabled" | "shop_daily_cap" | "shop_sold_today" | "shop_remaining_today" | "shop_resets_at">;

/** 需 Idempotency-Key。 */
export interface SellRequest {
  item_key: string;
  qty: number;
  expected_unit_price: number | null;
}
export type SellRequestInput = WithOptional<SellRequest, "expected_unit_price">;

export interface MarketResult {
  wallet: WalletSummary;
  pantry: InventoryItem[];
  gained_coins: number;
  message: string;
  receipt: MarketReceipt | null;
  settled_pet_id: string | null;
  settlement_status: "verified" | "legacy_unverified";
}
export type MarketResultInput = WithOptional<MarketResult, "pantry" | "receipt" | "settled_pet_id" | "settlement_status">;

export interface MarketReceipt {
  receipt_id: string;
  kind: "sell" | "order";
  home_id: string;
  settled_pet_id: string;
  order_id: string | null;
  operation_key: string;
  item_key: string;
  qty: number;
  unit_price: number | null;
  coins: number;
  economy_key: string;
  tx_id: string;
  created_at: IsoDateTime;
}
export type MarketReceiptInput = WithOptional<MarketReceipt, "order_id" | "unit_price">;

export interface MarketOperation {
  operation_key: string;
  status: "committed" | "unknown";
  receipt: MarketReceipt | null;
}
export type MarketOperationInput = WithOptional<MarketOperation, "receipt">;

/** 原选店操作的只读结果；旧版本只确认完成，不代表当前地图。 */
export interface VisitChoiceResult {
  state: "unknown" | "in_progress" | "completed";
  snapshot: JourneyMapSnapshot | null;
}
export type VisitChoiceResultInput = WithOptional<VisitChoiceResult, "snapshot">;

/** 主人给 TA 的出门建议（出发站上选一个地方）。TA 会认真考虑，但由 TA 自己决定去不去、什么时候去。 */
export interface SuggestRequest {
  destination_key: string;
  client_request_id: string | null;
}
export type SuggestRequestInput = WithOptional<SuggestRequest, "client_request_id">;

export interface JourneySuggestion {
  suggestion_id: string;
  destination_key: string;
  title: string;
  /** pending＝TA 还在考虑（出门一次没选它不算结束，24 小时内仍算数）；accepted＝TA 听了你的去了；passed＝考虑时间过了 TA 没去；replaced＝你改了建议 */
  status: SuggestionStatus;
  /** TA 最近一次出门时把这条建议一起想过的时刻（x-additive） */
  considered_at: IsoDateTime | null;
  created_at: IsoDateTime;
  decided_at: IsoDateTime | null;
}
export type JourneySuggestionInput = WithOptional<JourneySuggestion, "considered_at" | "decided_at">;

export interface TravelGuideStop {
  /** 核对到的真实名称；未核实时是 TA 写的名字 */
  name: string;
  /** TA 在攻略里写的叫法（手账图上用它） */
  label: string | null;
  /** 大概时段，例如“上午” */
  time: string | null;
  /** 为什么适合 TA */
  why: string | null;
  /** 给主人的实用提示；不确定的写“以现场为准” */
  tip: string | null;
  /** 是否用地图核对到了真实地点；未核实的不给地址 */
  verified: boolean;
  address: string | null;
  lat: number | null;
  lng: number | null;
  /** 地点资料来源，或“TA 听说的，未核实” */
  attribution: string | null;
  /** 核实过的地点：打开地图导航（高德，WGS-84 坐标） */
  nav_url?: string | null;
  /** 可复制的现实资料：名称与地址 */
  copy_text?: string | null;
}
export type TravelGuideStopInput = WithOptional<TravelGuideStop, "label" | "time" | "why" | "tip" | "address" | "lat" | "lng" | "attribution" | "nav_url" | "copy_text">;

/** TA 的攻略手账：出门前写的一日小攻略，主人也能照着走。 */
export interface TravelGuide {
  guide_id: string;
  journey_id: string;
  city: string;
  destination_title: string;
  title: string;
  summary: string | null;
  stops: TravelGuideStop[];
  owner_tips: string[];
  /** model＝TA 用自己的话写的（模型）；template＝模板 */
  composed_by: string;
  /** 写实手账图生成状态；没有开启“生成照片”时为空 */
  image_status: PhotoStatus | null;
  image_url: string | null;
  created_at: IsoDateTime;
  /** 这是 TA 的计划：planned 还没出发，in_progress 正在路上，completed 表示行程已非 active（含完成或取消），不证明已经返家 */
  status?: GuideStatus | null;
  /** 实际到过的站点（已经发生的经历，与计划分开） */
  visited?: string[];
  /** 这趟花的星币（游戏内，从 TA 的银行卡出） */
  coin_budget?: number | null;
  /** 现实出行的花费说明（不用星币换算） */
  real_budget_note?: string | null;
  /** 整份攻略的纯文本（只含核实过的站点与地址、家人叮嘱与现实花费说明），可以直接复制给家人照着走 */
  copy_text?: string | null;
}
export type TravelGuideInput = WithOptional<TravelGuide, "summary" | "stops" | "owner_tips" | "image_status" | "image_url" | "status" | "visited" | "coin_budget" | "real_budget_note" | "copy_text">;

/** TA 的一份工作：岗位、地点、开始与结束时间、状态和工资（完成后才入账，按旅程只入一次）。 */
export interface JobRecord {
  journey_id: string;
  job_key: string;
  title: string;
  place: string | null;
  starts_at: IsoDateTime;
  ends_at: IsoDateTime;
  /** going 去上班的路上 / working 在干活 / done 干完了 */
  status: string;
  pay: number;
  /** 工资是否已经进了银行卡 */
  paid: boolean;
}
export type JobRecordInput = WithOptional<JobRecord, "place">;

/** 生活时间线：旅行、打工、证件、驾考、朋友、明信片……都来自已经发生的记录。 */
export interface TimelineItem {
  at: IsoDateTime;
  kind: string;
  title: string;
  detail: string | null;
  ref_id: string | null;
}
export type TimelineItemInput = WithOptional<TimelineItem, "detail" | "ref_id">;

/** 事实字段可缺省，不编造。place_id 带来源命名空间。 */
export interface Place {
  provider: PlaceProvider;
  place_id: string;
  name: string;
  address: string | null;
  lat: number;
  lng: number;
  coord_system: CoordSystem;
  category: string | null;
  source_updated_at: IsoDateTime | null;
  attribution: string | null;
  data_origin: DataOrigin;
}
export type PlaceInput = WithOptional<Place, "address" | "category" | "source_updated_at" | "attribution">;

export interface VisitActivity {
  activity_id: string;
  kind: VisitActivityKind;
  label: string;
  state: VisitActivityState;
  result_text: string | null;
}
export type VisitActivityInput = WithOptional<VisitActivity, "result_text">;

/** visit_id 由 Journey 服务在确认下一站时创建；推荐 ID 不等于 visit_id。 */
export interface Visit {
  visit_id: string;
  journey_id: string;
  pet_id: string;
  place: Place;
  state: VisitState;
  template: VenueTemplate;
  planned_arrival_utc: IsoDateTime | null;
  arrived_at: IsoDateTime | null;
  leaving_at: IsoDateTime | null;
  recommendation_id: string | null;
  activities: VisitActivity[];
  /** 店内为原创动物世界场景，不代表真实商家内饰 */
  interior_is_original: boolean;
  data_origin: DataOrigin;
  /** 这次活动的照片；相册没开或这次没有照片时为空（不回退卡通、不补生成） */
  photo?: PetPhotoRef | null;
  /** ready／processing／unknown／failed／none（这次没有照片）；相册没开时为空 */
  photo_state?: VisitPhotoState | null;
}
export type VisitInput = WithOptional<Visit, "planned_arrival_utc" | "arrived_at" | "leaving_at" | "recommendation_id" | "activities" | "interior_is_original" | "photo" | "photo_state">;

/** 需 Idempotency-Key。 */
export interface VisitActionRequest {
  activity_id: string;
}
export type VisitActionRequestInput = VisitActionRequest;

/** 出发站选项。time_basis 标明时长依据；demo_fixture 表示演示线路（未接入真实路线/时刻表）。 */
export interface DestinationOption {
  destination_key: string;
  title: string;
  city: string;
  summary: string;
  /** 这趟的星币标价。**出发时从统一账本扣除，但持驾校借车券的首次自驾不扣**——所以「账本里没有这一行」有两种含义（用了券／本来免费），不要据此推断花了多少；实际扣没扣见行程的 fare_waived（m1701） */
  fee: number;
  /** 门到门往返总时长（真实经过时间，不压缩） */
  total_minutes: number;
  modes: string[];
  time_basis: string;
  /** 与主人确认过的愿望对应时的说明 */
  wish_match: string | null;
  affordable: boolean;
  /** 现在能不能去（现实资料拿不到时为 false，见 unavailable_reason） */
  available?: boolean;
  unavailable_reason?: string | null;
  /** 现实参考资料的来源说明（例如运营方船期与参考票价）；星币旅费与现实票价无关 */
  reference_note?: string | null;
}
export type DestinationOptionInput = WithOptional<DestinationOption, "modes" | "wish_match" | "available" | "unavailable_reason" | "reference_note">;

/** 现实参考票价（运营方公布，含来源）；与星币旅费无关，TA 在星球上的出行只花星币。 */
export interface ReferenceFare {
  currency: string;
  amount: number;
  fare_class: string;
  /** day_weekday / day_weekend_holiday / night */
  band: string;
  effective_from: string;
  note: string;
  source_url: string;
}
export type ReferenceFareInput = ReferenceFare;

export interface PlannedLegPreview {
  sequence: number;
  /** outbound / return */
  direction: string;
  kind: LegKind;
  mode: TransportMode;
  origin: TransportNode;
  destination: TransportNode;
  departs_at: IsoDateTime;
  arrives_at: IsoDateTime;
  time_basis: TimeBasis;
  time_source: LegTimeSource | null;
  source_label: string;
  /** 现实参考班次编号（已核验船期按服务日期落地） */
  reference_id: string | null;
  /** 动物世界承运人（出发时按参考班次分配稳定编号） */
  world_carrier: string | null;
  reference_fare: ReferenceFare | null;
}
export type PlannedLegPreviewInput = WithOptional<PlannedLegPreview, "time_source" | "reference_id" | "world_carrier" | "reference_fare">;

/** 出发前看一眼真实行程（0.4.0）：不扣钱、不生成行程、不分配编号；出门时间从开船时间反推。计划不是已发生的事。 */
export interface TripPlanPreview {
  destination_key: string;
  title: string;
  city: string;
  /** 星币旅费（世界内经济） */
  fee: number;
  leave_home_at: IsoDateTime;
  returns_home_at: IsoDateTime;
  stay_minutes: number;
  venue: Place;
  legs: PlannedLegPreview[];
  notes: string[];
  data_origin: DataOrigin;
}
export type TripPlanPreviewInput = WithOptional<TripPlanPreview, "notes">;

/** 需 Idempotency-Key；宠物必须在家、已入住，旅费足够。 */
export interface DepartRequest {
  destination_key: string;
}
export type DepartRequestInput = DepartRequest;

/** 到店前改选寻味推荐的分店：行程版本 +1，旧推荐待复核。需 Idempotency-Key。 */
export interface VisitChoiceRequest {
  recommendation_id: string;
  expected_itinerary_version: number;
}
export type VisitChoiceRequestInput = VisitChoiceRequest;

/** verified=False 表示示意节点（例如旧代码插值出的中转点），不得冒充真实枢纽。 */
export interface TransportNode {
  node_id: string;
  name: string;
  kind: NodeKind;
  /** IANA 时区，例如 Asia/Hong_Kong */
  timezone: string;
  lat: number | null;
  lng: number | null;
  verified: boolean;
}
export type TransportNodeInput = WithOptional<TransportNode, "lat" | "lng" | "verified">;

/** 现实参考：仅服务端核验与来源说明使用；主界面展示 WorldService。 */
export interface TransportReference {
  reference_id: string;
  provider: string;
  operating_instance_id: string;
  service_date: IsoDate;
  operator_name: string | null;
  marketing_codes: string[];
  origin: TransportNode;
  destination: TransportNode;
  scheduled_departure_utc: IsoDateTime | null;
  scheduled_arrival_utc: IsoDateTime | null;
  estimated_departure_utc: IsoDateTime | null;
  estimated_arrival_utc: IsoDateTime | null;
  actual_departure_utc: IsoDateTime | null;
  actual_arrival_utc: IsoDateTime | null;
  time_basis: TimeBasis;
  freshness: DataFreshness;
  source_url: string | null;
  fetched_at: IsoDateTime | null;
  verified_at: IsoDateTime | null;
  usage_scope: string | null;
}
export type TransportReferenceInput = WithOptional<TransportReference, "operator_name" | "marketing_codes" | "scheduled_departure_utc" | "scheduled_arrival_utc" | "estimated_departure_utc" | "estimated_arrival_utc" | "actual_departure_utc" | "actual_arrival_utc" | "source_url" | "fetched_at" | "verified_at" | "usage_scope">;

/** 发给客户端的最小来源说明，不含现实班次号作为主展示。 */
export interface TransportReferenceSummary {
  reference_id: string | null;
  time_basis: TimeBasis;
  freshness: DataFreshness;
  source_label: string;
  verified_at: IsoDateTime | null;
}
export type TransportReferenceSummaryInput = WithOptional<TransportReferenceSummary, "reference_id" | "verified_at">;

/** 动物世界承运身份：同一运营实例稳定映射（唯一约束 + mapping_version），刷新不换号。 */
export interface WorldService {
  world_service_id: string;
  carrier_name: string;
  service_code: string;
  mode: TransportMode;
  vehicle_style: string | null;
  reference_id: string | null;
  mapping_version: number;
}
export type WorldServiceInput = WithOptional<WorldService, "vehicle_style" | "reference_id" | "mapping_version">;

export interface LegTimes {
  origin_timezone: string;
  destination_timezone: string;
  planned_departure_utc: IsoDateTime;
  planned_arrival_utc: IsoDateTime;
  estimated_departure_utc: IsoDateTime | null;
  estimated_arrival_utc: IsoDateTime | null;
  actual_departure_utc: IsoDateTime | null;
  actual_arrival_utc: IsoDateTime | null;
}
export type LegTimesInput = WithOptional<LegTimes, "estimated_departure_utc" | "estimated_arrival_utc" | "actual_departure_utc" | "actual_arrival_utc">;

export interface JourneyLeg {
  leg_id: string;
  journey_id: string;
  sequence: number;
  kind: LegKind;
  mode: TransportMode;
  role: TravellerRole;
  world_service: WorldService | null;
  origin: TransportNode;
  destination: TransportNode;
  times: LegTimes;
  time_basis: TimeBasis;
  freshness: DataFreshness;
  position_basis: PositionBasis;
  phase: LegPhase;
  itinerary_version: number;
  /** 有几何才沿线呈现；仅节点时为示意 */
  route: LatLng[];
  reference: TransportReferenceSummary | null;
  rescheduled_reason: string | null;
  /** 这段时间的精确来源（见 LegTimeSource）；world_rule 的 time_basis 为 routed_estimate */
  time_source?: LegTimeSource | null;
}
export type JourneyLegInput = WithOptional<JourneyLeg, "world_service" | "route" | "reference" | "rescheduled_reason" | "time_source">;

/** 由服务器时间与已确认时间线计算；客户端只做平滑插值呈现，不决定到达。 */
export interface VehiclePosition {
  leg_id: string;
  lat: number;
  lng: number;
  heading_deg: number;
  progress: number;
  computed_at: IsoDateTime;
  position_basis: PositionBasis;
}
export type VehiclePositionInput = WithOptional<VehiclePosition, "heading_deg">;

export interface TravelActivity {
  activity_id: string;
  leg_id: string;
  kind: TravelActivityKind;
  state: TravelActivityState;
  starts_at: IsoDateTime;
  ends_at: IsoDateTime | null;
  media_session_id: string | null;
  interruptible: boolean;
  version: number;
}
export type TravelActivityInput = WithOptional<TravelActivity, "ends_at" | "media_session_id" | "interruptible" | "version">;

/** 地图车辆旁的音符/电视入口；badge 由实际 TravelActivity 决定，无活动则不下发。 */
export interface MapActivityEntry {
  entry_id: string;
  leg_id: string;
  activity_id: string;
  badge: ActivityBadgeKind;
  badge_state: TravelActivityState;
  media_session_id: string | null;
  label: string;
  actions: MapEntryAction[];
}
export type MapActivityEntryInput = WithOptional<MapActivityEntry, "media_session_id" | "actions">;

/** Journey → FoodDiscovery 的时间契约：门到门可行到达与可停留窗口，不只看落地时刻。 */
export interface PetArrivalContext {
  journey_id: string;
  itinerary_version: number;
  leg_id: string;
  city: string;
  destination_timezone: string;
  feasible_arrival_utc: IsoDateTime;
  stay_window_start_utc: IsoDateTime;
  stay_window_end_utc: IsoDateTime;
}
export type PetArrivalContextInput = PetArrivalContext;

export interface JourneyMapSnapshot {
  journey_id: string;
  pet_id: string;
  itinerary_version: number;
  /** active / completed / cancelled */
  lifecycle: string;
  destination_title: string | null;
  /** 宠物此刻在店里时才有值 */
  current_visit_id: string | null;
  /** 本次旅程的到访（出发即确定；到店前可按寻味推荐改选） */
  planned_visit_id: string | null;
  server_time: IsoDateTime;
  legs: JourneyLeg[];
  current_leg_id: string | null;
  vehicle: VehiclePosition | null;
  activities: TravelActivity[];
  activity_entries: MapActivityEntry[];
  arrival_context: PetArrivalContext | null;
  data_origin: DataOrigin;
  /** 有已经到期、后台还没结算到的事实（到站、收工、回家……）：位置照常按时间显示，工资与来信稍后出现；不是出错（0.4.1） */
  catching_up?: boolean;
}
export type JourneyMapSnapshotInput = WithOptional<JourneyMapSnapshot, "lifecycle" | "destination_title" | "current_visit_id" | "planned_visit_id" | "legs" | "current_leg_id" | "vehicle" | "activities" | "activity_entries" | "arrival_context" | "catching_up">;

export interface JourneyPlayerLodgingFacts {
  kind: "hotel_room" | "inn_room" | "homestay_room" | "hostel_bed";
  phrase: string;
  checked_in_at: IsoDateTime;
  place_timezone: string;
  place_key: string;
  scope: "current" | "history";
  price_status: "unknown";
  price_amount: null;
}
export type JourneyPlayerLodgingFactsInput = WithOptional<JourneyPlayerLodgingFacts, "price_status" | "price_amount">;

export interface JourneyPlayerSleepFacts {
  state: "asleep" | "awake" | "unknown";
  since: IsoDateTime | null;
  effective_at: IsoDateTime | null;
  pending: "sleep" | "wake" | null;
  reason: "not_current_journey" | "schedule_off" | "unverified_stay" | "source_invalid" | "no_current_sleep" | "actual_stay_choice";
}
export type JourneyPlayerSleepFactsInput = WithOptional<JourneyPlayerSleepFacts, "since" | "effective_at" | "pending">;

export interface JourneyPlayerFacts {
  journey_id: string;
  pet_id: string;
  household_id: string;
  home_id: string;
  itinerary_version: number;
  visit_id: string;
  observed_at: IsoDateTime;
  lodging: JourneyPlayerLodgingFacts | null;
  sleep: JourneyPlayerSleepFacts;
}
export type JourneyPlayerFactsInput = WithOptional<JourneyPlayerFacts, "lodging">;

export interface JourneyMapRead {
  journey_id: string;
  pet_id: string;
  itinerary_version: number;
  /** active / completed / cancelled */
  lifecycle: string;
  destination_title: string | null;
  /** 宠物此刻在店里时才有值 */
  current_visit_id: string | null;
  /** 本次旅程的到访（出发即确定；到店前可按寻味推荐改选） */
  planned_visit_id: string | null;
  server_time: IsoDateTime;
  legs: JourneyLeg[];
  current_leg_id: string | null;
  vehicle: VehiclePosition | null;
  activities: TravelActivity[];
  activity_entries: MapActivityEntry[];
  arrival_context: PetArrivalContext | null;
  data_origin: DataOrigin;
  /** 有已经到期、后台还没结算到的事实（到站、收工、回家……）：位置照常按时间显示，工资与来信稍后出现；不是出错（0.4.1） */
  catching_up?: boolean;
  player_facts: JourneyPlayerFacts | null;
}
export type JourneyMapReadInput = WithOptional<JourneyMapRead, "lifecycle" | "destination_title" | "current_visit_id" | "planned_visit_id" | "legs" | "current_leg_id" | "vehicle" | "activities" | "activity_entries" | "arrival_context" | "catching_up" | "player_facts">;

/** 旅途地图的真实底图（服务端代理高德静态地图）。available=false 时前端退回示意地图，并说明原因。 */
export interface BasemapView {
  available: boolean;
  reason: BasemapUnavailableReason | null;
  provider: BasemapProvider | null;
  /** 同源图片地址（需登录），图片为 2 倍清晰度；图上自带供应商标志与审图号，不得遮挡或裁掉 */
  image_url: string | null;
  /** 图片中心（WGS-84）；叠加物按 WGS-84 做 Web Mercator 投影即可对齐 */
  center: LatLng | null;
  /** Web Mercator 缩放级别（256 像素瓦片） */
  zoom: number | null;
  /** 图片逻辑宽度（CSS 像素） */
  width: number | null;
  /** 图片逻辑高度（CSS 像素） */
  height: number | null;
  attribution: string | null;
  expires_at: IsoDateTime | null;
}
export type BasemapViewInput = WithOptional<BasemapView, "reason" | "provider" | "image_url" | "center" | "zoom" | "width" | "height" | "attribution" | "expires_at">;

export interface MediaLicense {
  status: LicenseStatus;
  allows_in_app_playback: boolean;
  allows_sync: boolean;
  public_release_allowed: boolean;
  regions: string[];
  expires_at: IsoDateTime | null;
  note: string | null;
}
export type MediaLicenseInput = WithOptional<MediaLicense, "public_release_allowed" | "regions" | "expires_at" | "note">;

export interface MediaAsset {
  media_id: string;
  kind: MediaKind;
  title: string;
  creator: string | null;
  /** 作品版本；版本不同不能标同步 */
  edition: string;
  duration_ms: number;
  src_url: string | null;
  poster_url: string | null;
  external_url: string | null;
  availability: MediaAvailability;
  license: MediaLicense;
  data_origin: DataOrigin;
}
export type MediaAssetInput = WithOptional<MediaAsset, "creator" | "src_url" | "poster_url" | "external_url">;

export interface MediaAnchor {
  position_ms: number;
  server_time: IsoDateTime;
  playback_rate: number;
}
export type MediaAnchorInput = WithOptional<MediaAnchor, "playback_rate">;

export interface ControlLease {
  holder_device_id: string | null;
  lease_expires_at: IsoDateTime | null;
}
export type ControlLeaseInput = WithOptional<ControlLease, "holder_device_id" | "lease_expires_at">;

export interface CompanionSession {
  session_id: string;
  activity_id: string;
  pet_id: string;
  media: MediaAsset;
  state: MediaSessionState;
  anchor: MediaAnchor;
  revision: number;
  resume_policy: ResumePolicy;
  control: ControlLease | null;
  saved_progress_ms: number | null;
  interrupt_reason: InterruptReason | null;
  /** 驾驶中为 false：服务端拒绝切换到视频 */
  video_allowed: boolean;
  data_origin: DataOrigin;
}
export type CompanionSessionInput = WithOptional<CompanionSession, "control" | "saved_progress_ms" | "interrupt_reason">;

/** 只有 synced 且在允许偏差内、心跳未过期才累计 counted_ms；页面停留不等于陪伴。 */
export interface Participation {
  session_id: string;
  device_id: string;
  mode: ParticipationMode;
  since: IsoDateTime;
  last_heartbeat_at: IsoDateTime | null;
  counted_ms: number;
}
export type ParticipationInput = WithOptional<Participation, "last_heartbeat_at" | "counted_ms">;

export interface CompanionJoinRequest {
  device_id: string;
  mode: ParticipationMode;
}
export type CompanionJoinRequestInput = WithOptional<CompanionJoinRequest, "mode">;

export interface CompanionLeaveRequest {
  device_id: string;
}
export type CompanionLeaveRequestInput = CompanionLeaveRequest;

/** 需 Idempotency-Key；session_revision 过期返回 409 VERSION_CONFLICT。 */
export interface CompanionCommandRequest {
  device_id: string;
  command: CompanionCommandKind;
  session_revision: number;
  position_ms: number | null;
}
export type CompanionCommandRequestInput = WithOptional<CompanionCommandRequest, "position_ms">;

export interface CompanionHeartbeatRequest {
  device_id: string;
  player_state: ParticipationMode;
  position_ms: number;
  media_edition: string;
  client_time: IsoDateTime;
}
export type CompanionHeartbeatRequestInput = CompanionHeartbeatRequest;

/** -2（很不喜欢）… 2（很喜欢）；null 表示未知，不等于中性。 */
export interface TasteVector {
  sweet: number | null;
  salty: number | null;
  spicy: number | null;
  oily: number | null;
  aromatic_spice: number | null;
  rich_broth: number | null;
  crispy: number | null;
}
export type TasteVectorInput = WithOptional<TasteVector, "sweet" | "salty" | "spicy" | "oily" | "aromatic_spice" | "rich_broth" | "crispy">;

export interface DietaryRestriction {
  kind: DietaryRestrictionKind;
  label: string;
  /** 恒为私密；公开/社交接口不得输出 */
  private: boolean;
}
export type DietaryRestrictionInput = WithOptional<DietaryRestriction, "private">;

export interface FoodPreference {
  preference_id: string;
  subject: PreferenceSubject;
  pet_id: string;
  version: number;
  /** 主人可读的偏好名，例如“清淡”“浓郁” */
  label: string;
  taste: TasteVector;
  budget: MoneyAmount | null;
  max_wait_minutes: number | null;
  party_size: number | null;
  restrictions: DietaryRestriction[];
  source: PreferenceSource;
  updated_at: IsoDateTime;
}
export type FoodPreferenceInput = WithOptional<FoodPreference, "budget" | "max_wait_minutes" | "party_size" | "restrictions">;

export interface SourceRating {
  provider: string;
  rating: number | null;
  /** 平台总评价数 */
  source_rating_count: number | null;
  /** 本系统实际取得并分析的样本数 */
  observed_sample_count: number;
  fetched_at: IsoDateTime | null;
}
export type SourceRatingInput = WithOptional<SourceRating, "rating" | "source_rating_count" | "observed_sample_count" | "fetched_at">;

/** branch_id 含来源命名空间（amap:/google:/fixture:）；总店证据不自动转移给分店。 */
export interface Branch {
  branch_id: string;
  name: string;
  brand: string | null;
  place: Place | null;
  ratings: SourceRating[];
}
export type BranchInput = WithOptional<Branch, "brand" | "place" | "ratings">;

export interface Dish {
  dish_id: string;
  branch_id: string;
  name: string;
  price: MoneyAmount | null;
  flavor_traits: string[];
}
export type DishInput = WithOptional<Dish, "price" | "flavor_traits">;

export interface EvidenceCitation {
  evidence_id: string;
  source_kind: EvidenceSourceKind;
  source_label: string;
  aspect: string;
  observation: string;
  observed_at: IsoDateTime | null;
  sample_count: number;
}
export type EvidenceCitationInput = WithOptional<EvidenceCitation, "observed_at" | "sample_count">;

export interface JudgementScores {
  quality: number | null;
  match: number | null;
  value: number | null;
  logistics: number | null;
  uncertainty: number | null;
}
export type JudgementScoresInput = WithOptional<JudgementScores, "quality" | "match" | "value" | "logistics" | "uncertainty">;

export interface DishSuggestion {
  dish: Dish;
  why: string;
  evidence: EvidenceCitation[];
}
export type DishSuggestionInput = WithOptional<DishSuggestion, "evidence">;

export interface RecommendationProvenance {
  generated_at: IsoDateTime;
  fact_version: string;
  preference_version: number;
  rule_version: string;
  data_status: FoodDataStatus;
  coverage_note: string;
}
export type RecommendationProvenanceInput = RecommendationProvenance;

/** 主人现实用餐：使用主人自己的日期/位置/时间，不套宠物行程。 */
export interface OwnerDiningContext {
  plan_date: IsoDate;
  meal_time_local: string;
  timezone: string;
  city: string;
  area: string | null;
}
export type OwnerDiningContextInput = WithOptional<OwnerDiningContext, "area">;

export interface FoodRecommendation {
  /** Persisted pet source; null means unconfirmed */
  pet_id: string | null;
  /** Persisted journey source; owner mode has no journey */
  journey_id: string | null;
  recommendation_id: string;
  mode: FoodMode;
  branch: Branch;
  dishes: DishSuggestion[];
  scores: JudgementScores;
  eligibility: EligibilityStatus;
  group: RecommendationGroup;
  rank: number | null;
  reasons: string[];
  not_suitable_when: string[];
  unknowns: string[];
  provenance: RecommendationProvenance;
  freshness: RecommendationFreshness;
  /** pet 模式绑定的行程版本；变化后 needs_recheck */
  itinerary_version: number | null;
  data_origin: DataOrigin;
}
export type FoodRecommendationInput = WithOptional<FoodRecommendation, "pet_id" | "journey_id" | "dishes" | "rank" | "reasons" | "not_suitable_when" | "unknowns" | "itinerary_version">;

export interface FoodRecommendationRequest {
  mode: FoodMode;
  pet_id: string;
  preference_id: string | null;
  pet_context: PetArrivalContext | null;
  owner_context: OwnerDiningContext | null;
  /** 确定性场景配置键，例如 special_trip / quick_bite */
  scene: string | null;
  max_results: number;
}
export type FoodRecommendationRequestInput = WithOptional<FoodRecommendationRequest, "preference_id" | "pet_context" | "owner_context" | "scene" | "max_results">;

export interface FoodRecommendationList {
  mode: FoodMode;
  preference: FoodPreference;
  items: FoodRecommendation[];
  /** 数量不足时如实说明，不强造三个 */
  shortfall_note: string | null;
  data_origin: DataOrigin;
}
export type FoodRecommendationListInput = WithOptional<FoodRecommendationList, "items" | "shortfall_note">;

/** 主人实际用餐反馈；不同于虚拟到访 visit_id，需 Idempotency-Key。 */
export interface FoodFeedback {
  feedback_id: string | null;
  recommendation_id: string;
  dish_ids: string[];
  verdict: FeedbackVerdict;
  reasons: string[];
  note: string | null;
  dined_on: IsoDate;
  verification: FeedbackVerification;
}
export type FoodFeedbackInput = WithOptional<FoodFeedback, "feedback_id" | "dish_ids" | "reasons" | "note" | "verification">;

/** 可配置的公共 NPC 接待角色；不是平台管理员，也不占专属领养池。 */
export interface ReceptionHost {
  host_id: string;
  display_name: string;
  role_label: string;
  avatar_url: string | null;
  is_ai: boolean;
  disclosure: string;
}
export type ReceptionHostInput = WithOptional<ReceptionHost, "avatar_url" | "is_ai">;

export interface ReceptionTurn {
  turn_id: string;
  seq: number;
  speaker: TurnSpeaker;
  text: string;
  created_at: IsoDateTime;
  /** 接待员这句话的来源：guided（固定引导）/ model（对话模型）；主人的话为空 */
  composed_by?: string | null;
}
export type ReceptionTurnInput = WithOptional<ReceptionTurn, "composed_by">;

export interface IntakeCandidate {
  candidate_id: string;
  kind: CandidateKind;
  subject: CandidateSubject;
  text: string;
  source_turn_id: string;
  /** 原话依据片段，主人可展开核对 */
  source_excerpt: string;
  needs_clarification: boolean;
  suggested_slot: CareNoteSlot | null;
  suggested_slot_value: string | null;
  state: CandidateState;
}
export type IntakeCandidateInput = WithOptional<IntakeCandidate, "needs_clarification" | "suggested_slot" | "suggested_slot_value">;

export interface ReceptionSession {
  session_id: string;
  pet_id: string;
  branch: ReceptionBranch;
  mode: ReceptionMode;
  status: ReceptionStatus;
  host: ReceptionHost;
  turns: ReceptionTurn[];
  candidates: IntakeCandidate[];
  draft_revision: number;
  draft_expires_at: IsoDateTime | null;
  data_origin: DataOrigin;
}
export type ReceptionSessionInput = WithOptional<ReceptionSession, "turns" | "candidates" | "draft_expires_at">;

/** 需 Idempotency-Key；同一宠物已有进行中的会话时返回该会话（继续草稿）。 */
export interface ReceptionStartRequest {
  pet_id: string;
  branch: ReceptionBranch;
  /** 已不再使用（I107-W4）：接待用不用对话模型由运营后台的能力开关决定（用户 09-30），传什么都不影响；字段留着只为旧客户端不报错 */
  use_model?: boolean;
}
export type ReceptionStartRequestInput = WithOptional<ReceptionStartRequest, "use_model">;

/** 需 Idempotency-Key；expected_revision 过期返回 409 VERSION_CONFLICT。 */
export interface ReceptionTurnRequest {
  text: string;
  expected_revision: number;
}
export type ReceptionTurnRequestInput = ReceptionTurnRequest;

export interface CareNoteDecision {
  candidate_id: string;
  /** 主人编辑后的最终文字 */
  text: string;
  target: SaveTarget;
  purposes: MemoryPurpose[];
  slot: CareNoteSlot | null;
  slot_value: string | null;
}
export type CareNoteDecisionInput = WithOptional<CareNoteDecision, "purposes" | "slot" | "slot_value">;

/** 需 Idempotency-Key；draft_revision 与服务端不一致返回 409 VERSION_CONFLICT。 */
export interface IntakeConfirmationRequest {
  session_id: string;
  draft_revision: number;
  decisions: CareNoteDecision[];
}
export type IntakeConfirmationRequestInput = IntakeConfirmationRequest;

export interface CareNote {
  note_id: string;
  pet_id: string;
  kind: CandidateKind;
  subject: CandidateSubject;
  text: string;
  target: SaveTarget;
  purposes: MemoryPurpose[];
  slot: CareNoteSlot | null;
  slot_value: string | null;
  version: number;
  confirmed_at: IsoDateTime;
  supersedes_note_id: string | null;
  revoked_at: IsoDateTime | null;
}
export type CareNoteInput = WithOptional<CareNote, "purposes" | "slot" | "slot_value" | "supersedes_note_id" | "revoked_at">;

export interface MemoryGrant {
  grant_id: string;
  note_id: string;
  note_version: number;
  purpose: MemoryPurpose;
  granted_at: IsoDateTime;
  revoked_at: IsoDateTime | null;
}
export type MemoryGrantInput = WithOptional<MemoryGrant, "revoked_at">;

export interface IntakeConfirmationResult {
  confirmation_id: string;
  session_id: string;
  draft_revision: number;
  persist_state: PersistState;
  notes: CareNote[];
  grants: MemoryGrant[];
  onboarding: OnboardingState;
  data_origin: DataOrigin;
}
export type IntakeConfirmationResultInput = WithOptional<IntakeConfirmationResult, "notes" | "grants">;

export interface ProjectedNote {
  note_id: string;
  note_version: number;
  kind: CandidateKind;
  text: string;
  slot: CareNoteSlot | null;
  slot_value: string | null;
}
export type ProjectedNoteInput = WithOptional<ProjectedNote, "slot" | "slot_value">;

/** 按用途的最小投影；只读消费不扩大许可。 */
export interface MemoryProjection {
  pet_id: string;
  purpose: MemoryPurpose;
  items: ProjectedNote[];
  policy_version: string;
  generated_at: IsoDateTime;
}
export type MemoryProjectionInput = WithOptional<MemoryProjection, "items">;

/** 需 Idempotency-Key。先停止使用旧版本，再清理衍生物。 */
export interface MemoryCorrectionRequest {
  action: MemoryCorrectionAction;
  expected_version: number;
  new_text: string | null;
  /** 槽位值（如称呼）；不填则按新文字重新建议，无法确定时清空而不沿用旧值 */
  new_slot_value: string | null;
}
export type MemoryCorrectionRequestInput = WithOptional<MemoryCorrectionRequest, "new_text" | "new_slot_value">;

export interface MemoryCorrectionResult {
  note_id: string;
  new_note: CareNote | null;
  cleanup: CleanupState;
  affected_task_ids: string[];
}
export type MemoryCorrectionResultInput = WithOptional<MemoryCorrectionResult, "new_note" | "affected_task_ids">;

export interface ActorRef {
  actor_kind: ActorKind;
  actor_id: string;
  display_name: string;
  avatar_url: string | null;
  /** 真实账号家庭的宠物/主人为 true；NPC 恒为 false */
  is_real_household: boolean;
  /** 宠物作者的身份图（D4；只有 actor_kind=pet 时给）：主页公开才给图，否则只给占位；avatar_url 与 identity.url 同值 */
  identity?: PetIdentityImage | null;
  /** 宠物作者的物种（取值同 PetSpecies；没图时画插画用，D4）；npc／owner 为 null */
  species?: string | null;
}
export type ActorRefInput = WithOptional<ActorRef, "avatar_url" | "identity" | "species">;

export interface PostMedia {
  media_id: string;
  kind: string;
  url: string | null;
  alt: string | null;
  /** AI 生成图为 true；生成图不代表真实到店照片 */
  generated: boolean;
}
export type PostMediaInput = WithOptional<PostMedia, "url" | "alt">;

export interface Post {
  post_id: string;
  author: ActorRef;
  text: string;
  media: PostMedia[];
  /** 来源世界事件；普通动作不逐条发帖 */
  source_event_id: string;
  visit_id: string | null;
  visibility: PostVisibility;
  created_at: IsoDateTime;
  reaction_count: number;
  comment_count: number;
  viewer_reacted: boolean;
  data_origin: DataOrigin;
  /** 这一趟由星球活动补助车费时的「星球活动：xxx」（世界运营第二期 2a D9）；公开与否照旧只看家庭开关，这里只说属于哪个活动 */
  planet_event?: PlanetEventTag | null;
  /** 看的人是发帖宠物所在家庭的管理员、这条动态有公开配图时为 true：可以逐张撤回公开（MEDIA-UNPUBLISH-API-117）；别人一律 false */
  viewer_can_unpublish?: boolean;
}
export type PostInput = WithOptional<Post, "media" | "visit_id" | "reaction_count" | "comment_count" | "viewer_reacted" | "planet_event" | "viewer_can_unpublish">;

export interface Comment {
  comment_id: string;
  post_id: string;
  actor: ActorRef;
  reply_to_comment_id: string | null;
  text: string;
  created_at: IsoDateTime;
  removed: boolean;
}
export type CommentInput = WithOptional<Comment, "reply_to_comment_id" | "removed">;

export interface PostPage {
  items: Post[];
  next_cursor: string | null;
}
export type PostPageInput = WithOptional<PostPage, "items" | "next_cursor">;

export interface CommentPage {
  items: Comment[];
  next_cursor: string | null;
}
export type CommentPageInput = WithOptional<CommentPage, "items" | "next_cursor">;

/** 需 Idempotency-Key；同一行动者对同一帖只计一次。 */
export interface ReactionRequest {
  as_actor: ActorKind;
}
export type ReactionRequestInput = ReactionRequest;

/** 需 Idempotency-Key。 */
export interface CommentRequest {
  as_actor: ActorKind;
  text: string;
  reply_to_comment_id: string | null;
}
export type CommentRequestInput = WithOptional<CommentRequest, "reply_to_comment_id">;

export interface FollowRequest {
  follow: boolean;
}
export type FollowRequestInput = WithOptional<FollowRequest, "follow">;

/** 屏蔽某条动态/评论的作者（不暴露对方账号 ID）。 */
export interface BlockRequest {
  post_id: string | null;
  comment_id: string | null;
  /** PRIV-FOLLOW-02：personal（默认）只在你和对方两个账号之间互相藏动态与评论；household 是代 household_id 那一家的显式家庭操作，只有那一家此刻的管理员能用（否则 403）：两家之间不能新建关注、对方一家看不到这一家宠物的主页与头像、两家宠物之间待回应的朋友消息结束。管理员降级、退出或重新入户后这一项不再生效，再被提升也不会恢复 */
  scope?: string;
  /** scope=household 时必填：代哪一家屏蔽 */
  household_id?: string | null;
}
export type BlockRequestInput = WithOptional<BlockRequest, "post_id" | "comment_id" | "scope" | "household_id">;

export interface ReportRequest {
  target_kind: string;
  target_id: string;
  reason: string;
}
export type ReportRequestInput = ReportRequest;

export interface MessageSummary {
  message_id: string;
  client_message_id: string | null;
  sender: MessageSender;
  text: string;
  state: MessageDeliveryState;
  created_at: IsoDateTime;
  /** 这条消息出现在对话里的时刻（排序、分组都按它）；created_at 是写入时刻，排队的回复两者不同，前端显示与分组改用它 */
  available_at?: IsoDateTime | null;
  photo_url: string | null;
  /** 宠物消息的来源；主人消息为空 */
  composed_by?: MessageComposer | null;
  /** 附图（冒险插画）状态；无附图为空 */
  photo_status?: PhotoStatus | null;
  /** TA 主动发来的消息的话题 */
  topic?: MessageTopic | null;
  /** 主人消息等待回复时的说明，例如“TA 睡着啦，醒来会看到” */
  status_note?: string | null;
  /** 预计回复时间（等待中才有） */
  expected_reply_at?: IsoDateTime | null;
  /** 这条消息在哪个频道（0.4.0 家庭共同照顾） */
  channel?: MessageChannel;
  /** 由世界事件产生的来信指向那个事件（<journey_id>:<事件键>），同一事件全家只有一条；其他消息为空（0.4.1） */
  source_event_id?: string | null;
  /** TA 的这条回复针对的家人消息编号（0.4.1） */
  reply_to?: string | null;
  /** 主人自己那条私聊下面的确认条（UF-INTENT）：come_home＝「要 TA 忙完这段就回家吗？」。点了才发 POST /pets/{pet_id}/plan-requests（origin=text_confirmed、source_message_id＝这条消息）；不点什么都不变。只在发送那一刻判一次；TA 的消息为空 */
  suggested_action?: MessageSuggestedAction | null;
  /** TA 的心愿来信点开去哪（心愿形成、计划就绪那两种）；别的消息为空 */
  link?: MessageLink | null;
}
export type MessageSummaryInput = WithOptional<MessageSummary, "client_message_id" | "available_at" | "photo_url" | "composed_by" | "photo_status" | "topic" | "status_note" | "expected_reply_at" | "channel" | "source_event_id" | "reply_to" | "suggested_action" | "link">;

export interface MessageThread {
  pet_id: string;
  items: MessageSummary[];
  /** 往上翻更早一页的游标（不透明串，原样放回 ?cursor=）；没有更早的消息为 null。游标只在短时间内有效：过期、失效或报 400 cursor_invalid 时，请从最新一页重新开始。 */
  next_cursor: string | null;
  data_origin: DataOrigin;
}
export type MessageThreadInput = WithOptional<MessageThread, "items" | "next_cursor">;

/** client_message_id 即幂等键（复用旧 communicator 的 (pet_id, client_message_id) 去重）。 */
export interface SendMessageRequest {
  client_message_id: string;
  text: string;
}
export type SendMessageRequestInput = SendMessageRequest;

/** 标已读（`POST /communicator/{pet_id}/read`；需 CSRF 与 Idempotency-Key）。 */
export interface MarkReadRequest {
  /** 屏幕上真正显示出来的最新那条消息的 available_at，原样回传那个字符串，必须带时区（不带回 422）。别经过 JS Date 再转成 ISO：库里精确到微秒，Date 只到毫秒，截掉的几微秒会让最后那条一直算未读。比此刻新按此刻截断；比已记的旧不动（只进不退） */
  read_through: IsoDateTime;
  /** 这条消息所在的分区：private＝我和 TA，family＝家庭来信；已读位置每个分区各记一个。不带就两个分区一起记（旧前端） */
  channel?: MessageChannel | null;
}
export type MarkReadRequestInput = WithOptional<MarkReadRequest, "channel">;

export interface MessageReadResult {
  pet_id: string;
  /** 生效后的已读位置（库里此刻的值）：带了分区就是那个分区的；没带就是两个分区里较早的那个 */
  read_through: IsoDateTime;
  /** 此刻的未读数：TA 发来、你能看到（你和 TA 的私聊＋家庭频道）、已经出现、在各自分区已读位置之后的消息条数；与首页快照 unread.messages 同一个数（两个分区之和）。动态圈 unread.circle 不受这条命令影响 */
  unread: number;
  server_time: IsoDateTime;
  /** 请求里给的分区；没给为 null（两个分区一起记） */
  channel?: MessageChannel | null;
  /** 「我和 TA」分区的未读 */
  unread_private?: number;
  /** 「家庭来信」分区的未读 */
  unread_family?: number;
}
export type MessageReadResultInput = WithOptional<MessageReadResult, "channel" | "unread_private" | "unread_family">;

export interface CollectionItem {
  item_id: string;
  kind: string;
  /** 可种植种子的作物键（kind=seed 时有值） */
  item_key: string | null;
  title: string;
  obtained_at: IsoDateTime;
  tradable: boolean;
  bound_to_pet: boolean;
  source_event_id: string | null;
  data_origin: DataOrigin;
  /** 明信片上 TA 写给主人的话 */
  note?: string | null;
  /** 明信片上的写实自拍（生成完成后才有；仅主人可读） */
  image_url?: string | null;
  /** 自拍生成状态；没有开启“生成照片”时为空 */
  image_status?: PhotoStatus | null;
  /** 明信片自拍画好了、但这一位查看者取不到时照实说的一句（如「这张自拍暂时看不到」）；有值时 image_status、image_url 为空（I109） */
  image_unavailable_note?: string | null;
  /** 寄出明信片的地方 */
  place?: string | null;
  city?: string | null;
  /** 这一趟由星球活动补助车费时的「星球活动：xxx」（世界运营第二期 2a D9）；公开与否照旧只看家庭开关，这里只说属于哪个活动 */
  planet_event?: PlanetEventTag | null;
}
export type CollectionItemInput = WithOptional<CollectionItem, "item_key" | "source_event_id" | "note" | "image_url" | "image_status" | "image_unavailable_note" | "place" | "city" | "planet_event">;

/** TA 在外面遇到的朋友：真实宠物（同一时间同一地点遇到）或星球居民（NPC，明确标注）。 */
export interface FriendSummary {
  friend_id: string;
  kind: FriendKind;
  name: string;
  species: string | null;
  meet_count: number;
  /** 见过几次（事实，不是亲密程度）：「见过 N 次」 */
  closeness: string;
  first_met_at: IsoDateTime;
  last_met_at: IsoDateTime;
  last_place: string | null;
}
export type FriendSummaryInput = WithOptional<FriendSummary, "species" | "last_place">;

/** wish＝心愿页（/guides/wish）；plan＝这份计划（/guides/plan/{ref}）。路径由前端按 kind 拼，后端不下发 URL。 */
export interface MessageLink {
  /** wish（心愿形成那封）或 plan（计划就绪那封） */
  kind: "wish" | "plan";
  /** kind=wish 时是心愿编号，kind=plan 时是计划编号 */
  ref: string;
}
export type MessageLinkInput = MessageLink;

/** 原文片段依据：start/end 为 Python 字符串（Unicode 码点）下标，必须能在对应消息原文中匹配。 */
export interface SpanRef {
  start: number;
  end: number;
  text: string;
  offset_unit: string;
}
export type SpanRefInput = WithOptional<SpanRef, "offset_unit">;

export interface IntentSignal {
  kind: SignalKind;
  subject: SignalSubject;
  target: string | null;
  temporal: TemporalScope;
  negated: boolean;
  quoted: boolean;
  span: SpanRef;
  usage_limits: UsageLimit[];
  /** judge（判断器）/ parser（解析步骤）；来源必须可区分 */
  source: string;
}
export type IntentSignalInput = WithOptional<IntentSignal, "target" | "negated" | "quoted" | "usage_limits">;

export interface DecisionEvidence {
  provider: IntentProvider;
  requested_model: string | null;
  /** 只有真实返回时才填写 */
  effective_model: string | null;
  rule_version: string;
  question_version: string | null;
  raw_probabilities: Record<string, number> | null;
  /** 输出分布集中度，不是正确率，也不是用户许可 */
  confidence: number | null;
  latency_ms: number;
  usage_note: string | null;
  error: string | null;
  degraded_reason: string | null;
}
export type DecisionEvidenceInput = WithOptional<DecisionEvidence, "requested_model" | "effective_model" | "question_version" | "raw_probabilities" | "confidence" | "usage_note" | "error" | "degraded_reason">;

/** 最小上下文：账号归属由服务端提供；不附全量私密记忆。 */
export interface IntentContext {
  request_id: string;
  message_id: string;
  channel: IntentChannel;
  language: string;
  recent_context: string[];
  candidate_targets: string[];
  state_version: string | null;
}
export type IntentContextInput = WithOptional<IntentContext, "language" | "recent_context" | "candidate_targets" | "state_version">;

export interface IntentAssessment {
  assessment_id: string;
  signals: IntentSignal[];
  unknown: boolean;
  needs_clarification: boolean;
  conflicts: string[];
  evidence: DecisionEvidence;
}
export type IntentAssessmentInput = WithOptional<IntentAssessment, "signals" | "unknown" | "needs_clarification" | "conflicts">;

export interface ActionProposal {
  proposal_id: string;
  kind: ActionProposalKind;
  target: string | null;
  expected_state_version: string | null;
  requires_confirmation: boolean;
  /** 领域校验结论（代码产生），例如 route_change_not_allowed_by_intent */
  domain_check: string | null;
  note: string | null;
}
export type ActionProposalInput = WithOptional<ActionProposal, "target" | "expected_state_version" | "requires_confirmation" | "domain_check" | "note">;

export interface ActionOutcome {
  proposal_id: string;
  state: ActionOutcomeState;
  operation_id: string | null;
  result_version: string | null;
  message: string | null;
}
export type ActionOutcomeInput = WithOptional<ActionOutcome, "operation_id" | "result_version" | "message">;

export interface CredentialLink {
  /** journey / leg / visit / exam / home */
  kind: string;
  ref_id: string;
  title: string;
  at: IsoDateTime | null;
}
export type CredentialLinkInput = WithOptional<CredentialLink, "at">;

export interface CredentialField {
  label: string;
  value: string;
}
export type CredentialFieldInput = CredentialField;

export interface CredentialSummary {
  /** 尚未获得时为空 */
  credential_id: string | null;
  kind: CredentialKind;
  /** 星球居民证 / 星球银行卡 / 照护档案 / 护照 / 爪爪驾驶证 / 登机牌 / 船票车票 / 酒店房卡 */
  label: string;
  status: CredentialStatus;
  /** 稳定唯一的证件编号；签发后不变 */
  number: string | null;
  /** 持久保存的签发时间；刷新不会变成“今天签发” */
  issued_at: IsoDateTime | null;
  title: string | null;
  /** 获得条件 */
  condition: string;
  /** 只给主人看（照护档案等），不进公开卡片 */
  private: boolean;
  /** 关联的经历 */
  links: CredentialLink[];
}
export type CredentialSummaryInput = WithOptional<CredentialSummary, "credential_id" | "number" | "issued_at" | "title" | "private" | "links">;

export interface LedgerEntry {
  tx_id: string;
  type: string;
  delta: number;
  reason: string;
  created_at: IsoDateTime;
  /** 这笔钱关联的业务：journey（旅费、工资、退款）/ order（集市订单）/ home（家园商店、欢迎礼）；其他为空 */
  ref_kind?: string | null;
  /** 关联业务的编号，例如工资与旅费对应的 journey_id（0.4.1） */
  ref_id?: string | null;
}
export type LedgerEntryInput = WithOptional<LedgerEntry, "ref_kind" | "ref_id">;

export interface PassportStamp {
  city: string;
  stamped_at: IsoDateTime;
  journey_id: string;
  title: string;
}
export type PassportStampInput = PassportStamp;

export interface CredentialDetail {
  summary: CredentialSummary;
  /** 卡面信息（服务端给出，前端只负责排版） */
  fields: CredentialField[];
  /** 星球银行卡：现有钱包余额（同一个账户，不另建余额） */
  balance: number | null;
  /** 星球银行卡：最近的收入与支出 */
  ledger: LedgerEntry[];
  /** 护照：到达后盖的纪念章 */
  stamps: PassportStamp[];
  /** 照护档案：主人确认过的习惯、安抚方式与叮嘱（私密） */
  care_notes: string[];
}
export type CredentialDetailInput = WithOptional<CredentialDetail, "fields" | "balance" | "ledger" | "stamps" | "care_notes">;

export interface SessionBrief {
  session_id: string;
  subject: SchoolSubject;
  mode: SessionMode;
  item: string | null;
  attempt_kind: AttemptKind | null;
  state: SchoolSessionState;
  passed: boolean | null;
  score: number | null;
  created_at: IsoDateTime;
  settled_at: IsoDateTime | null;
}
export type SessionBriefInput = WithOptional<SessionBrief, "item" | "attempt_kind" | "passed" | "score" | "settled_at">;

export interface SubjectStatus {
  subject: SchoolSubject;
  title: string;
  theme: string;
  /** quiz（科一、科四）/ drive（科二、科三） */
  kind: string;
  state: SubjectState;
  passed_at: IsoDateTime | null;
  passed_score: number | null;
  /** 旧版驾考已通过（此前自动答题的版本），不再需要考试 */
  legacy: boolean;
  /** 第几轮（冷却结束后开始新一轮） */
  round_no: number;
  /** 本轮已经用掉的正式考试次数（0—2） */
  attempts_used: number;
  /** 本轮还剩几次正式考试（首次＋补考共 2 次） */
  attempts_left: number;
  /** 下一次正式考试是首次还是补考 */
  next_attempt: AttemptKind | null;
  /** 冷却中时：可以再约考试的时间（服务器时间） */
  cooldown_until: IsoDateTime | null;
  /** 锁定时的原因，例如“先过科目一”（短：320 宽的入口卡里不断行） */
  unlock_hint: string | null;
  /** 这一科未结束的正式考局，回来可以接着考 */
  open_session_id: string | null;
  last_result: SessionBrief | null;
  practice_count: number;
}
export type SubjectStatusInput = WithOptional<SubjectStatus, "passed_at" | "passed_score" | "legacy" | "next_attempt" | "cooldown_until" | "unlock_hint" | "open_session_id" | "last_result" | "practice_count">;

export interface CoachInfo {
  name: string;
  line: string;
  intro: string;
}
export type CoachInfoInput = CoachInfo;

export interface DrivingSchoolStatus {
  stage: SchoolStage;
  /** TA 为什么想学开车 */
  wish_text: string | null;
  enrolled_at: IsoDateTime | null;
  coach: CoachInfo;
  subjects: SubjectStatus[];
  /** 未结束的正式考局（同一时间最多一场） */
  open_session: SessionBrief | null;
  license: CredentialSummary | null;
  /** 还有一张驾校借车券（第一次自驾免租车费） */
  voucher_available: boolean;
  /** 领证仪式已经做过 */
  ceremony_done: boolean;
  /** lively / steady / quiet：挑选 TA 台词的性格（来自 DNA 行为画像） */
  temperament: string;
  rules_version: string;
  server_time: IsoDateTime;
}
export type DrivingSchoolStatusInput = WithOptional<DrivingSchoolStatus, "wish_text" | "enrolled_at" | "open_session" | "license" | "voucher_available" | "ceremony_done">;

export interface LessonStep {
  title: string;
  body: string;
}
export type LessonStepInput = LessonStep;

export interface DeductionRule {
  label: string;
  points: number;
}
export type DeductionRuleInput = DeductionRule;

export interface ItemInfo {
  /** reverse_park / side_park / curve / route；练习另有 reverse_straight / reverse_turn */
  item: string;
  title: string;
  time_limit_s: number;
}
export type ItemInfoInput = ItemInfo;

export interface SubjectCurriculum {
  subject: SchoolSubject;
  title: string;
  theme: string;
  format: string;
  pass_rule: string;
  pass_score: number;
  duration: string;
  kind: string;
  lessons: LessonStep[];
  deductions: DeductionRule[];
  /** 红线：触发即自动制动、本次不通过（开考前必须展示） */
  red_lines: string[];
  /** 正式考试的项目（科二三项、科三一条路线） */
  items: ItemInfo[];
  practice_items: ItemInfo[];
}
export type SubjectCurriculumInput = WithOptional<SubjectCurriculum, "items" | "practice_items">;

export interface SchoolCurriculum {
  rules_version: string;
  coach: CoachInfo;
  subjects: SubjectCurriculum[];
  controls: string[];
  retake_rule: string[];
  cooldown_hours: number;
  /** 按性格（lively / steady / quiet）的台词：pass / fail / park / right / license */
  pet_lines: Record<string, Record<string, string>>;
  /** 判定事件与扣分的说明文字（line → 压线、red_light → 闯了红灯……），前端实时提示与成绩单共用 */
  reasons: Record<string, string>;
}
export type SchoolCurriculumInput = SchoolCurriculum;

export interface QuizOption {
  option_id: string;
  label: string;
}
export type QuizOptionInput = QuizOption;

export interface QuizTarget {
  target_id: string;
  label: string;
}
export type QuizTargetInput = QuizTarget;

/** 题目（不含答案）。match：把 options 放到 targets 上；order：把 options 排成正确顺序。 */
export interface QuizQuestionView {
  question_id: string;
  kind: QuizKind;
  /** 场景插画的键（前端按键绘制） */
  scene: string;
  topic_title: string;
  prompt: string;
  options: QuizOption[];
  targets: QuizTarget[];
  /** 科四：同一段情境的两个判断共用一个 group */
  group: string | null;
  group_title: string | null;
  story: string[];
}
export type QuizQuestionViewInput = WithOptional<QuizQuestionView, "targets" | "group" | "group_title" | "story">;

export interface QuizAnswer {
  choice: string | null;
  order: string[] | null;
  /** {target_id: option_id} */
  matches: Record<string, string> | null;
}
export type QuizAnswerInput = WithOptional<QuizAnswer, "choice" | "order" | "matches">;

export interface QuizFeedback {
  question_id: string;
  correct: boolean;
  correct_answer: QuizAnswer;
  explanation: string;
  pet_line: string;
}
export type QuizFeedbackInput = QuizFeedback;

export interface QuizProgress {
  questions: QuizQuestionView[];
  /** 已保存的作答（续考时恢复） */
  answers: Record<string, QuizAnswer>;
  /** 练习模式的即时讲解；正式模式交卷前为空 */
  feedback: Record<string, QuizFeedback>;
}
export type QuizProgressInput = WithOptional<QuizProgress, "answers" | "feedback">;

export interface InputEvent {
  /** tick（每秒 30 个），每一项从 0 开始 */
  t: number;
  /** s 转向目标 / t 油门 / b 刹车 / g 换挡 / k 转向灯 / c 出发前检查 / v 视频邀请 */
  c: string;
  v: number;
}
export type InputEventInput = InputEvent;

export interface SimEvent {
  t: number;
  /** line / cone / out_of_bounds / timeout / done / precheck_skipped / start_no_signal / stop_rolled / crosswalk / red_light / turn_no_signal / speeding / invite_shown / invite_opened */
  k: string;
  ref: string | null;
  /** 扣分 */
  p: number;
  /** 1＝红线或失败，本项立即结束 */
  f: number;
}
export type SimEventInput = WithOptional<SimEvent, "ref">;

export interface DriveItemProgress {
  item: string;
  title: string;
  /** 场地配置：车身、正切表、速度、线、锥桶、目标区、时限、路线检查点与装饰（渲染用） */
  course: Record<string, unknown>;
  /** pending / running / done / failed */
  status: string;
  committed_tick: number;
  /** 服务端已接受的操作（续考时本地重放恢复状态） */
  events: InputEvent[];
  /** 服务端复算出的判定事件 */
  sim_events: SimEvent[];
  /** 服务端复算到 committed_tick 时的模拟快照（用于对齐） */
  snapshot: Record<string, unknown> | null;
}
export type DriveItemProgressInput = WithOptional<DriveItemProgress, "events" | "sim_events" | "snapshot">;

export interface DriveProgress {
  items: DriveItemProgress[];
  current_item: number;
}
export type DriveProgressInput = DriveProgress;

export interface Deduction {
  kind: string;
  label: string;
  points: number;
  item: string | null;
  t: number | null;
  ref: string | null;
  question_id: string | null;
}
export type DeductionInput = WithOptional<Deduction, "item" | "t" | "ref" | "question_id">;

export interface QuestionReview {
  question_id: string;
  prompt: string;
  correct: boolean;
  your_answer: QuizAnswer | null;
  correct_answer: QuizAnswer;
  explanation: string;
}
export type QuestionReviewInput = WithOptional<QuestionReview, "your_answer">;

export interface ItemResult {
  item: string;
  title: string;
  status: string;
  deducted: number;
  ticks: number;
}
export type ItemResultInput = ItemResult;

export interface NextStep {
  /** passed / licensed / retake / cooldown / practice */
  kind: string;
  message: string;
  attempts_left: number | null;
  cooldown_until: IsoDateTime | null;
}
export type NextStepInput = WithOptional<NextStep, "attempts_left" | "cooldown_until">;

export interface SessionResult {
  passed: boolean;
  score: number;
  max_score: number;
  pass_score: number;
  deductions: Deduction[];
  /** 红线或失败原因（科二科三），例如超时、闯红灯、主动放弃 */
  fatal: Deduction | null;
  /** 科一科四：结算后才给出正确答案与讲解 */
  review: QuestionReview[];
  items: ItemResult[];
  pet_says: string;
  next: NextStep | null;
}
export type SessionResultInput = WithOptional<SessionResult, "deductions" | "fatal" | "review" | "items" | "next">;

export interface SchoolSession {
  session_id: string;
  subject: SchoolSubject;
  title: string;
  mode: SessionMode;
  item: string | null;
  attempt_kind: AttemptKind | null;
  round_no: number | null;
  state: SchoolSessionState;
  pass_score: number;
  created_at: IsoDateTime;
  begun_at: IsoDateTime | null;
  paused_at: IsoDateTime | null;
  settled_at: IsoDateTime | null;
  void_reason: string | null;
  quiz: QuizProgress | null;
  drive: DriveProgress | null;
  result: SessionResult | null;
}
export type SchoolSessionInput = WithOptional<SchoolSession, "item" | "attempt_kind" | "round_no" | "begun_at" | "paused_at" | "settled_at" | "void_reason" | "quiz" | "drive" | "result">;

export interface SessionCreateRequest {
  subject: SchoolSubject;
  mode: SessionMode;
  /** 练习单项（科二：reverse_straight / reverse_turn / reverse_park / side_park / curve）；不填为整科 */
  item: string | null;
}
export type SessionCreateRequestInput = WithOptional<SessionCreateRequest, "item">;

export interface AnswerRequest {
  question_id: string;
  answer: QuizAnswer;
}
export type AnswerRequestInput = AnswerRequest;

export interface AnswerResult {
  question_id: string;
  saved: boolean;
  answered: number;
  total: number;
  /** 只在练习模式返回 */
  feedback: QuizFeedback | null;
}
export type AnswerResultInput = WithOptional<AnswerResult, "feedback">;

export interface InputChunk {
  item_index: number;
  from_tick: number;
  upto_tick: number;
  events: InputEvent[];
}
export type InputChunkInput = WithOptional<InputChunk, "events">;

export interface InputResult {
  session_id: string;
  session_state: SchoolSessionState;
  item_index: number;
  current_item: number;
  item_status: string;
  committed_tick: number;
  new_events: SimEvent[];
  /** 这一场到目前为止的扣分合计（服务端复算） */
  deducted: number;
  snapshot: Record<string, unknown> | null;
  result: SessionResult | null;
}
export type InputResultInput = WithOptional<InputResult, "new_events" | "snapshot" | "result">;

export interface AbandonRequest {
  /** 必须为 true：放弃已经开始的正式考试，计为本次不通过 */
  confirm: boolean;
}
export type AbandonRequestInput = AbandonRequest;

export interface CeremonyResult {
  license: CredentialSummary;
  /** 领证合影（收藏） */
  memento: CollectionItem | null;
  /** 驾校借车券（第一次自驾免租车费；用掉后为空） */
  voucher: CollectionItem | null;
  pet_says: string;
  /** 这是第一次看仪式（再次打开只是回看） */
  first_time: boolean;
}
export type CeremonyResultInput = WithOptional<CeremonyResult, "memento" | "voucher">;

export interface PublicEntry {
  route: EntryRoute;
  label: string;
  needs_login: boolean;
  note: string | null;
}
export type PublicEntryInput = WithOptional<PublicEntry, "note">;

/** 一位还在星球上生活的驿站居民：可以领养的，或平台原创角色（看 `resident_kind`）。住处是星球居民驿站（世界规则提供食宿，不是某位真实用户的家）。 */
export interface PublicResident {
  pet_id: string;
  candidate_id: string;
  name: string;
  species: PetSpecies;
  personality: string;
  dream: string;
  origin: PetOrigin;
  /** 来源说明；未知为 null，不编造 */
  source_note: string | null;
  /** 住在哪个驿站，例如“星球居民驿站·中环” */
  residence: string;
  city: string;
  living_since: IsoDateTime;
  /** 此刻在哪（按已发生的行程推算，访客读取不会推进世界） */
  presence: PetPresence;
  /** 此刻在做什么，例如“在驿站休息”“在去码头的路上” */
  doing: string;
  /** 此刻在家（presence＝at_home）时实际睡没睡：true 睡着、false 醒着；说不清或不在家为 null（不猜，不拿作息冒充）。与 doing 出自同一次实际睡眠读数（PUBLIC-RESIDENT-ASLEEP-116） */
  asleep?: boolean | null;
  /** 正在到访的真实地点名（来自地图供应商的公开地点）；在驿站或路上时为空 */
  place_name: string | null;
  /** 在外面时，这一趟计划回到驿站的时间；在驿站、或已过点还没结算完（说不准）时为 null。领养之后要等 TA 回到驿站才能入住，领养前可以据此说清大约几点能接回家（2026-09-25） */
  back_at?: IsoDateTime | null;
  /** 最近的公开动态（最多 3 条） */
  recent_posts: Post[];
  /** TA 的照片（公开路由，访客可看）；没有照片为 null。与 `PublicPetView.profile.avatar_url` 同一个地址、同一条规则。平台原创居民的形象是生成的原创设计，不是真实照片。后台给平台宠物设了官方形象时，是带版本的公开地址 `/api/v1/web/public/identity/{pet_id}/official/{revision}`（D4：普通下架照常能读，撤回使用权 404；与 identity.url 同值） */
  avatar_url?: string | null;
  /** avatar_url 是不是后台设的官方形象照（D4）。为 true 时读屏说「{名字}的官方形象」，不按来源推断「AI 生成」——官方形象照不一定是生成的 */
  official_avatar?: boolean;
  /** 设了官方形象照时，TA 原来那张照片的地址（规则同没有官方形象照时的 avatar_url）；官方形象打不开时（如缓存期内被撤回使用权）退回用它。没设官方形象照、或原来就没有照片时为 null */
  fallback_avatar_url?: string | null;
  /** 居民类别：adoptable＝可以领养；public_npc＝PetSoul 原创角色（不参加领养，页面标「PetSoul 原创角色」）。领养名单（`GET /public/residents`）里只有 adoptable；原创角色只出现在它自己的公开主页上（2026-09-27） */
  resident_kind?: ResidentKind;
  /** 身份图（D4，访客视角）：领养前后同一版官方形象、同一个地址；avatar_url／official_avatar／fallback_avatar_url 都由它推出 */
  identity?: PetIdentityImage | null;
  /** 此刻在不在星球地图上（I-PUB-STATE）：名单接口（/public/world、/public/residents）才给；单只主页里的 resident 为 null（不算这一项） */
  map_presence?: MapPresence | null;
  /** map_presence 为 off_map 时的原因；在图上或没算时为 null */
  off_map_reason?: OffMapReason | null;
}
export type PublicResidentInput = WithOptional<PublicResident, "source_note" | "asleep" | "place_name" | "back_at" | "recent_posts" | "avatar_url" | "official_avatar" | "fallback_avatar_url" | "resident_kind" | "identity" | "map_presence" | "off_map_reason">;

export interface PublicPetView {
  profile: PetPublicProfile;
  /** 仍在驿站生活时才有：可以领养的居民，或平台原创角色（看 `resident.resident_kind`） */
  resident: PublicResident | null;
  /** 能不能领养：只有可领养类才为 true，原创角色为 false */
  adoptable: boolean;
  posts: Post[];
}
export type PublicPetViewInput = WithOptional<PublicPetView, "resident" | "adoptable" | "posts">;

export interface PublicWorld {
  server_time: IsoDateTime;
  entries: PublicEntry[];
  residents: PublicResident[];
  /** 全星球最近的公开动态 */
  recent_posts: Post[];
  living_residents: number;
  /** 这份内容最多缓存多久（访客页刷新不会每次都重算） */
  cache_seconds: number;
  data_origin: DataOrigin;
  /** 名单里此刻在星球地图上有点的几位（I-PUB-STATE）；与 living_residents 分开给，「人数有、位置无」说得清 */
  placed_residents?: number;
  /** 公开居民图层接全了没有。false＝暂时看不了（名单与图层按合同回空），不是「0 位」；读失败另走非 200 */
  layer_ready?: boolean;
  /** 星球此刻的天色（访客页按它换昼夜底图）：与作息同一个算法（太阳高度角），参考点是东八区标准经线 120°E、纬度 30°N；每次返回都按返回那一刻现算（不跟 30 秒缓存），只取决于时刻，不含任何私有信息。按城市分的天色以后另给 */
  sky?: PublicSky | null;
}
export type PublicWorldInput = WithOptional<PublicWorld, "recent_posts" | "placed_residents" | "layer_ready" | "sky">;

/** 公开位置：登记住宅 POI 代表点不声明精度；其余来源是网格吸附的大约位置。 */
export interface PublicMapPosition {
  lat: number;
  lng: number;
  basis: PublicMapBasis;
  /** 必填：residential_site 为 null，住宅 POI 代表点不声明精度，不造 0 或半径；其余四类为正整数，表示格子中心到最远一角的距离（米，向上取整到 10 米）。随纬度变化（香港约 760 米），只说网格量化误差；route_area 按路线与时间表估算，不是实时定位 */
  precision_m: number | null;
}
export type PublicMapPositionInput = PublicMapPosition;

/** 一个地方的公开说法（大约位置）：与 PublicMapPosition 的四类 area 来源同一套网格吸附，只到片区，不对应门牌。 */
export interface PublicArea {
  /** 所在格子中心的纬度（WGS-84），不是实测坐标 */
  lat: number;
  /** 所在格子中心的经度（WGS-84），不是实测坐标 */
  lng: number;
  /** 格子中心到这一格最远一角的距离（米），与 PublicMapPosition 的四类 area 来源的 precision_m 同一算法 */
  precision_m: number;
  /** 片区级的叫法，例如「中环一带（香港）」：按坐标找最近的片区，离所有片区都远时只给城市名；不含店名、驿站名、门牌。坐标对应不到城市时为 null，不补造 */
  name: string | null;
  /** 所在城市；说不清为 null */
  city: string | null;
}
export type PublicAreaInput = WithOptional<PublicArea, "name" | "city">;

/** 在途居民这一程从哪一片到哪一片（前端画「正在去那一带」的弧线）。两头都只到片区；哪一头说不清，整个 move 为 null。 */
export interface PublicResidentMove {
  /** 去程是这一趟出发的驿站所在的片区，回程是这一趟到访地点所在的片区 */
  from_area: PublicArea;
  /** 去程是这一趟到访地点所在的片区（只到片区，到店前不说店名），回程是这一趟出发的驿站所在的片区 */
  to_area: PublicArea;
  /** 这一程几点出发（去程＝出门，回程＝离开到访地点），只到分钟 */
  departed_at: IsoDateTime;
  /** 按已排好的行程预计几点到，只到分钟；没有为 null。是计划时刻，不是实时估算 */
  arrive_eta: IsoDateTime | null;
}
export type PublicResidentMoveInput = WithOptional<PublicResidentMove, "arrive_eta">;

/** 星球地图公开图层上的一位平台居民（W2-R）。只放公开安全的字段：没有家庭、主人、私信、叮嘱、运营记录或内部编号。 */
export interface PublicMapResident {
  /** 宠物号，与公开主页 `GET /public/pets/{pet_id}` 同一个；主页链接由前端按它拼（路由归前端） */
  pet_id: string;
  name: string;
  species: PetSpecies;
  resident_kind: ResidentKind;
  /** 能不能领养：可领养类才为 true，原创角色为 false（与 PublicPetView.adoptable 同一条规则） */
  adoptable: boolean;
  /** 官方形象（D4 身份图的首选，访客视角）：带版本的公开地址 `/api/v1/web/public/identity/{pet_id}/official/{revision}`，与公开主页头像同一个地址。上图层的前提就是官方形象能用，所以一定有；与 identity.url 同值 */
  avatar_url: string;
  /** 身份图的版本串（与 identity.version 同值，只用于比相等）：换了官方形象就变 */
  avatar_version: string;
  /** 身份图（D4，访客视角，与公开主页同一条链）：退路图与占位都读这里。AI 来源字段照 D4 给，玩家页不显示 AI 字样（用户 09-29），数据留给运营后台 */
  identity: PetIdentityImage;
  /** 住在哪个驿站，与 PublicResident.residence 同一个说法 */
  residence: string;
  /** 此刻在哪（at_home＝在驿站），与 PublicResident.presence 同一口径 */
  presence: PetPresence;
  /** 此刻在做什么，与 PublicResident.doing 同一句 */
  doing: string;
  /** 此刻在家时实际睡没睡，与 PublicResident.asleep 同一口径；说不清或不在家为 null */
  asleep?: boolean | null;
  /** 正在到访的已公开地点名；只在 visiting 且地点有名字时有（未知不补造），与 PublicResident.place_name 同一个 */
  place_name: string | null;
  /** 此刻所在城市：在驿站＝驿站城市；到访＝这一趟的城市；在路上这一程两头在同一座城市就给这座城市，跨城或哪一头说不清为 null（不写两座城市之间） */
  city: string | null;
  /** 公开位置：符合条件且真实在家的平台居民使用当前有效登记住宅 POI 代表点（residential_site，precision_m 为 null）；其余来源维持网格大约位置。来源或状态不明时为 null（只进列表、不上地图点） */
  position: PublicMapPosition | null;
  /** 在途（presence 为 in_transit 或 returning）时这一程从哪一片到哪一片；在驿站、到访中一律 null，哪一头说不清也为 null */
  move?: PublicResidentMove | null;
}
export type PublicMapResidentInput = WithOptional<PublicMapResident, "asleep" | "place_name" | "city" | "position" | "move">;

/** 星球地图的公开居民图层（`GET /public/world/residents`，W2-R）。访客与登录玩家看到同一份：不看会话、不按人变。 */
export interface PublicResidentMap {
  server_time: IsoDateTime;
  coord_system: string;
  residents: PublicMapResident[];
  /** 此刻图层上一共有几位（所有分页合计） */
  total: number;
  /** 下一页的游标，原样带回；没有下一页为 null */
  next_cursor: string | null;
  /** 位置与在做什么最多缓存多久。不是撤权宽限：核准、撤回、样本、撤下、领养、形象撤权与 DATA-01 每次返回前都重新检查，此刻不合格的当场不给 */
  cache_seconds: number;
  /** 四类 area 来源的位置吸附网格边长（度），同一格坐标相同；residential_site 保留登记住宅 POI 代表点，不吸附。前端按实际返回坐标相等聚合 */
  grid_deg: number;
  /** 「附近」的半径（米）：前端拿自家宠物家片区中心（/world/state 的 home.center）与卡片 position 算距离，在这个半径内的算附近；没有有效的家片区中心就显示城市／全部居民，不编造「附近」、不申请定位；服务端不收任何坐标 */
  nearby_radius_m: number;
  /** 名单上的公开居民一共几位（与 /public/world 的 living_residents 同一口径，I-PUB-STATE） */
  public_total?: number;
  /** 其中此刻在图上有点的几位（total 里还含没有点、只进列表的那几位） */
  placed_total?: number;
  /** 不在图上的按原因计数：{OffMapReason 的值: 人数}；没有就是空对象 */
  off_map?: Record<string, number>;
  /** 图层接全了没有；false＝暂时看不了，不是 0 位 */
  layer_ready?: boolean;
}
export type PublicResidentMapInput = WithOptional<PublicResidentMap, "coord_system" | "next_cursor" | "public_total" | "placed_total" | "off_map" | "layer_ready">;

export interface PublicFeedPhoto {
  /** 当前合格居民生活照片的原生公开用途地址（/api/v1/web/public/residents/{pet_id}/life-photos/{media_id}）；退役明信片地址不恢复 */
  url: string;
  /** 读屏用的一句话 */
  alt: string;
  /** 原已提交出游事件的拍摄时刻，不以成图/展示时刻代替 */
  captured_at: IsoDateTime | null;
  /** 关联原公开世界事件的散列编号；不公开内部行程或到访号 */
  source_event_id: string | null;
}
export type PublicFeedPhotoInput = WithOptional<PublicFeedPhoto, "captured_at" | "source_event_id">;

/** 公开事件流里的一条：谁、什么时候、在哪一带、发生了什么。只有此刻公开的居民，地点只到片区。 */
export interface PublicFeedItem {
  /** 这一条的稳定编号（散列，不是内部记录号）；分页去重用，只比相等 */
  event_id: string;
  /** 这件事发生的时刻（世界里原本应发生的时刻，不是登记时刻） */
  at: IsoDateTime;
  kind: PublicFeedKind;
  /** 涉及的宠物号（都是此刻公开的居民），与公开主页 `GET /public/pets/{pet_id}` 同一个 */
  pet_ids: string[];
  /** 在哪一带（只到片区）；说不清为 null。相遇（met）的读口不给坐标，恒为 null，片区名写在 text 里 */
  area: PublicArea | null;
  /** 一句中文，直接显示 */
  text: string;
  /** 只有已经发成公开动态、公开地址打得开的图才有；其余为 null */
  photo: PublicFeedPhoto | null;
}
export type PublicFeedItemInput = WithOptional<PublicFeedItem, "area" | "photo">;

/** 公开事件流（`GET /public/world/feed`）：星球上正在发生什么。访客与玩家同一份；只读已提交的世界事实，读取不推进世界。 */
export interface PublicWorldFeed {
  server_time: IsoDateTime;
  /** 按时间倒序；同一时刻按 event_id 倒序，翻页不重不漏 */
  items: PublicFeedItem[];
  /** 更早一页的游标，原样放进 `before` 带回；没有更早的为 null */
  next_cursor: string | null;
  /** 事件流依赖的公开居民图层接全了没有（I-PUB-STATE）。true 且 items 为空＝此刻真没有动态；false＝暂时看不了；读失败走非 200。server_time 就是截至时刻 */
  layer_ready?: boolean;
}
export type PublicWorldFeedInput = WithOptional<PublicWorldFeed, "next_cursor" | "layer_ready">;

/** 按居民的公开时间线（`GET /public/residents/{pet_id}/timeline`；PUBLIC-RESIDENT-TIMELINE-117）：TA 的一天、TA 的朋友、TA 的照片。 */
export interface PublicResidentTimeline {
  server_time: IsoDateTime;
  state: PublicTimelineState;
  /** 与这一位有关的公开事实，按时间倒序（同一时刻按 event_id 倒序）：TA 出门／到了／回到驿站（打工、去参加星球活动在出门那句里），TA 是主角或同行的公开照片（photo_posted），TA 参与的相遇（met，对方也此刻公开）。state=unknown 时为空 */
  items: PublicFeedItem[];
  /** 更早一页的游标，原样放进 `before` 带回；没有更早的为 null */
  next_cursor: string | null;
  /** 公开居民图层接全了没有（同 PublicWorldFeed.layer_ready）；false＝暂时看不了 */
  layer_ready: boolean;
}
export type PublicResidentTimelineInput = WithOptional<PublicResidentTimeline, "next_cursor" | "layer_ready">;

export interface ProviderHealth {
  /** llm / amap / amap_static / google / image */
  provider: string;
  label: string;
  state: ProviderState;
  last_success_at: IsoDateTime | null;
  last_failure_at: IsoDateTime | null;
  /** 脱敏后的错误摘要 */
  last_error: string | null;
  calls_today: number;
  daily_cap: number | null;
}
export type ProviderHealthInput = WithOptional<ProviderHealth, "last_success_at" | "last_failure_at" | "last_error" | "calls_today" | "daily_cap">;

export interface WorldRunnerStatus {
  /** embedded（API 进程内）/ worker（独立任务进程）/ off */
  runner: string;
  interval_seconds: number;
  /** 这个 API 进程里的世界线程是否在跑 */
  running_here: boolean;
  /** 有没有进程持有有效租约（正在推进世界） */
  lease_alive: boolean;
  lease_holder_role: string | null;
  lease_pid: number | null;
  last_tick_at: IsoDateTime | null;
  last_ok_at: IsoDateTime | null;
  last_error: string | null;
  ticks: number;
  /** 最老一件已到期但还没登记的世界事实等了多少秒；持续变大说明这条线卡住了（0.4.1） */
  due_lag_seconds?: number | null;
  /** 世界线的判定：在岗／卡住（在跑，但该做的事超过阈值一直没做）／诊断不可用（报告缺失、取数失败或超期）／失联／按配置关着。只有世界线有；没装判定时为 null */
  health?: WorldRunnerHealth | null;
  /** 判成卡住或诊断不可用的原因（在岗、失联、关着时为空） */
  stall_reasons?: WorldStallReason[];
  /** 超过阈值还没动的宠物数（全量，不截 200）；诊断不可用且没有上一份好报告时为 null */
  overdue_pets?: number | null;
  /** 这份判定所据的报告是什么时候算的（同一进程最多复用 30 秒） */
  health_checked_at?: IsoDateTime | null;
}
export type WorldRunnerStatusInput = WithOptional<WorldRunnerStatus, "lease_holder_role" | "lease_pid" | "last_tick_at" | "last_ok_at" | "last_error" | "ticks" | "due_lag_seconds" | "health" | "stall_reasons" | "overdue_pets" | "health_checked_at">;

export interface OutboxHealth {
  /** 世界事件下游：communicator / social / collection / credentials / guides / friends */
  consumer: string;
  pending: number;
  delivered: number;
  /** 重试用尽、需要人看的条数 */
  dead_letter: number;
  /** 最老一条待投递等了多少秒；持续变大说明这个下游卡住了 */
  oldest_pending_seconds: number | null;
}
export type OutboxHealthInput = WithOptional<OutboxHealth, "pending" | "delivered" | "dead_letter" | "oldest_pending_seconds">;

export interface RuntimeDueItem {
  /** 到期事项的引用，例如 journey:<旅程编号>、reply:<会话>；不含正文 */
  ref: string;
  /** journey / reply / cooldown / other */
  kind: string;
  due_at: IsoDateTime;
  /** 对家人的承诺（工钱、待回复）：不能被延期或丢弃 */
  commitment: boolean;
}
export type RuntimeDueItemInput = WithOptional<RuntimeDueItem, "commitment">;

/** 一只宠物此刻的运行详情（只给本机或管理令牌）：用来回答“TA 为什么这么安静”。 */
export interface PetRuntimeStatus {
  pet_id: string;
  as_of: IsoDateTime;
  realm_id: string;
  household_id: string | null;
  /** TA 此刻所在地的时区；认不出就是空，运行层会明确报不可用，不套用默认城市 */
  timezone: string | null;
  region_id: string | null;
  /** 家园 / 驿站 / 店铺 / 交通段的引用 */
  scene_ref: string | null;
  activity_kind: string;
  activity_ref: string | null;
  activity_ends_at: IsoDateTime | null;
  interruptible: boolean;
  /** 当地作息（入睡, 起床），来自 DNA 画像；未知为空 */
  sleep_window: string[];
  /** 语义版本代数：思考开始时记下，提交时再比一次 */
  versions: Record<string, number | null>;
  due_items: RuntimeDueItem[];
  next_check_at: IsoDateTime | null;
  /** 上一次决定时写下的「到这个时刻再重新考虑」。与 next_check_at 不是一回事：next_check_at 是**此刻**按当前事实算出来的下次查看时间，next_review_at 是**当时那次决定**留下的有效期（例如「先留在家，两小时后再看」）。两者都可能为空。 */
  next_review_at: IsoDateTime | null;
  /** 安静的原因：正常生活 / 暂无新决策 / 额度延期 / 依赖不可用 / 任务卡住 / 维护 */
  silence_reason: string | null;
  last_evaluated_at: IsoDateTime | null;
  last_decision_at: IsoDateTime | null;
  /** model / rule_fallback / rule */
  last_decision_by: string | null;
  maintenance: boolean;
  /** 按当前事实立刻评估一次心跳的结论（只读，不执行） */
  heartbeat_action: string | null;
  heartbeat_reasons: string[];
  /** 这只宠物的家庭是否同意把共用资料交给模型 */
  cognition_enabled: boolean;
  /** off / shadow / live */
  brain_mode: string;
}
export type PetRuntimeStatusInput = WithOptional<PetRuntimeStatus, "household_id" | "timezone" | "region_id" | "scene_ref" | "activity_ref" | "activity_ends_at" | "interruptible" | "sleep_window" | "versions" | "due_items" | "next_check_at" | "next_review_at" | "silence_reason" | "last_evaluated_at" | "last_decision_at" | "last_decision_by" | "maintenance" | "heartbeat_action" | "heartbeat_reasons" | "cognition_enabled">;

export interface FrontendHint {
  /** 前端应使用的数据模式：live 只走本后端；fixture 是演示数据，不连后端 */
  data_mode: string;
  api_base: string;
  /** vite dev/preview 的代理目标（PETSOUL_DEV_API_TARGET） */
  dev_proxy_target: string;
  note: string;
}
export type FrontendHintInput = FrontendHint;

export interface OpsStatus {
  /** dev / demo / real-local / staging / production（只是标签，不改变行为） */
  environment: string;
  server_time: IsoDateTime;
  backend_version: string;
  /** 正在使用的数据库文件（相对后端目录；目录外时为绝对路径） */
  database: string;
  media_dir: string;
  sqlite_wal: boolean;
  providers_enabled: boolean;
  providers: ProviderHealth[];
  world: WorldRunnerStatus;
  /** 认知线（可能调模型的表达与回复）：与世界线分开的线程和租约，卡住不影响到期结算（0.4.1） */
  cognition?: WorldRunnerStatus | null;
  applied_migrations: number;
  last_migration: string | null;
  capabilities: Capability[];
  frontend: FrontendHint;
  /** 后台任务：到期未领、领取中、租期已过仍在跑、用完次数、最老到期等待秒数（0.4.1） */
  tasks?: Record<string, number>;
  /** 世界事件各下游的投递情况（0.4.1） */
  outbox?: OutboxHealth[];
}
export type OpsStatusInput = WithOptional<OpsStatus, "cognition" | "last_migration" | "tasks" | "outbox">;

/** `GET /map/config` 的响应。未配置时 `available=false` 且 `js_key`/`service_host` 为空。 */
export interface MapConfig {
  provider: MapProvider;
  available: boolean;
  js_key: string | null;
  service_host: string | null;
  style: string;
  style_dark: string;
  overseas_tiles: boolean;
  unavailable_reason: MapUnavailableReason | null;
}
export type MapConfigInput = WithOptional<MapConfig, "provider" | "js_key" | "service_host" | "overseas_tiles" | "unavailable_reason">;

/** 家的模糊中心。**只给家庭成员**；非成员整个字段为 None，不是坐标置零。 */
export interface WorldHome {
  center: LatLng;
  precision_m: number;
  label: string;
}
export type WorldHomeInput = WorldHome;

export interface WorldJob {
  title: string;
  pay: number;
  paid: boolean;
}
export type WorldJobInput = WorldJob;

export interface WorldPlace {
  name: string;
  lat: number;
  lng: number;
  attribution: string | null;
}
export type WorldPlaceInput = WithOptional<WorldPlace, "attribution">;

/** 只在 going / returning 出现。`route` 用**出发时已缓存**的几何，没有就 `[]`——读时不调地图。 */
export interface WorldLeg {
  mode: string;
  route: LatLng[];
  departs_at: IsoDateTime | null;
  arrives_at: IsoDateTime | null;
}
export type WorldLegInput = WithOptional<WorldLeg, "route" | "departs_at" | "arrives_at">;

export interface WorldPosition {
  lat: number;
  lng: number;
  basis: WorldPositionBasis;
  precision_m: number;
}
export type WorldPositionInput = WorldPosition;

export interface WorldActivity {
  kind: WorldActivityKind;
  phase: WorldPhase;
  pose: WorldPose;
  title: string;
  doing: string | null;
  place: WorldPlace | null;
  since: IsoDateTime | null;
  until: IsoDateTime | null;
  job: WorldJob | null;
  journey_id: string | null;
  visit_id: string | null;
  /** 停留（含过夜的停留地，西安 D0）期间、停留地当地的夜里为 true，这时 pose=sleeping；按停留地的时区与 TA 的作息判，时区不知道就是 false（未知不算睡着） */
  overnight?: boolean;
  /** 停留期间的停留地（或住处），带资料出处 attribution；不是停留为 null */
  stay_place?: WorldPlace | null;
}
export type WorldActivityInput = WithOptional<WorldActivity, "doing" | "place" | "since" | "until" | "job" | "journey_id" | "visit_id" | "overnight" | "stay_place">;

export interface WorldPetState {
  pet_id: string;
  name: string;
  species: string;
  avatar_url: string | null;
  relation: WorldRelation;
  home: WorldHome | null;
  activity: WorldActivity;
  leg: WorldLeg | null;
  position: WorldPosition | null;
  /** 在家时的作息与天色（L2-0＋#16）；不在家为 null。房间与锚点不在这里（只在 /home） */
  rhythm?: HomeRhythm | null;
  /** 身份头像（D4，家人视角）。avatar_url 仍是证件照裁图、没有就是 null（W1，不变）；地图头像：有官方形象用 identity，否则照旧证件照裁图 → identity → 占位 */
  identity?: PetIdentityImage | null;
  version: number;
}
export type WorldPetStateInput = WithOptional<WorldPetState, "avatar_url" | "home" | "leg" | "position" | "rhythm" | "identity" | "version">;

export interface WorldState {
  server_time: IsoDateTime;
  coord_system: string;
  cache_seconds: number;
  pets: WorldPetState[];
}
export type WorldStateInput = WithOptional<WorldState, "coord_system" | "cache_seconds" | "pets">;

/** 作息与天色（L2-0＋#16；后端 `web_runtime/rhythm.py` 一处算）。**`asleep` 为 null 是不知道，不是醒着。** */
export interface HomeRhythm {
  asleep: boolean | null;
  next_change_at: IsoDateTime | null;
  next_change: string | null;
  timezone: string | null;
  local_date: IsoDate | null;
  season: RhythmSeason | null;
  sky: RhythmSky | null;
  sunrise_at: IsoDateTime | null;
  sunset_at: IsoDateTime | null;
  polar: string | null;
  basis: RhythmBasis;
  rule_version: string;
  profile_rules_version: string | null;
}
export type HomeRhythmInput = WithOptional<HomeRhythm, "asleep" | "next_change_at" | "next_change" | "timezone" | "local_date" | "season" | "sky" | "sunrise_at" | "sunset_at" | "polar" | "basis" | "profile_rules_version">;

export interface AnnouncementItem {
  item_id: string;
  slug: string;
  revision: number;
  title: string;
  body: string;
  severity: AnnouncementSeverity;
  link: string | null;
  image_asset_id: string | null;
  image_url: string | null;
  effective_at: IsoDateTime | null;
  expires_at: IsoDateTime | null;
}
export type AnnouncementItemInput = WithOptional<AnnouncementItem, "link" | "image_asset_id" | "image_url" | "effective_at" | "expires_at">;

export interface AnnouncementFeed {
  announcements: AnnouncementItem[];
  as_of: IsoDateTime;
  source: AnnouncementSource;
}
export type AnnouncementFeedInput = WithOptional<AnnouncementFeed, "announcements">;

export interface ReportOutcomeItem {
  report_id: string;
  target_kind: string;
  target_id: string;
  reason: string;
  created_at: IsoDateTime;
  status: ReportStatus;
  outcome: ReportOutcome;
  resolved_at: IsoDateTime | null;
  message: string;
}
export type ReportOutcomeItemInput = WithOptional<ReportOutcomeItem, "resolved_at">;

export interface MyReports {
  reports: ReportOutcomeItem[];
  note: string;
}
export type MyReportsInput = WithOptional<MyReports, "reports">;

/** TA 想去的一个地方。**「有心愿」不等于「可以出发」**（合同 §3）。 */
export interface TravelWishCandidate {
  destination_key: string;
  title: string;
  executable: boolean;
  blocked_by: TravelWaitingReason[];
}
export type TravelWishCandidateInput = WithOptional<TravelWishCandidate, "executable" | "blocked_by">;

/** 当前活动心愿（一只宠物同时只有一个 active 或 ready 的）。对应 A 的 `WishView`。 */
export interface TravelWish {
  wish_id: string;
  pet_id: string;
  wish_revision: number;
  status: TravelWishStatus;
  destination_key: string;
  destination_name: string;
  city: string;
  owner_reason: string;
  funds_goal: number | null;
  waiting_reasons: TravelWaitingReason[];
  research_state: TravelResearchStatus | null;
  research_round: number;
  plan_id: string | null;
  plan_revision: number | null;
  journey_id: string | null;
  reconsider_after: IsoDateTime | null;
  last_considered_at: IsoDateTime | null;
  plan_stale: boolean;
  target_coins: number | null;
  current_coins: number | null;
  candidates: TravelWishCandidate[];
}
export type TravelWishInput = WithOptional<TravelWish, "funds_goal" | "waiting_reasons" | "research_state" | "research_round" | "plan_id" | "plan_revision" | "journey_id" | "reconsider_after" | "last_considered_at" | "plan_stale" | "target_coins" | "current_coins" | "candidates">;

/** TA 惦记着的一个远方（用户 2026-09-27「需要惦记」；A 的 `web_travel_longings`，合同 TRV-00 §38.3）。 */
export interface TravelLonging {
  longing_id: string;
  /** 惦记的地方，如「东京」「浅水湾」 */
  place_name: string;
  city: string;
  /** 地区（可空） */
  region: string | null;
  /** 给主人的一句理由（TA 为什么惦记那里） */
  owner_reason: string;
  created_at: IsoDateTime;
}
export type TravelLongingInput = WithOptional<TravelLonging, "region">;

/** 一条来源。`url` 可空——只有机构名没有链接时也是合法来源。 */
export interface TravelSource {
  source_id: string;
  url: string | null;
  publisher: string | null;
  retrieved_at: IsoDateTime | null;
  published_at: IsoDateTime | null;
}
export type TravelSourceInput = WithOptional<TravelSource, "url" | "publisher" | "retrieved_at" | "published_at">;

/** 一条已核验（或已被判否）的事实。 */
export interface TravelFact {
  fact_id: string;
  /** 类别，开放集合（审核不限制类别）。已知的九类与建议叫法：destination_identity 地点、route 怎么去、opening 开放时间、weather 天气、notice 公告、ticket_price 门票、transport_price 交通费、feature 看点、landmark 地标；不认识的类别归入「其他资料」（2026-09-25 定稿） */
  category: string;
  subject: string;
  /** JSON，形状按类别（2026-09-25 定稿，研究端口照此产出）：destination_identity 是 {lat, lng}（WGS-84 数字，页面不显示原值，导航用站点的 nav_url）；weather 是 {suitable: 布尔, summary: 一句中文如「多云」}；ticket_price／transport_price 是 {amount: 非负数字, currency: ISO 4217 三位大写, estimated: 布尔}，日期取本条自己的时间字段；route、opening、notice、feature、landmark 是一句中文字符串。被判 rejected 时为 null。认不出的形状不要原样显示 */
  value: unknown;
  source_ids: string[];
  verification: string | null;
  conclusion: string | null;
  verdict: TravelFactVerdict;
  blocks_departure: boolean;
  retrieved_at: IsoDateTime | null;
  published_at: IsoDateTime | null;
  observed_at: IsoDateTime | null;
  valid_from: IsoDateTime | null;
  valid_until: IsoDateTime | null;
}
export type TravelFactInput = WithOptional<TravelFact, "value" | "source_ids" | "verification" | "conclusion" | "blocks_departure" | "retrieved_at" | "published_at" | "observed_at" | "valid_from" | "valid_until">;

/** 计划里的一个地点。 */
export interface TravelStop {
  station_id: string | null;
  name: string;
  role: TravelStopRole;
  why: string | null;
  tip: string | null;
  fact_ids: string[];
  verified: boolean;
  lat: number | null;
  lng: number | null;
  nav_url: string | null;
  visited_event_ids: string[];
}
export type TravelStopInput = WithOptional<TravelStop, "station_id" | "why" | "tip" | "fact_ids" | "verified" | "lat" | "lng" | "nav_url" | "visited_event_ids">;

/** 给主人的一条提醒：带数字（含金额符号）的必须有已核验事实支持；不带数字的一般叮嘱可以没有 `fact_ids`（合同 §18.4）。 */
export interface TravelOwnerTip {
  text: string;
  /** 支持这条提醒的已核验事实；为空＝一般叮嘱（不带数字），照常显示、不挂来源 */
  fact_ids: string[];
  /** 安全类可爱贴纸的键（用户 2026-09-27：「有鲨鱼不让下水」做成可爱的东西）。A 在发布计划时按这条提醒引用的公告（category=notice）用封闭关键词表判，不信模型自报；不是这类就为 null。前端只在非 null 时画安全便签，贴纸由界面叠加（TRV-05 §12.4） */
  safety_sticker?: TravelSafetySticker | null;
}
export type TravelOwnerTipInput = WithOptional<TravelOwnerTip, "fact_ids" | "safety_sticker">;

/** 计划关联的那趟真实行程里，跟钱有关的部分。 */
export interface TravelJourneySummary {
  journey_id: string;
  fare: number;
  fare_waived: boolean;
  /** 车费由平台补助时的来源（`{kind}:{ref}`，如 `event:<活动号>`）；没有补助为 null。判定顺序：先看它，再看 fare_waived，最后看 fare */
  fare_sponsor?: string | null;
}
export type TravelJourneySummaryInput = WithOptional<TravelJourneySummary, "fare" | "fare_waived" | "fare_sponsor">;

/** 一版计划（`web_travel_plans` 的一行，主键 `(plan_id, plan_revision)`）。**旧版都留着。** */
export interface TravelPlanRevision {
  plan_id: string;
  plan_revision: number;
  wish_id: string;
  wish_revision_at_build: number;
  pet_id: string;
  destination_key: string;
  operation_id: string | null;
  title: string;
  summary: string;
  rain_alternative: string | null;
  stops: TravelStop[];
  owner_tips: TravelOwnerTip[];
  preconditions: string[];
  sources: TravelSource[];
  facts: TravelFact[];
  valid_from: IsoDateTime | null;
  valid_until: IsoDateTime | null;
  journey: TravelJourneySummary | null;
  journals: TravelJournal[];
  created_at: IsoDateTime;
}
export type TravelPlanRevisionInput = WithOptional<TravelPlanRevision, "operation_id" | "rain_alternative" | "stops" | "owner_tips" | "preconditions" | "sources" | "facts" | "valid_from" | "valid_until" | "journey" | "journals">;

/** 一个心愿的计划全集。`current_revision` 指最新发布的那一版。 */
export interface TravelPlan {
  plan_id: string;
  wish_id: string;
  current_revision: number;
  revisions: TravelPlanRevision[];
}
export type TravelPlanInput = WithOptional<TravelPlan, "revisions">;

/** 一页手账（`web_travel_journals` 的一行，主键 `(journal_id, journal_revision)`）。 */
export interface TravelJournal {
  journal_id: string;
  journal_revision: number;
  plan_id: string;
  plan_revision: number;
  phase: TravelJournalPhase;
  title: string | null;
  summary: string | null;
  stations: TravelStop[];
  owner_tips: TravelOwnerTip[];
  rain_alternative: string | null;
  sources: TravelSource[];
  identity_mode: TravelIdentityMode;
  identity_note: string | null;
  template_revision: string | null;
  image_status: PhotoStatus | null;
  image_url: string | null;
  /** 这一页为什么没有图：P 的编译拒绝码（被拒就没有图，但手账照样有文字，§9）；或 A 的 `local_trip_no_image`＝本地活动类心愿按设计不画图（用户 2026-09-27「不需要配」），前端按正常状态画，不写「图没画成」、不给重画。其余取值照 P 的拒绝码表 */
  image_refused: string | null;
  redraw_ticket: string | null;
  event_ids: string[];
  created_at: IsoDateTime;
  updated_at: IsoDateTime | null;
  /** 这一趟由星球活动补助车费时的「星球活动：xxx」（世界运营第二期 2a D9）；公开与否照旧只看家庭开关，这里只说属于哪个活动 */
  planet_event?: PlanetEventTag | null;
}
export type TravelJournalInput = WithOptional<TravelJournal, "title" | "summary" | "stations" | "owner_tips" | "rain_alternative" | "sources" | "identity_mode" | "identity_note" | "template_revision" | "image_status" | "image_url" | "image_refused" | "redraw_ticket" | "event_ids" | "updated_at" | "planet_event">;

/** 主人点「重画」一页手账的图（`POST /travel/plans/{plan_id}/journal/redraw`；需 CSRF 与 Idempotency-Key）。 */
export interface TravelJournalRedrawRequest {
  expected_revision: number;
  journal_id: string;
  redraw_ticket: string;
}
export type TravelJournalRedrawRequestInput = TravelJournalRedrawRequest;

/** 重做研究（`POST /travel/plans/{plan_id}/research/retry`；需 CSRF 与 Idempotency-Key；合同 §7）。回 200 与之后的心愿。 */
export interface TravelResearchRetryRequest {
  expected_revision: number;
}
export type TravelResearchRetryRequestInput = TravelResearchRetryRequest;

/** 取消心愿（`POST /travel/wish/{wish_id}/cancel`；需 CSRF 与 Idempotency-Key；合同 §7）。回 200 与取消后的心愿（status=cancelled）。 */
export interface TravelWishCancelRequest {
  expected_revision: number;
}
export type TravelWishCancelRequestInput = TravelWishCancelRequest;

/** 历次旅行回忆的一条（`GET /travel/memories`）：某个心愿已发布的一版计划，这一版里有回忆手账（phase = memory）。 */
export interface TravelMemoryHistoryItem {
  plan_id: string;
  wish_id: string;
  plan_revision: number;
  memory_created_at: IsoDateTime;
  revision: TravelPlanRevision;
}
export type TravelMemoryHistoryItemInput = TravelMemoryHistoryItem;

/** 一只宠物的历次旅行回忆，一页（`GET /travel/memories`，最新的在前）。 */
export interface TravelMemoryHistory {
  pet_id: string;
  items: TravelMemoryHistoryItem[];
  next_cursor: string | null;
}
export type TravelMemoryHistoryInput = WithOptional<TravelMemoryHistory, "items" | "next_cursor">;

export interface PlanetEvent {
  event_id: string;
  title: string;
  /** 活动的主题故事（运营写的，照原文） */
  story: string;
  /** 活动地点在出行目的地里的键；「告诉 TA」与判断 TA 能不能去都按它 */
  destination_key: string;
  destination_title: string;
  /** 意向中的真实地点名字（只给人看；没有就是 null） */
  venue_name: string | null;
  window_start: IsoDateTime;
  window_end: IsoDateTime;
  /** 车费的说法（例如「车费由星球活动补助，不花 TA 的星币」） */
  fare_note: string;
}
export type PlanetEventInput = WithOptional<PlanetEvent, "venue_name">;

export interface PlanetEventList {
  events: PlanetEvent[];
  as_of: IsoDateTime;
}
export type PlanetEventListInput = PlanetEventList;

export interface PlanetEventTag {
  event_id: string;
  title: string;
}
export type PlanetEventTagInput = PlanetEventTag;

export interface PlanetEventTell {
  event_id: string;
  pet_id: string;
  /** 告诉 TA 时活动的标题（活动结束后栏里不再列它，这里仍能说清是哪一个） */
  title: string;
  destination_key: string;
  window_start: IsoDateTime;
  window_end: IsoDateTime;
  status: PlanetEventTellStatus;
  told_at: IsoDateTime;
  /** status=used 时，挂在这个活动上的那一趟 */
  journey_id: string | null;
  /** 这一行从哪来：owner＝家人告诉的；heard＝TA 自己听说的（D10）。同一个活动两种都有时各一行；撤回 heard 行要在 DELETE 带 source=heard */
  source?: PlanetEventTellSource;
  /** status=used 时这一趟走到哪了：scheduled＝排好了还没出门；traveling＝已经出门；returned＝已经回到家。其余状态为 null */
  journey_phase?: PlanetEventJourneyPhase | null;
}
export type PlanetEventTellInput = WithOptional<PlanetEventTell, "journey_id" | "source" | "journey_phase">;

export interface PlanetEventTellList {
  tells: PlanetEventTell[];
}
export type PlanetEventTellListInput = PlanetEventTellList;

export interface PlanetEventTellRequest {
  event_id: string;
}
export type PlanetEventTellRequestInput = PlanetEventTellRequest;

export interface PhotoSourceRef {
  kind: PhotoSourceKind;
  /** visit＝到访号；photo_ask＝请求号；legacy_request＝旧申请的来源键；arrival＝宠物号；creative＝作品号（cr-…） */
  id: string;
  /** 到访＝登记时的到访事实代数；命令型恒 1；到站为空 */
  revision: number | null;
}
export type PhotoSourceRefInput = WithOptional<PhotoSourceRef, "revision">;

export interface PhotoPlace {
  label: string | null;
  city: string | null;
  place_id: string | null;
  /** 拍摄地的时区；缺就是空，界面写「当地时间待核」，不拿宿主机或香港补 */
  timezone: string | null;
}
export type PhotoPlaceInput = WithOptional<PhotoPlace, "label" | "city" | "place_id" | "timezone">;

/** 画这张时用的身份参考。参考来源与 D4 身份图（`PetIdentityImage.source_kind`）同一个词表，不另起一套。 */
export interface PhotoIdentity {
  mode: PhotoIdentityMode;
  /** 参考照从哪来：owner_original（主人原照）／real_archive（档案真照）／original_companion（我们生成的基准照、随仓原创形象，或 TA 生效的角色中性形象）／platform_official（平台官方形象）。只在 mode=reference 时有；A 在成图时落库，旧记录为空 */
  source_kind: IdentitySourceKind | null;
  /** 实际用的身份参考照指纹（A 落库后才有；只在 mode=reference 时给） */
  reference_digest: string | null;
  /** 登记那一刻生效的世界身体版本（BODY-0；旧记录、登记时没有身体档案为空） */
  body_version: number | null;
}
export type PhotoIdentityInput = WithOptional<PhotoIdentity, "source_kind" | "reference_digest" | "body_version">;

export interface PhotoAudience {
  scope: PhotoAudienceScope;
  /** 只在查看者就是请求人时返回 */
  requester_user_id: string | null;
}
export type PhotoAudienceInput = WithOptional<PhotoAudience, "requester_user_id">;

export interface PhotoGeneration {
  /** processing／ready／failed／unknown；unknown＝结果还没确认，不能写成「没画成」 */
  state: PhotoStatus;
  can_retry: boolean;
}
export type PhotoGenerationInput = PhotoGeneration;

export interface PhotoAsset {
  /** 只有 ready 才有；其余状态一律为空，不回退原照 */
  media_url: string | null;
  content_type: string | null;
  kind: PhotoAssetKind;
}
export type PhotoAssetInput = WithOptional<PhotoAsset, "media_url" | "content_type" | "kind">;

/** 哪些地方引用了这张照片（只列查看者自己看得见的：私聊只列本人那条）。 */
export interface PhotoRefs {
  message_ids: string[];
  collection_item_ids: string[];
  journal_ids: string[];
  post_ids: string[];
}
export type PhotoRefsInput = WithOptional<PhotoRefs, "message_ids" | "collection_item_ids" | "journal_ids" | "post_ids">;

export interface PhotoActivityRef {
  visit_id: string | null;
  journey_id: string | null;
}
export type PhotoActivityRefInput = WithOptional<PhotoActivityRef, "visit_id" | "journey_id">;

/** 相册里的一张照片：就是一条插画记录的只读投影。 */
export interface PetPhoto {
  /** ＝插画记录号（也是媒体地址那一段）；旧拍照申请的 request_id 也是它 */
  photo_id: string;
  pet_id: string;
  household_id: string | null;
  source: PhotoSourceRef;
  trigger: PhotoTrigger;
  /** 拍摄意图那一刻（登记时冻结），不是成图时刻 */
  captured_at: IsoDateTime;
  place: PhotoPlace;
  /** 服务端按宠物日册时区算好的日期，前端按它分组、不用浏览器时区 */
  album_day: IsoDate | null;
  category: PhotoCategory;
  narrative: PhotoNarrative;
  identity: PhotoIdentity;
  audience: PhotoAudience;
  generation: PhotoGeneration;
  asset: PhotoAsset;
  /** TA 配的话；没有就是空（读接口绝不临时生成） */
  caption: string | null;
  refs: PhotoRefs;
  activity: PhotoActivityRef | null;
}
export type PetPhotoInput = WithOptional<PetPhoto, "household_id" | "album_day" | "caption" | "activity">;

export interface PetAlbumPage {
  items: PetPhoto[];
  /** 按 (captured_at 倒序, photo_id 倒序) 翻页；新照片中途提交不跳项、不重复 */
  next_cursor: string | null;
  /** 这位查看者在这个筛选下能看到的总数 */
  total_visible: number;
}
export type PetAlbumPageInput = WithOptional<PetAlbumPage, "items" | "next_cursor">;

/** 关联经历的只读摘要。 */
export interface PhotoExperience {
  visit_id: string | null;
  journey_id: string | null;
  place_name: string | null;
  journey_title: string | null;
}
export type PhotoExperienceInput = WithOptional<PhotoExperience, "visit_id" | "journey_id" | "place_name" | "journey_title">;

export interface PetPhotoDetail {
  photo: PetPhoto;
  experience: PhotoExperience | null;
}
export type PetPhotoDetailInput = WithOptional<PetPhotoDetail, "experience">;

/** 从相册移除：只表示「不在相册里显示」，不删照片、不动私聊与收藏。 */
export interface AlbumHideResult {
  photo_id: string;
  hidden: boolean;
  hidden_at: IsoDateTime;
}
export type AlbumHideResultInput = WithOptional<AlbumHideResult, "hidden">;

/** 到访详情里引用的那张照片（与相册里同一个 photo_id、同一个文件）。 */
export interface PetPhotoRef {
  photo_id: string;
  media_url: string | null;
  captured_at: IsoDateTime;
  state: PhotoStatus;
}
export type PetPhotoRefInput = WithOptional<PetPhotoRef, "media_url">;

/** 请 TA 拍一张（需 CSRF 与 Idempotency-Key）。**没有自由文本字段**：主人的原话不进生图提示词；场景由服务端按 TA 此刻的真实活动决定。 */
export interface PhotoAskCommand {
  origin: PhotoAskChannel;
  source_message_id: string | null;
}
export type PhotoAskCommandInput = WithOptional<PhotoAskCommand, "source_message_id">;

export interface PhotoAskQuotaScope {
  scope: PhotoAskScope;
  limit: number;
  used: number;
  remaining: number;
  /** 下一个日册日零点（宠物日册时区），服务端算好，前端不自己算 */
  reset_at: IsoDateTime;
}
export type PhotoAskQuotaScopeInput = PhotoAskQuotaScope;

export interface PhotoAskInFlight {
  count: number;
  max: number;
}
export type PhotoAskInFlightInput = PhotoAskInFlight;

/** 生活照的一个桶（A-PHOTOASK-STATE-01）：owner＝主人请拍那一类扣的（每天 3）；autonomous＝TA 自己拍的（在干嘛、到访、梗图，每天 7）。 */
export interface PhotoAskBucket {
  /** owner／autonomous */
  bucket: string;
  limit: number;
  used: number;
  remaining: number;
  reset_at: IsoDateTime | null;
  /** 这一桶用完了是 quota_exhausted，否则为空 */
  reason: string | null;
}
export type PhotoAskBucketInput = WithOptional<PhotoAskBucket, "reset_at" | "reason">;

/** 生图层的余量（全站、每宠；只报，不加不改）。 */
export interface PhotoAskImageLayer {
  /** 层名，例如 platform、pet */
  layer: string;
  limit: number;
  used: number;
  remaining: number;
  /** 这一层用完了是 quota_exhausted，否则为空 */
  reason: string | null;
}
export type PhotoAskImageLayerInput = WithOptional<PhotoAskImageLayer, "reason">;

/** 请求次数只来自服务端；前端不自己计数、不自己算重置时间。 */
export interface PhotoAskQuota {
  /** 计次所在的日册日（宠物住处时区的当地日期） */
  quota_day: IsoDate;
  /** 算这个日册日用的时区名 */
  quota_tz: string;
  /** 旧三层次数（每人每宠、每宠、每家庭）：只在生活照额度没开、它们真挡请求时给；开着时为空，张数看 buckets（主人桶、自主桶），一个数只说一次 */
  scopes: PhotoAskQuotaScope[];
  in_flight: PhotoAskInFlight;
  cooldown_until: IsoDateTime | null;
  /** 今天主人还能请拍几张：max(0, 主人桶每日张数 − 今天已用)；主人桶每日张数（现为 3）是这只宠物全家、各入口共用的新照片张数，不是请求次数 */
  remaining?: number | null;
  /** 还在画的生活照张数（不分天） */
  preparing?: number | null;
  /** 结果还没确认、等核对的生活照张数（不分天，不算进 preparing） */
  checking?: number | null;
  /** 今天的张数在这一刻重置：次日日册零点（宠物住处时区），服务端算好 */
  reset_at?: IsoDateTime | null;
  /** 此刻请不了的原因，只按一个顺序报一个：album_day_unknown → quota_exhausted → request_in_flight → cooldown → busy；能请时为 null */
  reason?: string | null;
  /** 多少秒后再试：用完到 reset_at，冷却到 cooldown_until，暂忙到供应商预算的次日 UTC 零点；算不出时为 null */
  retry_after?: number | null;
  /** 生活照两个桶各自的上限、已用、剩余与耗尽原因（主人桶、自主桶，不相加）；额度关着为空 */
  buckets?: PhotoAskBucket[];
  /** 生图层（全站、每宠）的余量与耗尽原因；没接读口时为空 */
  image_layers?: PhotoAskImageLayer[];
}
export type PhotoAskQuotaInput = WithOptional<PhotoAskQuota, "scopes" | "cooldown_until" | "remaining" | "preparing" | "checking" | "reset_at" | "reason" | "retry_after" | "buckets" | "image_layers">;

export interface PhotoAskResult {
  request_id: string;
  outcome: PhotoAskOutcome;
  photo_id: string;
  task_id: string | null;
  scene_label: string | null;
  captured_at: IsoDateTime | null;
  quota: PhotoAskQuota;
  reply_message_id: string | null;
}
export type PhotoAskResultInput = WithOptional<PhotoAskResult, "task_id" | "scene_label" | "captured_at" | "reply_message_id">;

/** 本人的一次请求记录。生成状态不在请求表里存，一律读插画记录。 */
export interface PhotoAsk {
  request_id: string;
  pet_id: string;
  origin: PhotoAskOrigin;
  outcome: PhotoAskOutcome;
  photo_id: string | null;
  task_id: string | null;
  scene_key: string | null;
  /** 受理那天（之后成图或失败都不改） */
  quota_day: IsoDate;
  /** 受理时算日册日用的时区名 */
  quota_tz: string;
  quota_state: PhotoAskQuotaState;
  created_at: IsoDateTime;
  /** 此刻的状态：processing／ready／failed／checking（结果待核） */
  status?: PhotoAskStatus;
  /** 能不能重试：结果待核一律不能；明确失败只在有授权的重试通道时才能 */
  can_retry?: boolean;
  /** 这次请求是在哪条聊天消息上发起的；旧记录为空 */
  source_message_id?: string | null;
  /** 照片的四态；照片此刻对你不可见或记录已不在时为空 */
  generation_state: PhotoStatus | null;
  photo: PetPhoto | null;
}
export type PhotoAskInput = WithOptional<PhotoAsk, "photo_id" | "task_id" | "scene_key" | "status" | "can_retry" | "source_message_id" | "generation_state" | "photo">;

export interface PhotoAskPage {
  items: PhotoAsk[];
  next_cursor: string | null;
}
export type PhotoAskPageInput = WithOptional<PhotoAskPage, "items" | "next_cursor">;

/** 一处部位变化。视图里三种用法：世界相对现实（world_differs）、首期能提的变化（eligible_changes）、修订相对上一修订（history）。 */
export interface CareChange {
  /** 部位编号，按体型取（四足 head、ear_l、limb_hl……；鸟 wing_l……），不是一张全局枚举 */
  part_id: string;
  from_state: BodyPartState;
  to_state: BodyPartState;
}
export type CareChangeInput = CareChange;

/** 外观设置三选项此刻的选择（每宠一行）。只影响页面要不要再提示，不是授权凭证。 */
export interface CarePreferenceView {
  choice: CarePreferenceChoice;
  /** 没选过是 0；写回时带它做 expected_version */
  version: number;
  /** 最后一次是谁选的（user_id）；没选过为 null */
  set_by: string | null;
  /** 最后一次选的时刻；没选过为 null */
  set_at: IsoDateTime | null;
}
export type CarePreferenceViewInput = CarePreferenceView;

/** 一条医生请求此刻的样子。state、reason 读时派生；can_* 由服务端按此刻的权限、状态与开关算，页面不自己推权限。 */
export interface CareRequestView {
  request_id: string;
  kind: CareRequestKind;
  state: CareShownState;
  /** 请求行版本；预览、应用、取消带它做 expected_request_version */
  version: number;
  changes: CareChange[];
  /** 提议那一刻的世界修订号 */
  base_world_revision: number;
  proposer_user_id: string;
  proposer_is_me: boolean;
  /** 花额度生成预览的人；还没预览为 null */
  previewed_by: string | null;
  /** 应用或取消的人；还没有为 null */
  decided_by: string | null;
  /** 取值见 CareReason；没有为 null */
  reason: string | null;
  created_at: IsoDateTime;
  updated_at: IsoDateTime;
  /** 预览 7 天未应用即过期（进入 preview_ready 时起算）；还没到 preview_ready 为 null */
  expires_at: IsoDateTime | null;
  can_preview: boolean;
  can_apply: boolean;
  can_cancel: boolean;
}
export type CareRequestViewInput = CareRequestView;

/** 一个已生效的世界修订。 */
export interface WorldBodyRevisionView {
  revision: number;
  source: WorldBodyRevisionSource;
  /** 相对上一修订的部位变化；基线为空 */
  changes: CareChange[];
  /** 生效时刻 */
  at: IsoDateTime;
  /** 应用或恢复的人；不是医生请求产生的为 null */
  actor_user_id: string | null;
  /** 恢复自哪一版；不是恢复为 null */
  restored_from: number | null;
}
export type WorldBodyRevisionViewInput = WorldBodyRevisionView;

/** 外观设置页：TA 在 PetSoul 里的样子与现实档案的差别、三选项、未结请求与历史（GET 纯读；偏好命令也回它）。 */
export interface WorldBodyCareView {
  pet_id: string;
  /** 这只宠物此刻能不能用外观设置；false 时看 blocked_reason */
  available: boolean;
  /** 取值见 CareReason（不适用那组）；能用时为 null */
  blocked_reason: string | null;
  /** 生效的世界修订号；没有身体档案为 null */
  world_revision: number | null;
  /** 现实档案修订号；没有身体档案为 null */
  reality_revision: number | null;
  /** 世界相对现实的差别（from＝现实，to＝世界） */
  world_differs: CareChange[];
  /** 首期能提的变化：现实已确认 absent、世界仍 absent 的部位恢复成 present */
  eligible_changes: CareChange[];
  /** 要先去身份档案补证的部位编号：不给提议 */
  unconfirmed_parts: string[];
  preference: CarePreferenceView;
  /** 这只宠物唯一一条未结请求（状态按此刻派生，可能已是 expired、superseded）；没有为 null */
  open_request: CareRequestView | null;
  /** 全部世界修订，新到旧 */
  history: WorldBodyRevisionView[];
  can_propose: boolean;
  can_revert: boolean;
  /** 恢复上一版的目标修订号（只能恢复到上一版）；没有为 null */
  revert_target_revision: number | null;
  three_d_layer: ThreeDLayer;
  three_d_body_plan: ThreeDBodyPlan;
}
export type WorldBodyCareViewInput = WorldBodyCareView;

/** 外观设置三选项里的「保留 TA 的样子」「以后再说」：不产生任何任务或预占，不取消别人的未结请求。 */
export interface CarePreferenceCommand {
  choice: CarePreferenceOption;
  /** 读到的 preference.version（没选过是 0）；不等 409 VERSION_CONFLICT */
  expected_version: number;
}
export type CarePreferenceCommandInput = CarePreferenceCommand;

/** 提议里的一处变化：部位与目标状态（from 由服务端按现实档案填）。 */
export interface CareProposeChange {
  /** 部位编号，须在这只宠物体型的部位表里 */
  part_id: string;
  /** 首期只收 present（其余 409 change_not_supported） */
  to_state: BodyPartState;
}
export type CareProposeChangeInput = CareProposeChange;

/** 提议（S2，路由下一包接）：0 任务、0 预占；管理员与共同照顾者都能提。 */
export interface CareProposeCommand {
  /** 空的 409 no_change；同一部位写两次 422 */
  changes: CareProposeChange[];
  /** 读到的 world_revision；不等 409 VERSION_CONFLICT */
  expected_world_revision: number;
}
export type CareProposeCommandInput = CareProposeCommand;

/** 取消一条未结请求（S2，路由下一包接）：提议人本人或管理员；不花钱、不改形态。 */
export interface CareCancelCommand {
  /** 读到的 open_request.version；不等 409 VERSION_CONFLICT */
  expected_request_version: number;
}
export type CareCancelCommandInput = CareCancelCommand;

/** 主人为 TA 选定的生日（纪念、过生日用）：与出生信息分开，不改出生日期，不等于领养日。2 月 29 日照收。 */
export interface ChosenBirthday {
  month: number;
  day: number;
}
export type ChosenBirthdayInput = ChosenBirthday;

export interface PetAge {
  years: number;
  /** true 时界面写「约 N 岁」：出生信息不是年月日齐全且不是估计的 */
  approximate: boolean;
}
export type PetAgeInput = PetAge;

/** 出生信息：知道哪几样填哪几样。有日必有月；estimated 只修饰年份。 */
export interface PetBirth {
  /** 出生年；不知道为 null */
  year: number | null;
  /** 出生月；不知道为 null */
  month: number | null;
  /** 出生日；不知道为 null。填了日就要填月 */
  day: number | null;
  /** 年份是估计的（界面写「约」）；只在有年份时允许 */
  estimated: boolean;
}
export type PetBirthInput = WithOptional<PetBirth, "year" | "month" | "day" | "estimated">;

/** 整体保存（PUT /pets/{pet_id}/facts）：清除就传 unknown、全空或 null。要 Idempotency-Key；只有家庭管理员能改。 */
export interface PetCoreFactsUpdate {
  sex: PetSex;
  birth: PetBirth;
  chosen_birthday: ChosenBirthday | null;
  /** 读到的版本；首存传 0。家人在这之后改过 → 409 VERSION_CONFLICT（details.current_version） */
  expected_version: number;
}
export type PetCoreFactsUpdateInput = PetCoreFactsUpdate;

/** TA 的性别与生日（GET／PUT /pets/{pet_id}/facts 的回包）。只给这只宠物的家庭成员；公开主页、领养卡本期不带这些。 */
export interface PetCoreFactsView {
  pet_id: string;
  sex: PetSex;
  sex_source: FactSource | null;
  sex_confirmed_at: IsoDateTime | null;
  birth: PetBirth;
  birth_precision: BirthPrecision;
  /** 档案、证件共用的写法：2020年3月14日／2020年3月／3月14日／2020年；估计的年份只有年份时写「约2020年」，带月份的写「3月14日（年份约2020年）」「3月（年份约2020年）」；未知为 null */
  birth_label: string | null;
  birth_source: FactSource | null;
  birth_confirmed_at: IsoDateTime | null;
  /** 只有知道出生年时才给，按 TA 住处的当地日期算；只知道月日时为 null */
  age: PetAge | null;
  chosen_birthday: ChosenBirthday | null;
  chosen_source: FactSource | null;
  chosen_confirmed_at: IsoDateTime | null;
  /** 整条记录的版本；从没保存过为 0。保存时作为 expected_version 原样带回 */
  version: number;
}
export type PetCoreFactsViewInput = WithOptional<PetCoreFactsView, "sex_source" | "sex_confirmed_at" | "birth_label" | "birth_source" | "birth_confirmed_at" | "age" | "chosen_birthday" | "chosen_source" | "chosen_confirmed_at">;

/** 一条说法（BODY-0 §11.2）。group_count 给 group＋count；part_state 给 part_id＋state；dog_size 给 value。其余字段不给（null）。 */
export interface BodyStatementItem {
  kind: BodyStatementKind;
  /** kind=group_count：哪一组 */
  group: BodyGroup | null;
  /** kind=group_count：这一组有几个（不超过体型里这一组的部位数，服务端判） */
  count: number | null;
  /** kind=part_state：哪个部位（须属于这只宠物的体型，服务端判） */
  part_id: BodyPartId | null;
  /** kind=part_state：present／absent／partial */
  state: BodyStatementState | null;
  /** kind=dog_size：small／large（只对狗，服务端判） */
  value: BodyDogSize | null;
}
export type BodyStatementItemInput = WithOptional<BodyStatementItem, "group" | "count" | "part_id" | "state" | "value">;

/** 现实档案（R）里一个部位的状态与确认。 */
export interface BodyPartReality {
  state: BodyPartState;
  confirmation: BodyConfirmation;
}
export type BodyPartRealityInput = BodyPartReality;

/** 只知道数量的一组（BODY-0 §2.1 GroupCount）。 */
export interface BodyGroupCountView {
  group: BodyGroup;
  count: number;
  confirmation: BodyConfirmation;
}
export type BodyGroupCountViewInput = BodyGroupCountView;

/** 一条待确认的说法。家庭管理员看得到全部，成员只看得到自己提交的（服务端按查看者筛）。 */
export interface BodyPendingStatementView {
  statement_id: string;
  /** 提交人 user_id */
  submitted_by: string;
  items: BodyStatementItem[];
  submitted_at: IsoDateTime;
}
export type BodyPendingStatementViewInput = BodyPendingStatementView;

/** 一条还没处理的照片与档案冲突提示（BODY-0 §11.3）：只是提示，不是事实；页面不说照片里看到了什么。 */
export interface BodyConflictView {
  conflict_id: string;
  part_id: BodyPartId;
  observed_at: IsoDateTime;
  source: BodyConflictSource;
}
export type BodyConflictViewInput = BodyConflictView;

/** 身体档案页（BODY-0 §11.5，字段名照修订）。GET 纯读；写命令也回它。没有档案时两个修订号为 null、parts 为空。 */
export interface BodyProfileView {
  species: PetSpecies;
  /** 没有体型的物种（other）为 null：不建档案，写命令 422 body_value_invalid */
  body_plan: BodyPlan | null;
  /** 现实档案 R 的修订号；没有档案为 null。写命令带它做 expected_reality_revision（没有档案时带 0） */
  reality_revision: number | null;
  /** 生效的世界档案 W 的修订号；没有档案为 null */
  world_revision: number | null;
  /** 现实档案（R）：部位编号 → 状态与确认；没有档案为空 */
  parts: Record<string, BodyPartReality>;
  /** 世界里的有效状态（W＝R＋医生改动）：部位编号 → 状态；没有档案为空 */
  world_parts: Record<string, BodyPartState>;
  /** 只知道数量的组 */
  groups: BodyGroupCountView[];
  /** 狗的大小；没选或不是狗为 null */
  dog_size: BodyDogSize | null;
  size_class: BodySizeClass;
  size_class_basis: BodySizeClassBasis;
  /** 待确认的说法：管理员看全部，成员只看自己提交的 */
  pending_statements: BodyPendingStatementView[];
  /** 还没处理的照片与档案冲突提示 */
  conflicts: BodyConflictView[];
  /** 现实档案与医生改动的基准对不上的部位编号（纠正碰到了医生改过的部位，世界里按医生的为准） */
  notices: BodyPartId[];
  /** 要不要显示部位图示（BODY-0 §11.1，后端算好，前端不自己推） */
  show_body_diagram: boolean;
  /** 能不能提交说法（家庭成员且不是原创居民、物种有体型） */
  can_edit: boolean;
  /** 能不能确认、驳回说法与处理冲突（家庭管理员且不是原创居民、物种有体型） */
  can_confirm: boolean;
}
export type BodyProfileViewInput = BodyProfileView;

/** 提交说法（BODY-0 §11.2）：家庭管理员提交当场生效（出新 R），成员提交进待确认。不设「原因」字段。 */
export interface BodyStatementRequest {
  /** 读到的 reality_revision（没有档案时是 0）；不等 409 VERSION_CONFLICT（body_revision_conflict） */
  expected_reality_revision: number;
  /** 一次可提交多条；空的、同一部位或同一组说两次都 422 body_value_invalid */
  items: BodyStatementItem[];
}
export type BodyStatementRequestInput = BodyStatementRequest;

/** 提交之后。reality_revision：applied 时是新 R，pending 时仍是提交时的 R。 */
export interface BodyStatementResult {
  statement_id: string;
  status: BodyStatementStatus;
  reality_revision: number;
  body: BodyProfileView;
}
export type BodyStatementResultInput = BodyStatementResult;

/** 家庭管理员确认一条待确认的说法：按此刻的 R 套上去、重核，出新 R。 */
export interface BodyConfirmRequest {
  /** 读到的 reality_revision；不等 409 VERSION_CONFLICT（body_revision_conflict） */
  expected_reality_revision: number;
}
export type BodyConfirmRequestInput = BodyConfirmRequest;

/** 家庭管理员驳回一条待确认的说法：档案不变。请求体为空对象。 */
export interface BodyRejectRequest {
}
export type BodyRejectRequestInput = BodyRejectRequest;

/** 保留档案（BODY-0 §11.3）：冲突关闭，R 不变。只有家庭管理员。 */
export interface BodyConflictKeepRequest {
  /** 读到的 reality_revision；不等 409 VERSION_CONFLICT（body_revision_conflict） */
  expected_reality_revision: number;
}
export type BodyConflictKeepRequestInput = BodyConflictKeepRequest;

/** 按照片更正（BODY-0 §11.3）：走身份纠正，出新 R（来源 correction）。只有家庭管理员；items 形状同提交说法。 */
export interface BodyConflictCorrectRequest {
  /** 读到的 reality_revision；不等 409 VERSION_CONFLICT（body_revision_conflict） */
  expected_reality_revision: number;
  /** 更正后的说法；空的、同一部位说两次都 422 body_value_invalid */
  items: BodyStatementItem[];
}
export type BodyConflictCorrectRequestInput = BodyConflictCorrectRequest;

/** 聊天的另一方：此刻的公开名字与物种（与交友列表同一个来源）。没有简介。 */
export interface PetChatCounterpart {
  pet_id: string;
  /** 对方此刻的公开名字；对方改了名，下一次读就是新名字 */
  name: string;
  species: PetSpecies;
}
export type PetChatCounterpartInput = PetChatCounterpart;

/** 列表里的一场聊天。 */
export interface PetChatSummary {
  thread_id: string;
  counterpart: PetChatCounterpart;
  status: PetChatStatus;
  /** 结束了才有：结束了（不代表有过来回，看 exchange）、没接上话、中途停下、朋友的信过了回信时限没回（不是拒绝）；还没结束为 null */
  ended_how: PetChatEnding | null;
  /** 这只宠物看得见的句数：TA 自己说的，加上真送达给 TA 的 */
  line_count: number;
  started_at: IsoDateTime;
  ended_at: IsoDateTime | null;
  /** 这一场有没有来回，只按真送到的话算、不按说了算：聊过、打过招呼、没接上；还在进行、谁的话都还没送到为 null（界面说等回应或联系中，不说正在聊） */
  exchange?: PetChatExchange | null;
}
export type PetChatSummaryInput = WithOptional<PetChatSummary, "ended_how" | "ended_at" | "exchange">;

export interface PetChatPage {
  items: PetChatSummary[];
  /** 按（开始时刻倒序，thread_id 倒序）翻页，原样带回；没有下一页为 null */
  next_cursor: string | null;
}
export type PetChatPageInput = WithOptional<PetChatPage, "items" | "next_cursor">;

export interface PetChatLine {
  /** 这场聊天里的序号，从 1 起；回放只给这只宠物看得见的那几句，所以可能不连续 */
  seq: number;
  speaker: PetChatSpeaker;
  text: string;
}
export type PetChatLineInput = PetChatLine;

/** 一场聊天的回放：只有这只宠物看得见的那几句，按先后。 */
export interface PetChatReplay {
  thread_id: string;
  counterpart: PetChatCounterpart;
  status: PetChatStatus;
  /** 结束了才有：结束了（不代表有过来回，看 exchange）、没接上话、中途停下、朋友的信过了回信时限没回（不是拒绝）；还没结束为 null */
  ended_how: PetChatEnding | null;
  started_at: IsoDateTime;
  lines: PetChatLine[];
  /** 这一场有没有来回，只按真送到的话算、不按说了算：聊过、打过招呼、没接上；还在进行、谁的话都还没送到为 null（界面说等回应或联系中，不说正在聊） */
  exchange?: PetChatExchange | null;
}
export type PetChatReplayInput = WithOptional<PetChatReplay, "ended_how" | "lines" | "exchange">;

/** 旧的相遇记录：同一时刻、同一个地方才记一次，只说明遇见过，不代表说过话。 */
export interface PetFriendHistory {
  /** 旧记录里遇见的次数 */
  count: number;
  first_met_at: IsoDateTime;
  last_met_at: IsoDateTime;
  /** 最近一次遇见的地方 */
  last_place: string | null;
  /** 遇见过的地方，最多 10 个 */
  places: string[];
}
export type PetFriendHistoryInput = WithOptional<PetFriendHistory, "last_place" | "places">;

/** 现场相遇：一次现场相遇就是一场现场的会话，不管聊没聊起来；与旧记录分开给、不相加。 */
export interface PetFriendEncounters {
  /** 现场相遇的次数 */
  count: number;
  /** 第一次；没有过为 null */
  first_at: IsoDateTime | null;
  /** 最近一次；没有过为 null */
  last_at: IsoDateTime | null;
  /** 最近一次 TA 自己去的那个地方；不知道为 null */
  last_place: string | null;
}
export type PetFriendEncountersInput = WithOptional<PetFriendEncounters, "first_at" | "last_at" | "last_place">;

/** 相遇：旧记录与现场相遇分开给，不相加；每一段为 null 表示不知道。 */
export interface PetFriendMeetings {
  /** 旧的相遇记录；旧记录里没有这一位为 null */
  history: PetFriendHistory | null;
  /** 现场相遇；社交还没开、或不知道为 null */
  encounters: PetFriendEncounters | null;
}
export type PetFriendMeetingsInput = WithOptional<PetFriendMeetings, "history" | "encounters">;

/** 一段共同经历：TA 亲历的、仍然有效的。不给原话。 */
export interface PetFriendEpisode {
  happened_at: IsoDateTime;
  /** TA 自己去的那个地方；不知道为 null */
  place_label: string | null;
  /** 这一场里有没有任何一方的话真送到了对方 */
  talked: boolean;
  /** 回放入口：聊天回放那条路由（/pets/{pet_id}/pet-chats/{thread_id}） */
  thread_id: string;
}
export type PetFriendEpisodeInput = WithOptional<PetFriendEpisode, "place_label">;

/** 和这位朋友的一场聊天：只给句数与说法，不给原话；回放走聊天回放那条路由。 */
export interface PetFriendChat {
  /** 回放入口：/pets/{pet_id}/pet-chats/{thread_id} */
  thread_id: string;
  kind: PetChatKind;
  status: PetChatStatus;
  /** 结束了才有：结束了（不代表有过来回，看 exchange）、没接上话、中途停下、朋友的信过了回信时限没回（不是拒绝）；还没结束为 null */
  ended_how: PetChatEnding | null;
  /** 这一场有没有来回，只按真送到的话算、不按说了算：聊过、打过招呼、没接上；还在进行、谁的话都还没送到为 null（界面说等回应或联系中，不说正在聊） */
  exchange: PetChatExchange | null;
  /** TA 说的、真送到对方的句数（撤下、删除的不算） */
  mine_delivered: number;
  /** 对方说的、真送到 TA 的句数（撤下、删除的不算） */
  theirs_delivered: number;
  started_at: IsoDateTime;
  ended_at: IsoDateTime | null;
}
export type PetFriendChatInput = WithOptional<PetFriendChat, "ended_how" | "exchange" | "ended_at">;

/** 实际交流：最近 20 场，新的在前。 */
export interface PetFriendChats {
  items: PetFriendChat[];
  /** 还有更早的：全部历史用聊天列表按这位朋友筛（friend_id） */
  more: boolean;
}
export type PetFriendChatsInput = WithOptional<PetFriendChats, "items">;

/** 朋友列表里的一位：宠物（别家的，或同一家的另一只）或星球居民。不给原话，也不给对方的家与原因码。 */
export interface PetFriendSummary {
  friend_id: string;
  kind: PetFriendKind;
  /** 宠物：此刻的公开名字，改了名下一次读就是新名字；星球居民：旧记录里的名字 */
  name: string;
  /** 宠物才有；星球居民为 null */
  species: PetSpecies | null;
  /** 有没有来回，只按真送到的话算、取最好的一场：聊过、打过招呼、没接上、遇见过（没有会话）；null 表示不知道（会话还在进行、谁的话都还没送到，或社交还没开） */
  exchange: PetFriendExchange | null;
  /** 旧的相遇记录里的次数；旧记录里没有这一位为 null（不是 0 次） */
  meet_count_history: number | null;
  /** 现场相遇的次数（星球居民在社交开着时是 0）；社交还没开或不知道为 null */
  encounter_count: number | null;
  /** 关系：friends 不代表聊过，页面不显示成「是朋友」；ended 是已不是朋友（确曾有关系、后来明确解除，历史照给）；none 是没有关系记录（星球居民在社交开着时是 none）；null 表示不知道（社交还没开或不知道） */
  relation: PetFriendRelation | null;
  /** 最近一次往来：旧记录里最近一次遇见与会话最近的动静，取较晚的 */
  last_interaction_at: IsoDateTime;
}
export type PetFriendSummaryInput = WithOptional<PetFriendSummary, "species" | "exchange" | "meet_count_history" | "encounter_count" | "relation">;

/** 一位朋友的详情：摘要，加上相遇、共同经历、实际交流三段。每一段为 null 表示不知道，为空表示没有。不给原话。 */
export interface PetFriendDetail {
  friend_id: string;
  kind: PetFriendKind;
  /** 宠物：此刻的公开名字，改了名下一次读就是新名字；星球居民：旧记录里的名字 */
  name: string;
  /** 宠物才有；星球居民为 null */
  species: PetSpecies | null;
  /** 有没有来回，只按真送到的话算、取最好的一场：聊过、打过招呼、没接上、遇见过（没有会话）；null 表示不知道（会话还在进行、谁的话都还没送到，或社交还没开） */
  exchange: PetFriendExchange | null;
  /** 旧的相遇记录里的次数；旧记录里没有这一位为 null（不是 0 次） */
  meet_count_history: number | null;
  /** 现场相遇的次数（星球居民在社交开着时是 0）；社交还没开或不知道为 null */
  encounter_count: number | null;
  /** 关系：friends 不代表聊过，页面不显示成「是朋友」；ended 是已不是朋友（确曾有关系、后来明确解除，历史照给）；none 是没有关系记录（星球居民在社交开着时是 none）；null 表示不知道（社交还没开或不知道） */
  relation: PetFriendRelation | null;
  /** 最近一次往来：旧记录里最近一次遇见与会话最近的动静，取较晚的 */
  last_interaction_at: IsoDateTime;
  meetings: PetFriendMeetings;
  /** 共同经历，最多 20 段、新的在前；null 表示不知道（社交还没开或不知道），空表示没有（星球居民在社交开着时为空） */
  episodes: PetFriendEpisode[] | null;
  /** 实际交流；null 表示不知道（社交还没开或不知道），items 为空表示没有 */
  chats: PetFriendChats | null;
}
export type PetFriendDetailInput = WithOptional<PetFriendDetail, "species" | "exchange" | "meet_count_history" | "encounter_count" | "relation" | "episodes" | "chats">;

/** TA 的朋友：最近往来的在前。 */
export interface PetFriendPage {
  items: PetFriendSummary[];
  /** 朋友太多、只列了最近往来的 200 位时为 true */
  truncated: boolean;
}
export type PetFriendPageInput = WithOptional<PetFriendPage, "items">;

/** 「忙完回家」（CSRF＋Idempotency-Key）。**没有自由文本字段**；text_confirmed 必带确认条所在那条消息的编号，button 不许带。 */
export interface PlanRequestCommand {
  /** 主人确认时看到的那一趟（首页行程卡上的 journey_id） */
  journey_id: string;
  /** 主人确认时看到的行程版本；服务端对不上就不执行（409 VERSION_CONFLICT） */
  expected_itinerary_version: number;
  origin: PlanRequestOrigin;
  /** text_confirmed：确认条所在的那条主人消息；button 为空 */
  source_message_id: string | null;
}
export type PlanRequestCommandInput = WithOptional<PlanRequestCommand, "source_message_id">;

export interface PlanRequestCancel {
  /** 撤回时看到的请求版本（PlanRequestView.version）；对不上 409 VERSION_CONFLICT */
  expected_version: number;
}
export type PlanRequestCancelInput = PlanRequestCancel;

/** 中性安排：给其他家人看的只有这两项，没有请求人、来源消息与原因。 */
export interface PlanArrangement {
  state: ArrangementState;
  /** 按这一趟当前的行程现算；路上耽搁了就跟着变；空＝说不准 */
  expected_home_at: IsoDateTime | null;
}
export type PlanArrangementInput = WithOptional<PlanArrangement, "expected_home_at">;

/** 请求人自己的那一条。 */
export interface PlanRequestView {
  request_id: string;
  journey_id: string;
  origin: PlanRequestOrigin;
  state: PlanRequestState;
  display_state: PlanRequestDisplay;
  safe_node_kind: SafeNodeKind;
  /** 预计能动身的时刻，只作预计 */
  safe_node_at: IsoDateTime | null;
  /** 开着时按这一趟当前的行程现算；其余是接受那一刻的预计；空＝说不准 */
  expected_home_at: IsoDateTime | null;
  /** 实际到家事件的时刻（done 才有） */
  home_at: IsoDateTime | null;
  /** cannot_now／expired 的原因 */
  reason_code: PlanRequestReason | null;
  /** 撤回时带回来（PlanRequestCancel.expected_version） */
  version: number;
  created_at: IsoDateTime;
  updated_at: IsoDateTime;
}
export type PlanRequestViewInput = WithOptional<PlanRequestView, "safe_node_at" | "expected_home_at" | "home_at" | "reason_code">;

export interface PlanRequestResult {
  outcome: PlanRequestOutcome;
  /** accepted／cannot_now 时是这次建的那一条；其余为空 */
  request: PlanRequestView | null;
  /** already_arranged 时的中性安排 */
  arrangement: PlanArrangement | null;
  /** already_returning／already_arranged 时的预计到家；空＝说不准 */
  expected_home_at: IsoDateTime | null;
}
export type PlanRequestResultInput = WithOptional<PlanRequestResult, "request" | "arrangement" | "expected_home_at">;

/** 当前安排（纯读）：request 只给请求人自己的那一条（开着的，或最近一条）；别的家人请的，只给 arrangement。 */
export interface PlanRequestCurrent {
  request: PlanRequestView | null;
  arrangement: PlanArrangement | null;
}
export type PlanRequestCurrentInput = WithOptional<PlanRequestCurrent, "request" | "arrangement">;

/** 「我的屏蔽」里的一项（只列本人设的）。 */
export interface BlockedTarget {
  target_kind: BlockTargetKind;
  /** 解除用的不透明引用，原样放进 DELETE /blocks/{target_ref}；只在本人的屏蔽里认，不含对方的账号或宠物编号 */
  target_ref: string;
  /** 宠物：屏蔽那一刻它在那条动态上的公开名字（没有就是「一只你屏蔽过的宠物」），不是它此刻的名字；用户：此刻按公开规则看得到才给当前昵称，否则「一位你屏蔽过的用户」；旧范围：固定「以前屏蔽过的全部星球居民动态」 */
  display_name: string;
  /** 只有此刻按公开规则看得到的用户才可能有；宠物与旧范围一律为 null */
  avatar_url: string | null;
  /** 设这项屏蔽的时刻 */
  created_at: IsoDateTime;
}
export type BlockedTargetInput = WithOptional<BlockedTarget, "avatar_url">;

export interface BlockedTargetPage {
  items: BlockedTarget[];
  /** 按（设屏蔽的时刻倒序、种类、引用）的全序翻页，原样放回 ?cursor=；没有下一页为 null。看不懂回 422 bad_cursor，请从第一页重新看 */
  next_cursor: string | null;
}
export type BlockedTargetPageInput = WithOptional<BlockedTargetPage, "items" | "next_cursor">;

/** 一套统一的画布（像素）；每帧不另带宽高。 */
export interface PetMotionCanvas {
  width: number;
  height: number;
}
export type PetMotionCanvasInput = PetMotionCanvas;

/** 球的附着点，按画布比例（篮球用）。 */
export interface PetMotionHoldPoint {
  x: number;
  y: number;
}
export type PetMotionHoldPointInput = PetMotionHoldPoint;

/** 段内的帧标记：只驱动音效、粒子和画面，不是规则事件，不加分、不扣命。 */
export interface PetMotionEvent {
  /** 第几帧（从 0 起） */
  frame: number;
  name: string;
}
export type PetMotionEventInput = PetMotionEvent;

/** 接地测点：按画布宽高换成比例后乘一百万取整（规范式里不许有小数，修订 D1）。 */
export interface PetMotionContactPoint {
  x: number;
  y: number;
}
export type PetMotionContactPointInput = PetMotionContactPoint;

/** 一帧的接地记录（contact-band/1，后端读帧图重算后写回，只用来校验脚不滑、不浮、不陷，**不用来平移落位**）。字段与 contact.record 一一对应。 */
export interface PetMotionContact {
  /** 量法版本，本版 contact-band/1 */
  method: string;
  /** ok；量不出时是 no_contact、fragmented、floor_mismatch、off_contact（不给测点） */
  status: string;
  /** paws：画面最低接地带（斜前视角是前爪）；body：脚被挡住时量身体接地带 */
  basis: string;
  /** auto：整幅宽找；given：按种子 x 开窗 */
  seed: string;
  canvas: PetMotionCanvas;
  /** 接地点；status 不是 ok 时为 null */
  point: PetMotionContactPoint | null;
  /** 地面行（画布像素）；一个实心像素都没有时为 null */
  floor_row: number | null;
  /** 接地带里的接地像素团 [起列, 止列]，按列升序 */
  segments: number[][];
}
export type PetMotionContactInput = PetMotionContact;

/** 这一帧的来源（生产方登记、后端核过形状）：缩放、平移按一百万倍取整。 */
export interface PetMotionFrameSource {
  source_sha256: string;
  /** 在原图里的裁切框 [左, 上, 右, 下]（像素） */
  crop_box: number[];
  /** 原图像素 → 画布像素的缩放 × 1000000 */
  scale: number;
  /** 平移 [dx, dy] × 1000000 */
  offset: number[];
  /** 坐标系，本版 canvas_px_topleft/1 */
  coordinate: string;
}
export type PetMotionFrameSourceInput = PetMotionFrameSource;

/** 一帧：透明 PNG，按画布比例落位。 */
export interface PetMotionFrame {
  /** 帧序，从 0 起 */
  index: number;
  duration_ms: number;
  /** 受权限保护的帧图地址（与形象图同一条路由）；不是公开直链，也不进指纹（换地址不算换了一版） */
  url: string;
  /** 这一帧图片字节的 SHA-256 */
  content_sha256: string;
  content_box: ContentBox;
  /** 落地点（画布比例）：着地帧是实测；离地帧填这一套的站位（等于头部 anchor） */
  anchor: GroundAnchor;
  has_alpha: boolean;
  opaque_ratio: number;
  /** 球的附着点；这一帧球不在爪里为 null（每帧都写） */
  hold_point: PetMotionHoldPoint | null;
  /** 身体是否着地；篮球出手那一段、居家跑（ground_contact/2）里离地的帧为 false（每帧都写） */
  grounded: boolean;
  /** ground_contact/2 的帧才有这个键：接地记录（离地帧为 null）；旧规则的帧不带这个键 */
  contact?: PetMotionContact | null;
  /** ground_contact/2 的帧才有这个键：这一帧的来源；旧规则的帧不带这个键 */
  source?: PetMotionFrameSource | null;
}
export type PetMotionFrameInput = WithOptional<PetMotionFrame, "contact" | "source">;

/** 一段：一个可播放单元。只有已生效且就绪、与头部同一套的段才会出现在这里。 */
export interface PetMotionClip {
  /** 封闭集合 clip-catalog-1／clip-catalog-2（只增不删）；段按目录的定义顺序排，catalog-2 新增的段接在后面。clip-catalog-3 另有主人教的动作键族 taught_<单号>_enter／_main／_exit，排在最后（按单号，单内进入、主体、退出） */
  clip_key: string;
  /** 同一只、同一用途、同一 clip_key 单调递增；变了就是换了一版，要重挂播放器 */
  revision: number;
  /** 整段清单指纹（motion-manifest/1，盖住头部与本段，不含 revision 与帧地址）；前端只比对、不重算 */
  manifest_sha256: string;
  from_state: string;
  to_state: string;
  loop: boolean;
  /** 居家 front；贪吃走路分 up、down、left、right，其余贪吃段 down；篮球 right */
  facing: string;
  /** 贪吃：这一段所在朝向的站位（画布比例，量过；贪吃的站位按方向各自统一）；其余用途为 null，以头部 anchor 为准 */
  anchor?: GroundAnchor | null;
  /** 缺帧或加载失败时停在哪个稳定姿势 */
  fallback_state: string;
  /** 按 (frame, name) 升序 */
  events: PetMotionEvent[];
  /** 可以离开这一段的帧（非规则事件的切换用），升序、不重复 */
  interrupt_frames: number[];
  frames: PetMotionFrame[];
}
export type PetMotionClipInput = WithOptional<PetMotionClip, "anchor">;

/** `GET /pets/{pet_id}/motion` 的回包：一套的头部加这一套里已生效且就绪的段。没有可播的段、或站位关键段读不到时，整个回包是 null。 */
export interface PetMotionSet {
  pet_id: string;
  purpose: PetMotionPurpose;
  /** 指纹规范的版本：motion-manifest/1，ground_contact/2 的居家套是 motion-manifest/2；不认识的版本整套不用 */
  manifest_digest_version: string;
  /** 段目录的版本：clip-catalog-1，ground_contact/2 的居家套是 clip-catalog-2；前端据此认目录 */
  clip_catalog_version: string;
  /** 身份参考的版本，对照生效形象的 reference_version */
  reference_version: number;
  /** 冻结的身份参考指纹：等于生效形象中性站姿那张图的 content_sha256 */
  identity_sha256: string;
  /** 身体投影版本；没有时为 null */
  body_revision: number | null;
  /** 动作的画风版本；只要求同一套内一致，不和形象的画风版本比 */
  style_version: string;
  canvas: PetMotionCanvas;
  /** 锚点规则的名字：居家与篮球 hind_paws_midpoint，贪吃 ground_projection_center；居家新量法 ground_contact/2（头部 anchor 是整套画布基准点，帧不逐帧平移） */
  anchor_rule: string;
  /** 这一套的站位（画布比例，量过）。贪吃按方向各自统一：这里是朝下那一组（move_down）的，各段所在朝向的站位见段上的 anchor */
  anchor: GroundAnchor;
  mirror_allowed: boolean;
  generation_method: PetMotionGenerationMethod;
  clips: PetMotionClip[];
}
export type PetMotionSetInput = PetMotionSet;

/** 新建（管理员，直接生效）或提建议（成员，待管理员确认）。starts_at 不填为提交时刻；ends_at 不填为不限。 */
export interface ActionLimitCreate {
  activity: ActionLimitActivity;
  starts_at: IsoDateTime | null;
  ends_at: IsoDateTime | null;
  reason: string | null;
}
export type ActionLimitCreateInput = WithOptional<ActionLimitCreate, "starts_at" | "ends_at" | "reason">;

export interface ActionLimitExpected {
  expected_version: number;
}
export type ActionLimitExpectedInput = ActionLimitExpected;

export interface ActionLimitItem {
  limit_id: string;
  activity: ActionLimitActivity;
  source_kind: ActionLimitSource;
  source_actor: string;
  status: ActionLimitStatus;
  record_version: number;
  set_version: number;
  starts_at: IsoDateTime;
  ends_at: IsoDateTime | null;
  revoked_at: IsoDateTime | null;
  revoked_reason: string | null;
  created_at: IsoDateTime;
  updated_at: IsoDateTime;
  effective: boolean;
  expired: boolean;
  out_of_household: boolean;
}
export type ActionLimitItemInput = WithOptional<ActionLimitItem, "ends_at" | "revoked_at" | "revoked_reason">;

export interface ActionLimitRevise {
  expected_version: number;
  activity: ActionLimitActivity;
  starts_at: IsoDateTime | null;
  ends_at: IsoDateTime | null;
  reason: string | null;
}
export type ActionLimitReviseInput = WithOptional<ActionLimitRevise, "starts_at" | "ends_at" | "reason">;

export interface ActionLimitRevoke {
  expected_version: number;
  reason: string | null;
}
export type ActionLimitRevokeInput = WithOptional<ActionLimitRevoke, "reason">;

/** 这只宠物在当前家庭的全部行动限制（含待确认、已撤回、已过期、已不在这个家的）。set_version 是此刻的集合版本。 */
export interface ActionLimitsView {
  pet_id: string;
  set_version: number;
  items: ActionLimitItem[];
}
export type ActionLimitsViewInput = ActionLimitsView;

export interface PetSocialPrefsUpdate {
  allow_romance: boolean;
  expected_version: number;
}
export type PetSocialPrefsUpdateInput = PetSocialPrefsUpdate;

export interface PetSocialPrefsView {
  pet_id: string;
  allow_romance: boolean;
  readable: boolean;
  defaulted: boolean;
  version: number;
}
export type PetSocialPrefsViewInput = WithOptional<PetSocialPrefsView, "readable" | "defaulted">;

export interface CityCard {
  /** amap:<市级 adcode> */
  city_id: string;
  /** 显示名：郑州、北京、香港 */
  short_name: string;
  province: string;
  /** catalog（没开过）／opening／open／unavailable */
  status: string;
  /** 刚开放、住处还在慢慢多起来（只有 1 个落点）：能入住，不主动推荐 */
  thin: boolean;
  /** 已开：入住时地址当场落定；没开的照样能入住，地址晚一点落定 */
  ready: boolean;
  /** 这座城能选的生活环境；只有 city 时页面写「这里目前是城市生活」 */
  habitats: string[];
  /** 住在这座城的宠物数；0 时为 null，页面不显示数字 */
  pet_count: number | null;
  /** 已经住进这座城的 NPC 居民数；0 时页面不说「有邻居」 */
  npc_neighbors: number;
}
export type CityCardInput = CityCard;

export interface CityAlias {
  /** 搜到的区县或县级市原名，例如「昆山市」 */
  name: string;
  city_id: string;
  /** 它属于哪座城，例如「苏州」 */
  short_name: string;
}
export type CityAliasInput = CityAlias;

export interface CitySearchResult {
  cities: CityCard[];
  /** 城市名里搜不到时，区县名里搜到的（「昆山属于苏州，可以选苏州」）；同名的全列出来 */
  alias_of: CityAlias[];
}
export type CitySearchResultInput = CitySearchResult;

export interface NearestOpenCity {
  city_id: string;
  short_name: string;
  distance_km: number;
}
export type NearestOpenCityInput = NearestOpenCity;

export interface CityStatus {
  city: CityCard;
  /** 开城进行到哪一步：finding／verifying／checking_nearby；不在开城时为 null */
  step: string | null;
  /** no_residential_found／verify_failed／quota_wait／provider_error／region_unsupported */
  reason: string | null;
  /** 下一次自动重开或重试的时刻 */
  retry_at: IsoDateTime | null;
  /** 排队（quota_wait）时的位置，从 1 起；地址晚一点落定，不挡入住 */
  queue_position: number | null;
  /** 最近一座已开的城（换城时推荐；按目录中心点直线距离，不调地图） */
  nearest_open: NearestOpenCity | null;
  /** 开城这件事此刻有没有在做（选点核实装好了）。false 时还没开的城会一直在准备、地址落不定，页面如实说「这座城还在准备，暂时说不准什么时候好」，不显示进度；已开的城不受影响 */
  opening_available?: boolean;
}
export type CityStatusInput = WithOptional<CityStatus, "opening_available">;

export interface PickCard {
  city_id: string;
  short_name: string;
  habitat: string;
  ready: boolean;
}
export type PickCardInput = PickCard;

export interface PickResult {
  cards: PickCard[];
  batch: number;
}
export type PickResultInput = PickResult;

/** 老家补真实住处（CITY-01 v3 11.4）的预览。只读：不联网、不写库。 */
export interface RealSitePreview {
  /** 此刻能不能确认：管理员、宠物都在家、这一片有落点 */
  can_change: boolean;
  /** 不能确认的原因码：already_real（已经是真实住处）／city_not_chosen（从没选过城市：先选城）／region_unsupported／city_not_ready（这座城还在准备）／no_site_in_area（这一片还没有住处，确认会先去准备）／not_admin（管理员可以给 TA 找住处）／pet_away（等 TA 回家再换） */
  reason: string | null;
  /** 确认时原样带回；预览之后落点变了会 409 preview_changed */
  site_id: string | null;
  /** 新住处：城市·区县·小区（只给本家人看；对外仍只到区县） */
  private_display: string | null;
  /** 离原来的住处多远（公里，一位小数） */
  distance_km: number | null;
  /** 会变的：outing_start（出门的起点）、nearby_places（附近能去的地方） */
  changes: string[];
  /** 不变的：city、habitat、memories、friends、birth_record */
  keeps: string[];
}
export type RealSitePreviewInput = WithOptional<RealSitePreview, "site_id" | "private_display" | "distance_km">;

export interface RealSiteRequest {
  /** 预览里给的 site_id */
  site_id: string;
}
export type RealSiteRequestInput = RealSiteRequest;

export interface CityChoiceRequest {
  /** 城市目录里的 amap:<市级 adcode>（见 /cities/search、/cities/recommend、/cities/random） */
  city_id: string;
}
export type CityChoiceRequestInput = CityChoiceRequest;

/** 已入住的家选城（CITY-01 R4）的回包。 */
export interface CityChoiceResult {
  place: HomePlaceSummary;
  /** 同 CityStatus.opening_available：false 且 place.address_pending 时，地址会一直落不定、宠物不出门，页面要如实说 */
  opening_available: boolean;
}
export type CityChoiceResultInput = CityChoiceResult;

export interface RealSiteNotice {
  /** 一次性告知「可以给 TA 换一个有真实地址的住处」该不该出：这个家能补、而且还没告知过。家里谁关掉都算告知过 */
  show: boolean;
}
export type RealSiteNoticeInput = RealSiteNotice;

export interface AuthChannelCapability {
  channel: ContactChannel;
  status: ChannelStatus;
  /** 这一渠道验证码的有效期：短信 300、邮件 900（v3.1：c84a 接受邮件 15 分钟） */
  code_ttl_seconds: number;
  /** 手机号只支持的地区前缀，首版 ['+86']；邮件为空 */
  regions: string[];
}
export type AuthChannelCapabilityInput = WithOptional<AuthChannelCapability, "regions">;

/** GET /auth/capabilities（未登录可读）。只给渠道可用性与规则常量，不给任何配置值。前端按它决定露不露页签。 */
export interface AuthCapabilities {
  channels: AuthChannelCapability[];
  /** 原账号名＋密码登录（老用户） */
  legacy_username_login: boolean;
  /** 原账号名注册；新渠道真实启用、旧客户端核过后由发布开关关闭（410） */
  legacy_username_register: boolean;
  /** 新设／重设密码的最低长度（常量，待 c84a 定：CTO 15、I 10） */
  password_min_length: number;
  password_max_length: number;
  /** 找回是否可用：至少一个渠道 available 时为 true */
  recovery_available: boolean;
}
export type AuthCapabilitiesInput = WithOptional<AuthCapabilities, "password_max_length">;

/** POST /auth/code。请求头必须带 Idempotency-Key（发送前持久化预占；网络重试不多发）。 */
export interface CodeRequest {
  channel: ContactChannel;
  /** 邮箱，或 +86 手机号（11 位或 +86 开头）；服务端归一化 */
  target: string;
  purpose: CodePurpose;
  /** purpose=account_proof 时必带（/auth/phone 回的 proof_ticket），其他用途带了就拒（E0-d） */
  proof_ticket?: string | null;
}
export type CodeRequestInput = WithOptional<CodeRequest, "proof_ticket">;

/** 202。外部回包不随「这个联系方式有没有注册过」变化（防枚举）。 */
export interface CodeChallenge {
  challenge_id: string;
  channel: ContactChannel;
  /** 脱敏后的目标，例如 138****5678、a***@qq.com */
  target_masked: string;
  expires_at: IsoDateTime;
  /** 多久以后才能再取一个码（以服务端为准，刷新页面不能绕过） */
  retry_after_seconds: number;
  delivery: DeliveryState;
}
export type CodeChallengeInput = CodeChallenge;

/** POST /auth/phone：purpose=phone_signin 的码。已有账号就登录；没有就原子地新建一个（不设密码）。 */
export interface PhoneSigninRequest {
  challenge_id: string;
  code: string;
  /** 新号码第一次进入时的称呼；已有账号忽略 */
  display_name: string | null;
  entry: EntryIntentRequest | null;
}
export type PhoneSigninRequestInput = WithOptional<PhoneSigninRequest, "display_name" | "entry">;

export interface PhoneSigninResult {
  /** created 时前端问一屏「你希望大家怎么称呼你」（若注册时没给）；proof_required 时没有会话 */
  outcome: SigninOutcome;
  session: SessionState | null;
  /** proof_required 才有：短时（15 分钟）、只能用于 /auth/phone/proof 和人工恢复申请；不是会话 */
  proof_ticket: string | null;
  /** proof_required 时**固定列已实现的三种**（email_code、password、recovery_code），不随旧账号实际有什么而变：不泄露旧主人有没有邮箱、密码；「用邮箱另建新账号」由页面自己给入口（E0-d） */
  proof_methods: string[];
}
export type PhoneSigninResultInput = WithOptional<PhoneSigninResult, "session" | "proof_ticket" | "proof_methods">;

/** POST /auth/phone/proof：凭 proof_ticket 交一种事先建立的独立证明。成功＝状态表 S5，签发会话并把这台设备记成可信； */
export interface PhoneProofRequest {
  proof_ticket: string;
  method: PhoneProofMethod;
  password: string | null;
  recovery_code: string | null;
  challenge_id: string | null;
  code: string | null;
}
export type PhoneProofRequestInput = WithOptional<PhoneProofRequest, "password" | "recovery_code" | "challenge_id" | "code">;

/** POST /auth/recovery/manual：状态表 S6，拿不出原凭证时提交人工恢复待核（202）。只记「这个号码在某时请求恢复」和一段自述； */
export interface ManualRecoveryRequest {
  proof_ticket: string;
  /** 自述（例如什么时候换的号）；运营人工核对用 */
  note: string | null;
}
export type ManualRecoveryRequestInput = WithOptional<ManualRecoveryRequest, "note">;

/** POST /auth/email/verify：purpose=email_register 的码。验证通过以后才区分新邮箱和已注册邮箱。 */
export interface EmailVerifyRequest {
  challenge_id: string;
  code: string;
}
export type EmailVerifyRequestInput = EmailVerifyRequest;

export interface EmailVerifyResult {
  outcome: EmailVerifyOutcome;
  /** verified_new 才有：短时、单次、只能用来建这个邮箱的账号 */
  signup_grant: string | null;
  grant_expires_at: IsoDateTime | null;
}
export type EmailVerifyResultInput = WithOptional<EmailVerifyResult, "signup_grant" | "grant_expires_at">;

/** POST /auth/email/register：凭 signup_grant 设密码、建账号，成功即登录（201 CREATED）。 */
export interface EmailRegisterRequest {
  signup_grant: string;
  /** 长度规则按 AuthCapabilities.password_min_length 由服务端判 */
  password: string;
  display_name: string | null;
  entry: EntryIntentRequest | null;
}
export type EmailRegisterRequestInput = WithOptional<EmailRegisterRequest, "display_name" | "entry">;

/** POST /auth/email/login：失败统一 401 INVALID_CREDENTIALS「邮箱或密码不正确」；失败计数落库（多层限流）。 */
export interface EmailLoginRequest {
  email: string;
  password: string;
}
export type EmailLoginRequestInput = EmailLoginRequest;

/** POST /auth/recovery/verify：purpose=password_recover 的码。只找已有绑定账号，绝不新建。 */
export interface RecoveryVerifyRequest {
  challenge_id: string;
  code: string;
}
export type RecoveryVerifyRequestInput = RecoveryVerifyRequest;

export interface RecoveryVerifyResult {
  outcome: RecoveryOutcome;
  /** 短时、单次、只能用来重设这个账号的密码；不是会话 */
  reset_grant: string | null;
  grant_expires_at: IsoDateTime | null;
}
export type RecoveryVerifyResultInput = WithOptional<RecoveryVerifyResult, "reset_grant" | "grant_expires_at">;

/** POST /auth/recovery/reset：204。改密码与吊销这个账号全部会话（cookie 和 Bearer）在同一事务；成功后回登录页，不自动登录。 */
export interface RecoveryResetRequest {
  reset_grant: string;
  new_password: string;
}
export type RecoveryResetRequestInput = RecoveryResetRequest;

/** POST /auth/reauth：给当前会话记一次「刚刚重新验证过」。有密码的账号给 password；只有手机号的账号用 purpose=change_contact */
export interface ReauthRequest {
  password: string | null;
  challenge_id: string | null;
  code: string | null;
}
export type ReauthRequestInput = WithOptional<ReauthRequest, "password" | "challenge_id" | "code">;

/** POST /me/contacts/{channel}：bind_contact／change_contact 的码（发到新联系方式）。要近期再验证（403 REAUTH_REQUIRED）。 */
export interface ContactBindRequest {
  challenge_id: string;
  code: string;
}
export type ContactBindRequestInput = ContactBindRequest;

/** GET /me/recovery-code：有没有有效的恢复码、什么时候生成的。码本身谁都读不到（库里只存 scrypt 哈希）。 */
export interface RecoveryCodeStatus {
  has_code: boolean;
  created_at: IsoDateTime | null;
}
export type RecoveryCodeStatusInput = WithOptional<RecoveryCodeStatus, "created_at">;

/** POST /me/recovery-code（201，要近期再验证，回包 no-store）：新码只在这一次回包里出现；旧码同时作废。 */
export interface RecoveryCodeIssued {
  /** 分 4 组的大写字母加数字（去掉 0/O、1/I），例如 ABCDE-FGHJK-LMNPQ-RSTUV；输入时空格、连字符、大小写都不影响 */
  recovery_code: string;
  created_at: IsoDateTime;
}
export type RecoveryCodeIssuedInput = RecoveryCodeIssued;

export interface DataUseService {
  purpose: DataUsePurpose;
  /** 服务的显示名（品牌）。品牌不等于合同法律主体；认不出品牌（比如中转地址）时为 null：这一路照样在外发，前端只写用途、不写品牌（R1） */
  display_name: string | null;
  /** 合同主体；不知道就是 null，不编 */
  contract_entity: string | null;
}
export type DataUseServiceInput = WithOptional<DataUseService, "display_name" | "contract_entity">;

export interface DataUseServices {
  /** 此刻实际在用的外部服务；没启用、读不到的不列。没配置时为空列表 */
  services: DataUseService[];
}
export type DataUseServicesInput = DataUseServices;

export interface FoodPreferenceResult {
  state: "unknown" | "in_progress" | "completed";
  preference: FoodPreference | null;
}
export type FoodPreferenceResultInput = WithOptional<FoodPreferenceResult, "preference">;

export interface FoodFeedbackResult {
  state: "unknown" | "in_progress" | "completed";
  feedback: FoodFeedback | null;
}
export type FoodFeedbackResultInput = WithOptional<FoodFeedbackResult, "feedback">;

export interface CreateGameInvitationRequest {
  game_key: "gomoku";
  rules_version: "gomoku-freestyle-v1";
  operation_id: string | null;
}
export type CreateGameInvitationRequestInput = WithOptional<CreateGameInvitationRequest, "operation_id">;

export interface PrivateGameCapabilities {
  available: boolean;
  reasons: ("POLICY_UNAVAILABLE" | "PET_RESPONSE_UNAVAILABLE" | "ACTIVITY_SLOT_UNAVAILABLE")[];
}
export type PrivateGameCapabilitiesInput = WithOptional<PrivateGameCapabilities, "available">;

export interface GameOrigin {
  conversation_id: string;
  invitation_message_id: string;
}
export type GameOriginInput = GameOrigin;

export interface PrivateGameInvitation {
  invitation_id: string;
  pet_id: string;
  rules_version: "gomoku-freestyle-v1";
  human_player_id: string;
  pet_player_id: string;
  origin: GameOrigin;
  created_at: IsoDateTime;
  expires_at: IsoDateTime;
  status: "pending" | "accepted" | "declined" | "cancelled" | "expired";
  version: number;
}
export type PrivateGameInvitationInput = PrivateGameInvitation;

export interface PrivateGameInvitationPetResponse {
  decision: "accept" | "decline" | "later";
  invitation_version: number;
  responded_at: IsoDateTime;
}
export type PrivateGameInvitationPetResponseInput = PrivateGameInvitationPetResponse;

export interface PrivateGameInvitationRead {
  invitation_id: string;
  pet_id: string;
  rules_version: "gomoku-freestyle-v1";
  human_player_id: string;
  pet_player_id: string;
  origin: GameOrigin;
  created_at: IsoDateTime;
  expires_at: IsoDateTime;
  status: "pending" | "accepted" | "declined" | "cancelled" | "expired";
  version: number;
  pet_response: PrivateGameInvitationPetResponse | null;
}
export type PrivateGameInvitationReadInput = WithOptional<PrivateGameInvitationRead, "pet_response">;

export interface GamePlayers {
  black: string;
  white: string;
}
export type GamePlayersInput = GamePlayers;

export interface GamePoint {
  x: number;
  y: number;
}
export type GamePointInput = GamePoint;

export interface GameMove {
  x: number;
  y: number;
  number: number;
  version: number;
  actor: string;
  seat: "black" | "white";
}
export type GameMoveInput = GameMove;

export interface GameFiveWin {
  kind: "win";
  winner: "black" | "white";
  reason: "five";
  line: GamePoint[];
}
export type GameFiveWinInput = GameFiveWin;

export interface GameResignWin {
  kind: "win";
  winner: "black" | "white";
  reason: "resign";
}
export type GameResignWinInput = GameResignWin;

export interface GameDraw {
  kind: "draw";
}
export type GameDrawInput = GameDraw;

export interface PrivateGameSnapshot {
  game_id: string;
  players: GamePlayers;
  rules_version: "gomoku-freestyle-v1";
  state_version: number;
  board: ("black" | "white" | null)[];
  moves: GameMove[];
  turn: "black" | "white" | null;
  result: GameFiveWin | GameResignWin | GameDraw | null;
  status: "active" | "finished";
  origin: GameOrigin;
}
export type PrivateGameSnapshotInput = PrivateGameSnapshot;

export interface PrivateGameOperationResult {
  schema_version: 1;
  operation_id: string;
  submission_status: "committed";
  operation: "create_invitation" | "respond_invitation" | "cancel_invitation" | "apply_human_command" | "apply_pet_command";
  invitation_id: string;
  game_id: string | null;
  original_receipt_version: number;
  original_receipt: PrivateGameInvitation | PrivateGameSnapshot;
  replayed: boolean;
}
export type PrivateGameOperationResultInput = PrivateGameOperationResult;

export interface OriginalPrivateGameOperation {
  status: "UNKNOWN" | "COMMITTED";
  operation_id: string;
  reason: "original_operation_missing" | null;
  original_result: PrivateGameOperationResult | HumanGameOperationResult | null;
}
export type OriginalPrivateGameOperationInput = WithOptional<OriginalPrivateGameOperation, "reason" | "original_result">;

export interface HumanGameRequestBase {
  expected_state_version: number;
  operation_id: string | null;
}
export type HumanGameRequestBaseInput = WithOptional<HumanGameRequestBase, "operation_id">;

export interface HumanGameMoveRequest {
  expected_state_version: number;
  operation_id: string | null;
  kind: "move";
  x: number;
  y: number;
}
export type HumanGameMoveRequestInput = WithOptional<HumanGameMoveRequest, "operation_id">;

export interface HumanGameResignRequest {
  expected_state_version: number;
  operation_id: string | null;
  kind: "resign";
}
export type HumanGameResignRequestInput = WithOptional<HumanGameResignRequest, "operation_id">;

export interface CancelGameInvitationRequest {
  expected_invitation_version: number;
  operation_id: string | null;
}
export type CancelGameInvitationRequestInput = WithOptional<CancelGameInvitationRequest, "operation_id">;

export interface HumanGameMovedEvent {
  type: "moved";
  version: number;
  seq: number;
  move: GameMove;
}
export type HumanGameMovedEventInput = HumanGameMovedEvent;

export interface HumanGameEndedEvent {
  type: "ended";
  version: number;
  seq: number;
  result: GameFiveWin | GameResignWin | GameDraw;
}
export type HumanGameEndedEventInput = HumanGameEndedEvent;

export interface HumanGameCommandReceipt {
  command_id: string;
  version: number;
  events: (HumanGameMovedEvent | HumanGameEndedEvent)[];
}
export type HumanGameCommandReceiptInput = HumanGameCommandReceipt;

export interface HumanGameOperationResult {
  schema_version: 1;
  operation_id: string;
  submission_status: "committed";
  operation: "move" | "resign";
  invitation_id: string;
  game_id: string;
  original_receipt_version: number;
  original_receipt: HumanGameCommandReceipt;
  replayed: boolean;
}
export type HumanGameOperationResultInput = HumanGameOperationResult;

/** 基础动作就绪（BASIC-PACK-117，c84a 12:54）：每段一行照实给主人看，不让主人只看到一个永远在转的「准备中」。 */
export interface BasicMotionReadiness {
  /** preparing／first_ready／complete（包自己的状态，按上一次现算） */
  pack_state: string;
  /** 第一批动作都可用（pack_state 是 first_ready 或 complete） */
  first_ready: boolean;
  /** 第一批：「已能用 X/14」 */
  first_batch: BasicMotionCount;
  /** 这只宠物适用的全部基础动作 */
  overall: BasicMotionCount;
  /** 每段一行，按排段的先后（第一批的类在前） */
  clips: BasicMotionClip[];
}
export type BasicMotionReadinessInput = BasicMotionReadiness;

export interface BasicMotionCount {
  /** 已能用几段 */
  usable: number;
  /** 这只宠物适用的一共几段（按物种版面，不硬凑） */
  total: number;
}
export type BasicMotionCountInput = BasicMotionCount;

/** 「TA 的小动作」里基础动作的一行（BASIC-PACK-117，c84a 12:54）。三样分开：status、live、fallback。 */
export interface BasicMotionClip {
  /** 段名（clip-catalog-2，如 stand_idle、lie_to_sleep、petted_stand）；前端按它配人话，不直接显示 */
  clip_key: string;
  /** 所在类：stand、lie、sleep、eat、drink、petted、sit、walk、run、walk_depth */
  category: string;
  /** 是不是第一批（S1 姿态表就能出的 14 段） */
  first_batch: boolean;
  status: BasicMotionStatus;
  /** 按当前这一套形象已生效；换形象过渡期新套的段收尾好了也先不生效，旧套照播 */
  live: boolean;
  /** 没得播时的兜底：fade＝拿首尾两张静态姿态淡化着过；null＝不兜底（被摸、跑没有就照实写还在准备） */
  fallback: string | null;
}
export type BasicMotionClipInput = WithOptional<BasicMotionClip, "fallback">;

export interface WebEndpoint {
  method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
  path: string;
  auth: "public" | "optional" | "required";
  csrf: boolean;
  idempotency: boolean;
}

export const WEB_ENDPOINTS = {
  "adopt": { method: "POST", path: "/adoption/adopt", auth: "required", csrf: true, idempotency: true },
  "adoption_candidates": { method: "GET", path: "/adoption/candidates", auth: "required", csrf: false, idempotency: false },
  "announcements": { method: "GET", path: "/announcements", auth: "optional", csrf: false, idempotency: false },
  "public_asset": { method: "GET", path: "/assets/{asset_id}", auth: "public", csrf: false, idempotency: false },
  "auth_capabilities": { method: "GET", path: "/auth/capabilities", auth: "public", csrf: false, idempotency: false },
  "send_code": { method: "POST", path: "/auth/code", auth: "public", csrf: false, idempotency: true },
  "email_login": { method: "POST", path: "/auth/email/login", auth: "public", csrf: false, idempotency: false },
  "email_register": { method: "POST", path: "/auth/email/register", auth: "public", csrf: false, idempotency: false },
  "email_verify": { method: "POST", path: "/auth/email/verify", auth: "public", csrf: false, idempotency: false },
  "login": { method: "POST", path: "/auth/login", auth: "public", csrf: false, idempotency: false },
  "logout": { method: "POST", path: "/auth/logout", auth: "public", csrf: false, idempotency: false },
  "phone_signin": { method: "POST", path: "/auth/phone", auth: "public", csrf: false, idempotency: false },
  "phone_proof": { method: "POST", path: "/auth/phone/proof", auth: "public", csrf: false, idempotency: false },
  "reauth": { method: "POST", path: "/auth/reauth", auth: "required", csrf: true, idempotency: false },
  "manual_recovery": { method: "POST", path: "/auth/recovery/manual", auth: "public", csrf: false, idempotency: false },
  "recovery_reset": { method: "POST", path: "/auth/recovery/reset", auth: "public", csrf: false, idempotency: false },
  "recovery_verify": { method: "POST", path: "/auth/recovery/verify", auth: "public", csrf: false, idempotency: false },
  "register": { method: "POST", path: "/auth/register", auth: "public", csrf: false, idempotency: false },
  "savings_plans": { method: "GET", path: "/bank/savings-plans", auth: "required", csrf: false, idempotency: false },
  "statement": { method: "GET", path: "/bank/statement", auth: "required", csrf: false, idempotency: false },
  "blocked_targets": { method: "GET", path: "/blocks", auth: "required", csrf: false, idempotency: false },
  "block": { method: "POST", path: "/blocks", auth: "required", csrf: true, idempotency: false },
  "unblock": { method: "DELETE", path: "/blocks/{target_ref}", auth: "required", csrf: true, idempotency: false },
  "correct_note": { method: "POST", path: "/care-notes/{note_id}/corrections", auth: "required", csrf: true, idempotency: true },
  "circle_feed": { method: "GET", path: "/circle/feed", auth: "required", csrf: false, idempotency: false },
  "random_cities": { method: "GET", path: "/cities/random", auth: "required", csrf: false, idempotency: false },
  "recommend_cities": { method: "GET", path: "/cities/recommend", auth: "required", csrf: false, idempotency: false },
  "search_cities": { method: "GET", path: "/cities/search", auth: "required", csrf: false, idempotency: false },
  "city_status": { method: "GET", path: "/cities/{city_id}", auth: "required", csrf: false, idempotency: false },
  "list_collection": { method: "GET", path: "/collection", auth: "required", csrf: false, idempotency: false },
  "retry_collection_image": { method: "POST", path: "/collection/{pet_id}/items/{item_id}/retry-image", auth: "required", csrf: true, idempotency: false },
  "remove_comment": { method: "DELETE", path: "/comments/{comment_id}", auth: "required", csrf: true, idempotency: false },
  "private_game_capabilities": { method: "GET", path: "/communicator/{pet_id}/games/capabilities", auth: "required", csrf: false, idempotency: false },
  "create_private_game_invitation": { method: "POST", path: "/communicator/{pet_id}/games/invitations", auth: "required", csrf: true, idempotency: true },
  "private_game_invitation": { method: "GET", path: "/communicator/{pet_id}/games/invitations/{invitation_id}", auth: "required", csrf: false, idempotency: false },
  "cancel_private_game_invitation": { method: "POST", path: "/communicator/{pet_id}/games/invitations/{invitation_id}/cancel", auth: "required", csrf: true, idempotency: true },
  "private_game_by_original_invitation": { method: "GET", path: "/communicator/{pet_id}/games/invitations/{invitation_id}/game", auth: "required", csrf: false, idempotency: false },
  "original_private_game_operation": { method: "GET", path: "/communicator/{pet_id}/games/operations/{operation_id}", auth: "required", csrf: false, idempotency: false },
  "private_game": { method: "GET", path: "/communicator/{pet_id}/games/{game_id}", auth: "required", csrf: false, idempotency: false },
  "private_game_human_command": { method: "POST", path: "/communicator/{pet_id}/games/{game_id}/commands", auth: "required", csrf: true, idempotency: true },
  "list_messages": { method: "GET", path: "/communicator/{pet_id}/messages", auth: "required", csrf: false, idempotency: false },
  "send_message": { method: "POST", path: "/communicator/{pet_id}/messages", auth: "required", csrf: true, idempotency: false },
  "original_message_receipt": { method: "GET", path: "/communicator/{pet_id}/messages/by-client/{client_message_id:path}", auth: "required", csrf: false, idempotency: false },
  "original_private_message_by_id": { method: "GET", path: "/communicator/{pet_id}/messages/by-id/{message_id}", auth: "required", csrf: false, idempotency: false },
  "retry_photo": { method: "POST", path: "/communicator/{pet_id}/messages/{message_id}/retry-photo", auth: "required", csrf: true, idempotency: false },
  "photo_ask_records": { method: "GET", path: "/communicator/{pet_id}/photo-asks", auth: "required", csrf: false, idempotency: false },
  "photo_ask": { method: "POST", path: "/communicator/{pet_id}/photo-asks", auth: "required", csrf: true, idempotency: true },
  "photo_ask_quota": { method: "GET", path: "/communicator/{pet_id}/photo-asks/quota", auth: "required", csrf: false, idempotency: false },
  "mark_messages_read": { method: "POST", path: "/communicator/{pet_id}/read", auth: "required", csrf: true, idempotency: true },
  "list_credentials": { method: "GET", path: "/credentials", auth: "required", csrf: false, idempotency: false },
  "credential_detail": { method: "GET", path: "/credentials/{credential_id}", auth: "required", csrf: false, idempotency: false },
  "driving_status": { method: "GET", path: "/driving", auth: "required", csrf: false, idempotency: false },
  "ceremony": { method: "POST", path: "/driving/ceremony", auth: "required", csrf: true, idempotency: false },
  "driving_curriculum": { method: "GET", path: "/driving/curriculum", auth: "required", csrf: false, idempotency: false },
  "enroll": { method: "POST", path: "/driving/enroll", auth: "required", csrf: true, idempotency: false },
  "history": { method: "GET", path: "/driving/history", auth: "required", csrf: false, idempotency: false },
  "create_session": { method: "POST", path: "/driving/sessions", auth: "required", csrf: true, idempotency: true },
  "get_session": { method: "GET", path: "/driving/sessions/{session_id}", auth: "required", csrf: false, idempotency: false },
  "abandon": { method: "POST", path: "/driving/sessions/{session_id}/abandon", auth: "required", csrf: true, idempotency: false },
  "answer": { method: "PUT", path: "/driving/sessions/{session_id}/answers", auth: "required", csrf: true, idempotency: false },
  "begin": { method: "POST", path: "/driving/sessions/{session_id}/begin", auth: "required", csrf: true, idempotency: false },
  "inputs": { method: "POST", path: "/driving/sessions/{session_id}/inputs", auth: "required", csrf: true, idempotency: false },
  "pause": { method: "POST", path: "/driving/sessions/{session_id}/pause", auth: "required", csrf: true, idempotency: false },
  "submit": { method: "POST", path: "/driving/sessions/{session_id}/submit", auth: "required", csrf: true, idempotency: false },
  "list_tells": { method: "GET", path: "/event-tells", auth: "required", csrf: false, idempotency: false },
  "tell": { method: "POST", path: "/event-tells", auth: "required", csrf: true, idempotency: false },
  "withdraw": { method: "DELETE", path: "/event-tells/{event_id}", auth: "required", csrf: true, idempotency: false },
  "planet_events": { method: "GET", path: "/events", auth: "public", csrf: false, idempotency: false },
  "farm_action": { method: "POST", path: "/farm/actions", auth: "required", csrf: true, idempotency: true },
  "crops": { method: "GET", path: "/farm/crops", auth: "required", csrf: false, idempotency: false },
  "farm_events": { method: "GET", path: "/farm/events", auth: "required", csrf: false, idempotency: false },
  "farm_events_seen": { method: "POST", path: "/farm/events/seen", auth: "required", csrf: true, idempotency: true },
  "farm_expansion": { method: "GET", path: "/farm/expansion", auth: "required", csrf: false, idempotency: false },
  "patrol": { method: "POST", path: "/farm/patrol", auth: "required", csrf: true, idempotency: false },
  "farm_raids": { method: "GET", path: "/farm/raids", auth: "required", csrf: false, idempotency: false },
  "steal": { method: "POST", path: "/farm/steal", auth: "required", csrf: true, idempotency: true },
  "farm_unlock": { method: "POST", path: "/farm/unlock", auth: "required", csrf: true, idempotency: true },
  "original_farm_unlock_operation": { method: "GET", path: "/farm/unlock/operations/{operation_id}", auth: "required", csrf: false, idempotency: false },
  "submit_feedback": { method: "POST", path: "/food/feedback", auth: "required", csrf: true, idempotency: true },
  "feedback_result": { method: "GET", path: "/food/feedback/{recommendation_id}/result", auth: "required", csrf: false, idempotency: true },
  "get_food_preference": { method: "GET", path: "/food/preferences/{subject}", auth: "required", csrf: false, idempotency: false },
  "put_food_preference": { method: "PUT", path: "/food/preferences/{subject}", auth: "required", csrf: true, idempotency: true },
  "preference_result": { method: "GET", path: "/food/preferences/{subject}/result", auth: "required", csrf: false, idempotency: true },
  "request_recommendations": { method: "POST", path: "/food/recommendations", auth: "required", csrf: true, idempotency: false },
  "get_recommendation": { method: "GET", path: "/food/recommendations/{recommendation_id}", auth: "required", csrf: false, idempotency: false },
  "friends": { method: "GET", path: "/friends", auth: "required", csrf: false, idempotency: false },
  "guides": { method: "GET", path: "/guides", auth: "required", csrf: false, idempotency: false },
  "guide": { method: "GET", path: "/guides/{guide_id}", auth: "required", csrf: false, idempotency: false },
  "retry_guide_image": { method: "POST", path: "/guides/{pet_id}/{guide_id}/retry-image", auth: "required", csrf: true, idempotency: false },
  "home_snapshot": { method: "GET", path: "/home", auth: "required", csrf: false, idempotency: false },
  "read_place": { method: "GET", path: "/home/place", auth: "required", csrf: false, idempotency: false },
  "choose_place": { method: "PUT", path: "/home/place", auth: "required", csrf: true, idempotency: false },
  "choose_city": { method: "POST", path: "/home/place/city", auth: "required", csrf: true, idempotency: false },
  "real_site_confirm": { method: "POST", path: "/home/place/real-site", auth: "required", csrf: true, idempotency: false },
  "real_site_notice": { method: "GET", path: "/home/place/real-site/notice", auth: "required", csrf: false, idempotency: false },
  "real_site_notice_seen": { method: "POST", path: "/home/place/real-site/notice", auth: "required", csrf: true, idempotency: false },
  "real_site_preview": { method: "GET", path: "/home/place/real-site/preview", auth: "required", csrf: false, idempotency: false },
  "home_version": { method: "GET", path: "/home/version", auth: "required", csrf: false, idempotency: false },
  "visit_home": { method: "GET", path: "/homes/{home_id}", auth: "required", csrf: false, idempotency: false },
  "my_households": { method: "GET", path: "/households", auth: "required", csrf: false, idempotency: false },
  "household_detail": { method: "GET", path: "/households/{household_id}", auth: "required", csrf: false, idempotency: false },
  "list_invites": { method: "GET", path: "/households/{household_id}/invites", auth: "required", csrf: false, idempotency: false },
  "create_invite": { method: "POST", path: "/households/{household_id}/invites", auth: "required", csrf: true, idempotency: false },
  "revoke_invite": { method: "DELETE", path: "/households/{household_id}/invites/{invite_id}", auth: "required", csrf: true, idempotency: false },
  "remove_member": { method: "DELETE", path: "/households/{household_id}/members/{user_id}", auth: "required", csrf: true, idempotency: false },
  "set_member_role": { method: "PUT", path: "/households/{household_id}/members/{user_id}/role", auth: "required", csrf: true, idempotency: false },
  "update_household_settings": { method: "PATCH", path: "/households/{household_id}/settings", auth: "required", csrf: true, idempotency: false },
  "accept_invite": { method: "POST", path: "/invites/accept", auth: "required", csrf: true, idempotency: false },
  "preview_invite": { method: "POST", path: "/invites/preview", auth: "optional", csrf: false, idempotency: false },
  "jobs": { method: "GET", path: "/jobs", auth: "required", csrf: false, idempotency: false },
  "depart": { method: "POST", path: "/journey/depart", auth: "required", csrf: true, idempotency: true },
  "destinations": { method: "GET", path: "/journey/destinations", auth: "required", csrf: false, idempotency: false },
  "journey_leg": { method: "GET", path: "/journey/legs/{leg_id}", auth: "required", csrf: false, idempotency: false },
  "journey_map": { method: "GET", path: "/journey/map", auth: "required", csrf: false, idempotency: false },
  "journey_plan": { method: "GET", path: "/journey/plan", auth: "required", csrf: false, idempotency: false },
  "suggest": { method: "POST", path: "/journey/suggest", auth: "required", csrf: true, idempotency: false },
  "suggestions": { method: "GET", path: "/journey/suggestions", auth: "required", csrf: false, idempotency: false },
  "suggestion_by_request": { method: "GET", path: "/journey/suggestions/by-request/{client_request_id}", auth: "required", csrf: false, idempotency: false },
  "basemap": { method: "GET", path: "/map/basemap", auth: "required", csrf: false, idempotency: false },
  "map_config": { method: "GET", path: "/map/config", auth: "public", csrf: false, idempotency: false },
  "market_view": { method: "GET", path: "/market", auth: "required", csrf: false, idempotency: false },
  "market_sale_operation": { method: "GET", path: "/market/operations/{operation_key}", auth: "required", csrf: false, idempotency: false },
  "market_order_detail": { method: "GET", path: "/market/orders/{order_id}", auth: "required", csrf: false, idempotency: false },
  "market_order_cancel": { method: "POST", path: "/market/orders/{order_id}/cancel", auth: "required", csrf: true, idempotency: true },
  "market_fulfill": { method: "POST", path: "/market/orders/{order_id}/fulfill", auth: "required", csrf: true, idempotency: true },
  "market_sell": { method: "POST", path: "/market/sell", auth: "required", csrf: true, idempotency: true },
  "my_contacts": { method: "GET", path: "/me/contacts", auth: "required", csrf: false, idempotency: false },
  "bind_contact": { method: "POST", path: "/me/contacts/{channel}", auth: "required", csrf: true, idempotency: false },
  "revoke_recovery_code": { method: "DELETE", path: "/me/recovery-code", auth: "required", csrf: true, idempotency: false },
  "recovery_code_status": { method: "GET", path: "/me/recovery-code", auth: "required", csrf: false, idempotency: false },
  "create_recovery_code": { method: "POST", path: "/me/recovery-code", auth: "required", csrf: true, idempotency: false },
  "basemap_image": { method: "GET", path: "/media/basemaps/{basemap_id}", auth: "required", csrf: false, idempotency: false },
  "character_media": { method: "GET", path: "/media/characters/{asset_id}", auth: "required", csrf: false, idempotency: false },
  "id_photo_media": { method: "GET", path: "/media/id-photos/{asset_id}", auth: "required", csrf: false, idempotency: false },
  "id_photo_avatar": { method: "GET", path: "/media/id-photos/{asset_id}/avatar", auth: "required", csrf: false, idempotency: false },
  "illustration": { method: "GET", path: "/media/illustrations/{illustration_id}", auth: "required", csrf: false, idempotency: false },
  "pet_photo": { method: "GET", path: "/media/pets/{pet_id}/photo", auth: "required", csrf: false, idempotency: false },
  "postcard": { method: "GET", path: "/media/postcards/{photo_id}", auth: "required", csrf: false, idempotency: false },
  "get_media_session": { method: "GET", path: "/media/sessions/{session_id}", auth: "required", csrf: false, idempotency: false },
  "command_media_session": { method: "POST", path: "/media/sessions/{session_id}/commands", auth: "required", csrf: true, idempotency: true },
  "heartbeat_media_session": { method: "POST", path: "/media/sessions/{session_id}/heartbeat", auth: "required", csrf: true, idempotency: false },
  "join_media_session": { method: "POST", path: "/media/sessions/{session_id}/join", auth: "required", csrf: true, idempotency: false },
  "leave_media_session": { method: "POST", path: "/media/sessions/{session_id}/leave", auth: "required", csrf: true, idempotency: false },
  "web_meta": { method: "GET", path: "/meta", auth: "public", csrf: false, idempotency: false },
  "data_services": { method: "GET", path: "/meta/data-services", auth: "public", csrf: false, idempotency: false },
  "neighbors": { method: "GET", path: "/neighbors", auth: "required", csrf: false, idempotency: false },
  "onboarding_state": { method: "GET", path: "/onboarding", auth: "required", csrf: false, idempotency: false },
  "move_in": { method: "POST", path: "/onboarding/move-in", auth: "required", csrf: true, idempotency: false },
  "pet_runtime": { method: "GET", path: "/ops/runtime/{pet_id}", auth: "public", csrf: false, idempotency: false },
  "ops_status": { method: "GET", path: "/ops/status", auth: "public", csrf: false, idempotency: false },
  "create_own_pet": { method: "POST", path: "/pets", auth: "required", csrf: true, idempotency: true },
  "action_limits": { method: "GET", path: "/pets/{pet_id}/action-limits", auth: "required", csrf: false, idempotency: false },
  "create_action_limit": { method: "POST", path: "/pets/{pet_id}/action-limits", auth: "required", csrf: true, idempotency: true },
  "suggest_action_limit": { method: "POST", path: "/pets/{pet_id}/action-limits/suggestions", auth: "required", csrf: true, idempotency: true },
  "revise_action_limit": { method: "PUT", path: "/pets/{pet_id}/action-limits/{limit_id}", auth: "required", csrf: true, idempotency: true },
  "confirm_action_limit": { method: "POST", path: "/pets/{pet_id}/action-limits/{limit_id}/confirm", auth: "required", csrf: true, idempotency: true },
  "revoke_action_limit": { method: "POST", path: "/pets/{pet_id}/action-limits/{limit_id}/revoke", auth: "required", csrf: true, idempotency: true },
  "pet_album": { method: "GET", path: "/pets/{pet_id}/album", auth: "required", csrf: false, idempotency: false },
  "pet_album_photo": { method: "GET", path: "/pets/{pet_id}/album/{photo_id}", auth: "required", csrf: false, idempotency: false },
  "hide_album_photo": { method: "POST", path: "/pets/{pet_id}/album/{photo_id}/hide", auth: "required", csrf: true, idempotency: true },
  "body_view": { method: "GET", path: "/pets/{pet_id}/body", auth: "required", csrf: false, idempotency: false },
  "body_conflict_correct": { method: "POST", path: "/pets/{pet_id}/body/conflicts/{conflict_id}/correct", auth: "required", csrf: true, idempotency: true },
  "body_conflict_keep": { method: "POST", path: "/pets/{pet_id}/body/conflicts/{conflict_id}/keep", auth: "required", csrf: true, idempotency: true },
  "body_submit": { method: "POST", path: "/pets/{pet_id}/body/statements", auth: "required", csrf: true, idempotency: true },
  "body_confirm": { method: "POST", path: "/pets/{pet_id}/body/statements/{statement_id}/confirm", auth: "required", csrf: true, idempotency: true },
  "body_reject": { method: "POST", path: "/pets/{pet_id}/body/statements/{statement_id}/reject", auth: "required", csrf: true, idempotency: true },
  "list_care_notes": { method: "GET", path: "/pets/{pet_id}/care-notes", auth: "required", csrf: false, idempotency: false },
  "character_state": { method: "GET", path: "/pets/{pet_id}/character", auth: "required", csrf: false, idempotency: false },
  "character_pose_retry": { method: "POST", path: "/pets/{pet_id}/character/poses/retry", auth: "required", csrf: true, idempotency: true },
  "character_regenerate": { method: "POST", path: "/pets/{pet_id}/character/regenerate", auth: "required", csrf: true, idempotency: true },
  "read_dna": { method: "GET", path: "/pets/{pet_id}/dna", auth: "required", csrf: false, idempotency: false },
  "save_dna": { method: "PUT", path: "/pets/{pet_id}/dna", auth: "required", csrf: true, idempotency: false },
  "pet_facts": { method: "GET", path: "/pets/{pet_id}/facts", auth: "required", csrf: false, idempotency: false },
  "save_pet_facts": { method: "PUT", path: "/pets/{pet_id}/facts", auth: "required", csrf: true, idempotency: true },
  "follow": { method: "POST", path: "/pets/{pet_id}/follow", auth: "required", csrf: true, idempotency: false },
  "followers": { method: "GET", path: "/pets/{pet_id}/followers", auth: "required", csrf: false, idempotency: false },
  "remove_follower": { method: "DELETE", path: "/pets/{pet_id}/followers/{follower_pet_id}", auth: "required", csrf: true, idempotency: false },
  "pet_friends": { method: "GET", path: "/pets/{pet_id}/friends", auth: "required", csrf: false, idempotency: false },
  "pet_friend": { method: "GET", path: "/pets/{pet_id}/friends/{friend_id}", auth: "required", csrf: false, idempotency: false },
  "home_welcome": { method: "GET", path: "/pets/{pet_id}/home-welcome", auth: "required", csrf: false, idempotency: false },
  "id_photo_regenerate": { method: "POST", path: "/pets/{pet_id}/id-photo/regenerate", auth: "required", csrf: true, idempotency: true },
  "list_limits": { method: "GET", path: "/pets/{pet_id}/interaction-limits", auth: "required", csrf: false, idempotency: false },
  "submit_limit": { method: "POST", path: "/pets/{pet_id}/interaction-limits", auth: "required", csrf: true, idempotency: true },
  "confirm_limit": { method: "POST", path: "/pets/{pet_id}/interaction-limits/{limit_id}/confirm", auth: "required", csrf: true, idempotency: true },
  "reject_limit": { method: "POST", path: "/pets/{pet_id}/interaction-limits/{limit_id}/reject", auth: "required", csrf: true, idempotency: true },
  "revise_limit": { method: "POST", path: "/pets/{pet_id}/interaction-limits/{limit_id}/revise", auth: "required", csrf: true, idempotency: true },
  "withdraw_limit": { method: "POST", path: "/pets/{pet_id}/interaction-limits/{limit_id}/withdraw", auth: "required", csrf: true, idempotency: true },
  "pet_motion": { method: "GET", path: "/pets/{pet_id}/motion", auth: "required", csrf: false, idempotency: false },
  "pet_chats": { method: "GET", path: "/pets/{pet_id}/pet-chats", auth: "required", csrf: false, idempotency: false },
  "pet_chat": { method: "GET", path: "/pets/{pet_id}/pet-chats/{thread_id}", auth: "required", csrf: false, idempotency: false },
  "add_pet_photo": { method: "PUT", path: "/pets/{pet_id}/photo", auth: "required", csrf: true, idempotency: true },
  "photo_request": { method: "POST", path: "/pets/{pet_id}/photo-request", auth: "required", csrf: true, idempotency: true },
  "photo_requests": { method: "GET", path: "/pets/{pet_id}/photo-requests", auth: "required", csrf: false, idempotency: false },
  "retry_photo_request": { method: "POST", path: "/pets/{pet_id}/photo-requests/{request_id}/retry-image", auth: "required", csrf: true, idempotency: false },
  "come_home": { method: "POST", path: "/pets/{pet_id}/plan-requests", auth: "required", csrf: true, idempotency: true },
  "current_come_home": { method: "GET", path: "/pets/{pet_id}/plan-requests/current", auth: "required", csrf: false, idempotency: false },
  "cancel_come_home": { method: "POST", path: "/pets/{pet_id}/plan-requests/{request_id}/cancel", auth: "required", csrf: true, idempotency: true },
  "pet_posts": { method: "GET", path: "/pets/{pet_id}/posts", auth: "required", csrf: false, idempotency: false },
  "pet_public_profile": { method: "GET", path: "/pets/{pet_id}/profile", auth: "required", csrf: false, idempotency: false },
  "read_relationship": { method: "GET", path: "/pets/{pet_id}/relationship", auth: "required", csrf: false, idempotency: false },
  "save_relationship": { method: "PUT", path: "/pets/{pet_id}/relationship", auth: "required", csrf: true, idempotency: false },
  "pet_social_prefs": { method: "GET", path: "/pets/{pet_id}/social-prefs", auth: "required", csrf: false, idempotency: false },
  "save_pet_social_prefs": { method: "PUT", path: "/pets/{pet_id}/social-prefs", auth: "required", csrf: true, idempotency: true },
  "teach_journal": { method: "GET", path: "/pets/{pet_id}/teach/journal", auth: "required", csrf: false, idempotency: false },
  "teach_orders_of_pet": { method: "GET", path: "/pets/{pet_id}/teach/orders", auth: "required", csrf: false, idempotency: false },
  "create_teach_order": { method: "POST", path: "/pets/{pet_id}/teach/orders", auth: "required", csrf: true, idempotency: true },
  "save_touch_preference": { method: "POST", path: "/pets/{pet_id}/touch-preferences", auth: "required", csrf: true, idempotency: true },
  "world_body_view": { method: "GET", path: "/pets/{pet_id}/world-body", auth: "required", csrf: false, idempotency: false },
  "world_body_preference": { method: "PUT", path: "/pets/{pet_id}/world-body/preference", auth: "required", csrf: true, idempotency: true },
  "world_body_propose": { method: "POST", path: "/pets/{pet_id}/world-body/requests", auth: "required", csrf: true, idempotency: true },
  "world_body_cancel": { method: "POST", path: "/pets/{pet_id}/world-body/requests/{request_id}/cancel", auth: "required", csrf: true, idempotency: true },
  "remove_post": { method: "DELETE", path: "/posts/{post_id}", auth: "required", csrf: true, idempotency: false },
  "get_post": { method: "GET", path: "/posts/{post_id}", auth: "required", csrf: false, idempotency: false },
  "post_comments": { method: "GET", path: "/posts/{post_id}/comments", auth: "required", csrf: false, idempotency: false },
  "comment": { method: "POST", path: "/posts/{post_id}/comments", auth: "required", csrf: true, idempotency: true },
  "react": { method: "POST", path: "/posts/{post_id}/reactions", auth: "required", csrf: true, idempotency: true },
  "public_identity_official": { method: "GET", path: "/public/identity/{pet_id}/official/{revision}", auth: "optional", csrf: false, idempotency: false },
  "public_pet_photo": { method: "GET", path: "/public/media/pets/{pet_id}/photo", auth: "public", csrf: false, idempotency: false },
  "public_postcard": { method: "GET", path: "/public/media/postcards/{photo_id}", auth: "public", csrf: false, idempotency: false },
  "public_pet": { method: "GET", path: "/public/pets/{pet_id}", auth: "optional", csrf: false, idempotency: false },
  "public_pet_posts": { method: "GET", path: "/public/pets/{pet_id}/posts", auth: "public", csrf: false, idempotency: false },
  "public_residents": { method: "GET", path: "/public/residents", auth: "public", csrf: false, idempotency: false },
  "public_resident_life_photo": { method: "GET", path: "/public/residents/{pet_id}/life-photos/{media_id}", auth: "public", csrf: false, idempotency: false },
  "public_resident_timeline": { method: "GET", path: "/public/residents/{pet_id}/timeline", auth: "public", csrf: false, idempotency: false },
  "public_world": { method: "GET", path: "/public/world", auth: "public", csrf: false, idempotency: false },
  "public_world_feed": { method: "GET", path: "/public/world/feed", auth: "public", csrf: false, idempotency: false },
  "public_world_residents": { method: "GET", path: "/public/world/residents", auth: "public", csrf: false, idempotency: false },
  "confirm_notes": { method: "POST", path: "/reception/confirmations", auth: "required", csrf: true, idempotency: true },
  "start_reception": { method: "POST", path: "/reception/sessions", auth: "required", csrf: true, idempotency: true },
  "get_reception": { method: "GET", path: "/reception/sessions/{session_id}", auth: "required", csrf: false, idempotency: false },
  "skip_reception": { method: "POST", path: "/reception/sessions/{session_id}/skip", auth: "required", csrf: true, idempotency: false },
  "add_turn": { method: "POST", path: "/reception/sessions/{session_id}/turns", auth: "required", csrf: true, idempotency: true },
  "report": { method: "POST", path: "/reports", auth: "required", csrf: true, idempotency: false },
  "my_reports": { method: "GET", path: "/reports/mine", auth: "required", csrf: false, idempotency: false },
  "read_session": { method: "GET", path: "/session", auth: "optional", csrf: false, idempotency: false },
  "read_settings": { method: "GET", path: "/settings", auth: "required", csrf: false, idempotency: false },
  "update_settings": { method: "PATCH", path: "/settings", auth: "required", csrf: true, idempotency: false },
  "grant": { method: "POST", path: "/social-media/grants", auth: "required", csrf: true, idempotency: false },
  "operation": { method: "GET", path: "/social-media/operations/{operation_id}", auth: "required", csrf: false, idempotency: false },
  "settings": { method: "GET", path: "/social-media/pets/{pet_id}/settings", auth: "required", csrf: false, idempotency: false },
  "download": { method: "GET", path: "/social-media/posts/{post_id}/bindings/{binding_id}", auth: "optional", csrf: false, idempotency: false },
  "unpublish": { method: "POST", path: "/social-media/posts/{post_id}/media/{media_id}/revocation", auth: "required", csrf: true, idempotency: false },
  "revoke": { method: "POST", path: "/social-media/revocations", auth: "required", csrf: true, idempotency: false },
  "teach_entitlement": { method: "GET", path: "/teach/entitlement", auth: "required", csrf: false, idempotency: false },
  "delete_teach_motion": { method: "DELETE", path: "/teach/orders/{order_id}", auth: "required", csrf: true, idempotency: true },
  "teach_order": { method: "GET", path: "/teach/orders/{order_id}", auth: "required", csrf: false, idempotency: false },
  "edit_teach_draft": { method: "PUT", path: "/teach/orders/{order_id}", auth: "required", csrf: true, idempotency: false },
  "adjust_teach_motion": { method: "POST", path: "/teach/orders/{order_id}/adjust", auth: "required", csrf: true, idempotency: true },
  "answer_teach_questions": { method: "POST", path: "/teach/orders/{order_id}/answers", auth: "required", csrf: true, idempotency: false },
  "cancel_teach_order": { method: "POST", path: "/teach/orders/{order_id}/cancel", auth: "required", csrf: true, idempotency: true },
  "confirm_teach_order": { method: "POST", path: "/teach/orders/{order_id}/confirm", auth: "required", csrf: true, idempotency: true },
  "disable_teach_motion": { method: "POST", path: "/teach/orders/{order_id}/disable", auth: "required", csrf: true, idempotency: true },
  "enable_teach_motion": { method: "POST", path: "/teach/orders/{order_id}/enable", auth: "required", csrf: true, idempotency: true },
  "upload_teach_reference": { method: "POST", path: "/teach/orders/{order_id}/references", auth: "required", csrf: true, idempotency: true },
  "delete_teach_reference": { method: "DELETE", path: "/teach/orders/{order_id}/references/{media_id}", auth: "required", csrf: true, idempotency: false },
  "edit_teach_spec": { method: "PUT", path: "/teach/orders/{order_id}/spec", auth: "required", csrf: true, idempotency: false },
  "understand_teach_draft": { method: "POST", path: "/teach/orders/{order_id}/understand", auth: "required", csrf: true, idempotency: false },
  "life_timeline": { method: "GET", path: "/timeline", auth: "required", csrf: false, idempotency: false },
  "read_longing": { method: "GET", path: "/travel/longing", auth: "required", csrf: false, idempotency: false },
  "read_memories": { method: "GET", path: "/travel/memories", auth: "required", csrf: false, idempotency: false },
  "read_plan": { method: "GET", path: "/travel/plans/{plan_id}", auth: "required", csrf: false, idempotency: false },
  "redraw_journal": { method: "POST", path: "/travel/plans/{plan_id}/journal/redraw", auth: "required", csrf: true, idempotency: true },
  "retry_research": { method: "POST", path: "/travel/plans/{plan_id}/research/retry", auth: "required", csrf: true, idempotency: true },
  "read_wish": { method: "GET", path: "/travel/wish", auth: "required", csrf: false, idempotency: false },
  "cancel_wish": { method: "POST", path: "/travel/wish/{wish_id}/cancel", auth: "required", csrf: true, idempotency: true },
  "get_visit": { method: "GET", path: "/visits/{visit_id}", auth: "required", csrf: false, idempotency: false },
  "visit_action": { method: "POST", path: "/visits/{visit_id}/actions", auth: "required", csrf: true, idempotency: true },
  "visit_choice": { method: "POST", path: "/visits/{visit_id}/choice", auth: "required", csrf: true, idempotency: true },
  "visit_choice_result": { method: "GET", path: "/visits/{visit_id}/choice/result", auth: "required", csrf: false, idempotency: true },
  "world_self_layer": { method: "GET", path: "/world/self-layer", auth: "required", csrf: false, idempotency: false },
  "world_state": { method: "GET", path: "/world/state", auth: "required", csrf: false, idempotency: false },
} as const satisfies Record<string, WebEndpoint>;
export type WebEndpointName = keyof typeof WEB_ENDPOINTS;
